<template>
  <div class="kalem">
    <imagefiledialog ref="imagefiledialog"></imagefiledialog>
    <loadingcomp mesaj="Voucher" v-model="loadingStatus"></loadingcomp>
    <snackbarcomp v-bind:mesaj="mesaj" v-model="snackbar"></snackbarcomp>
    <yetkidialog ref="yetkidialog"></yetkidialog>

    <v-toolbar class="baslik" size="120px" dark color="info">
      <v-toolbar-title class="baslikfont">Voucher</v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>

    <v-card color="grey lighten-4" flat>
      <v-layout row wrap>
        <v-flex xs12 md12 sm12>
          <v-layout row wrap>
            <v-flex pa-2 xs12 sm12>
              <v-card>
                <v-layout row wrap>
                  <v-flex xs12 pa-2 sm12 md12>
                    <v-layout row wrap>
                      <v-flex xs12 sm3 md12>
                        <v-layout row wrap class="pl-1 pr-1 project overdue">
                          <v-flex pa-2 md12 xs12 sm12>
                            <v-layout row wrap>
                             
                              <v-flex md4 xs12 sm12>
                              <v-autocomplete
                              @change="voucherLoad2()" 
                              clearable
                              v-model="secilenVoucherObje"
                              :items="itemsVoucherSaticilar"
                              :label="$t('Select-Voucher')"
                              item-value="name"
      item-text="name"
      return-object
                              append-icon="search"
                              hide-details
                              
                            >
                              <template slot="item" slot-scope="data">
                                <v-icon >{{ data.item.icon }} </v-icon>
                              
                                {{ data.item.name }}
                              </template>
                            </v-autocomplete>

                              </v-flex>
                                <v-flex md2 xs12 sm12>
                                   <v-select :label="$t('Language-select')" :items="locales" hide-details="" v-model="locale" item-text="title" item-value="locale"></v-select>
                              </v-flex>
                                  <v-flex md6 xs12 sm12>
                                    <v-layout row wrap>
                                      <v-flex shrink>
                                        <v-checkbox :label="$t('Print-different-vouchers-for-each-sales-item')" @change="getVoucher()" v-model="KalemDetay"></v-checkbox>
                                      </v-flex>
                                      <v-flex shrink class="pl-2">
                                        <v-checkbox v-model="IsimleriAyir" :label="$t('Separate-Names')" @change="getVoucher()"></v-checkbox>
                                      </v-flex>
                                    </v-layout>
                              </v-flex>

                              <v-flex
                                v-if="supportsVoucherFieldSelection"
                                md12
                                xs12
                                sm12
                                class="pt-2"
                              >
                                <v-layout row wrap align-center>
                                  <v-flex md6 xs12 sm12>
                                    <v-autocomplete
                                      v-model="selectedVoucherFields"
                                      :items="voucherFieldItems"
                                      item-text="text"
                                      item-value="value"
                                      :label="voucherFieldSelectLabel"
                                      multiple
                                      chips
                                      deletable-chips
                                      clearable
                                      hide-details
                                      :disabled="!selectedSalerType"
                                      @change="saveVoucherFieldSelection"
                                    >
                                      <template slot="selection" slot-scope="data">
                                        <v-chip v-if="data.index < 2" small>
                                          {{ data.item.text }}
                                        </v-chip>
                                        <span
                                          v-if="data.index === 2"
                                          class="grey--text caption"
                                        >
                                          +{{ selectedVoucherFields.length - 2 }}
                                        </span>
                                      </template>
                                    </v-autocomplete>
                                  </v-flex>

                                  <v-flex md1 xs6 sm6 class="pl-1">
                                    <v-btn
                                      block
                                      small
                                      flat
                                      color="info"
                                      :disabled="!selectedSalerType"
                                      @click="selectAllVoucherFields"
                                    >
                                      {{ voucherSelectAllLabel }}
                                    </v-btn>
                                  </v-flex>

                                  <v-flex md1 xs6 sm6 class="pl-1">
                                    <v-btn
                                      block
                                      small
                                      flat
                                      color="warning"
                                      :disabled="!selectedSalerType"
                                      @click="clearVoucherFields"
                                    >
                                      {{ voucherClearLabel }}
                                    </v-btn>
                                  </v-flex>

                                  <v-flex md4 xs12 sm12 class="pl-1">
                                    <v-text-field
                                      v-model="voucherCustomCompanyName"
                                      :label="voucherCompanyNameLabel"
                                      clearable
                                      hide-details
                                    ></v-text-field>
                                  </v-flex>
                                </v-layout>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-card>
            </v-flex>

            <v-flex xs12 pa-2 sm10 v-if="locale == 'tr' && vouchergoster">
              <v-card flat>
                <v-layout justify-end row wrap>
                  <v-flex xs12 pa-3 sm12>
                    <div id="printJS-form" class="voucher-print-container">
                      <table
                        style="page-break-after: always"
                        v-for="item in selectedVoucherItems.Sayfalar"
                        :key="item.id"
                        width="100%"
                      >
                        <thead
                          v-if="item.Satici.Kod.trim() == secilenSaticiKod.trim()"
                          class="print"
                        >
                          <tr>
                            <td colspan="8">
                              <table width="100%">
                                <tr
                                  colspan="8"
                                  align="center"
                                  style="
                                    padding-top: 20px;
                                    padding-bottom: 20px;
                                  "
                                >
                                  <td v-show="(showVoucherField('upperLogo'))"
                                    align="left"
                                    style="
                                      width: 100%;
                                      vertical-align: top;
                                      padding-top: 10px;
                                      padding-bottom: 10px;
                                    "
                                    id="imgUst"
                                  ></td>
                                </tr>
                              </table>
                            </td>
                          </tr>
                          <tr>
                            <td v-show="(showVoucherField('voucherTitle'))"
                              colspan="10"
                              align="center"
                              style="padding-top: 10px; padding-bottom: 10px"
                            >
                              <span v-if="isOtel" class="black--text title">
                                OTEL VOUCHER </span
                              >
                               <span v-if="isAcente" class="black--text title">
                                ACENTE VOUCHER </span
                              >
                              <span v-if="isRestaurant" class="black--text title">
                                RESTAURANT VOUCHER </span
                              >
                              <span v-if="isTransfer" class="black--text title">
                                TRANSFER VOUCHER </span
                              >
                               <span v-if="isRentACar" class="black--text title">
                                RENT A CAR VOUCHER </span
                              >
                              

                            </td>
                          </tr>
                          <tr align="left">
                            <td colspan="10">
                              <table width="100%">
                                <tr v-show="(showAnyVoucherField(['supplierName', 'supplierPhone']))"
                                  colspan="8"
                                  align="center"
                                  style="
                                    padding-top: 20px;
                                    padding-bottom: 20px;
                                  "
                                >
                                  <td v-show="(showVoucherField('supplierName'))"
                                    align="left"
                                    style="
                                      width: 20%;
                                      vertical-align: top;
                                      padding-top: 10px;
                                      padding-bottom: 10px;
                                    "
                                  >
                                  <span v-if="isOtel" >
                                {{$t('Hotel-Name')}} : </span>
                                <span v-else >
                                  {{$t('Firm-Name')}}  </span>
                                  
                                  </td>

                                  <td v-show="(showVoucherField('supplierName'))" style="width: 30%">
                                    {{ item.Satici.Isim }}
                                  </td>

                                  <td v-show="(showVoucherField('supplierPhone'))" style="width: 20%">{{$t('Telephone')}}:</td>

                                  <td v-show="(showVoucherField('supplierPhone'))" style="width: 30%" align="left">
                                    {{ item.Satici.Tel1 }} /
                                    {{ item.Satici.Tel2 }}
                                  </td>

                                
                                </tr>
  
                              </table>
                            </td>
                          </tr>
                          <tr align="left">
                            <td colspan="10">
                              <table width="100%">
                                <tr v-show="(showAnyVoucherField(['supplierAddress', 'supplierEmail']))"
                                  colspan="8"
                                  align="center"
                                  style="
                                    padding-top: 20px;
                                    padding-bottom: 20px;
                                  "
                                >
                                  <td v-show="(showVoucherField('supplierAddress'))"
                                    align="left"
                                    style="
                                      width: 20%;
                                      vertical-align: top;
                                      padding-top: 10px;
                                      padding-bottom: 10px;
                                    "
                                  >
                                  <span v-if="isOtel" >
                               {{$t('Hotel-Adress')}}: </span>
                                <span v-else >
                                  Firma Adresi: </span>
                                  </td>
                                  <td v-show="(showVoucherField('supplierAddress'))" style="width: 30%">
                                    {{ item.Satici.Adres }} &nbsp;
                                    {{ item.Satici.Yer }} &nbsp;
                                    {{ item.Satici.Sehir }} &nbsp;
                                    {{ item.Satici.Ulke }}
                                  </td>
                                  <td v-show="(showVoucherField('supplierEmail'))" style="width: 20%">
                                    Email
                                  </td>
                                  <td v-show="(showVoucherField('supplierEmail'))" style="width: 30%" align="left">
                                    {{ item.Satici.Email || item.Satici.EMail || '-' }}
                                  </td>
                                </tr>
   
                              </table>
                            </td>
                          </tr>
                          <tr align="left">
                            <td colspan="10">
                              <table width="100%">
                                <tr v-show="(showAnyVoucherField(['counterReservationCode', 'bookedByPhone']))"
                                  colspan="8"
                                  align="center"
                                  style="
                                    padding-top: 20px;
                                    padding-bottom: 20px;
                                  "
                                >
                                  <td v-show="(showVoucherField('counterReservationCode'))"
                                    align="left"
                                    style="
                                      width: 20%;
                                      vertical-align: top;
                                      padding-top: 10px;
                                      padding-bottom: 10px;
                                    "
                                  >
                                   Karşı Rez. Kod:
                                  </td>
                                  <td v-show="(showVoucherField('counterReservationCode'))" style="width: 30%">
                                    {{ item.KarsiRezKodu }} 
                                  </td>
                                  <td v-show="(showVoucherField('bookedByPhone'))" style="width: 20%">
                                    Rez. Yapan Telefon:
                                  </td>
                                  <td v-show="(showVoucherField('bookedByPhone'))" style="width: 30%" align="left">
                                    {{ item.RezervasyonYapan.Telefon }} 
                                  </td>
                                </tr>
   
                              </table>
                            </td>
                          </tr>
                         
                          <tr>
                            <tr>
                                  <td colspan="8">
                                    <v-divider></v-divider>
                                  </td>
                            </tr>
                            <td v-show="(showAnyVoucherField(['roomOrder', 'pnrNo', 'personType', 'passengerName', 'checkInDate', 'checkOutDate', 'nightCount', 'boardRoomType']))" v-if="isOtel" colspan="8">
                              <table width="100%">
                                <tr
                                  colspan="8"
                                  align="center"
                                  style="
                                    padding-top: 20px;
                                    padding-bottom: 20px;
                                    
                                  "
                                >
                                  <td v-show="(showVoucherField('roomOrder'))" style="width: 5%">
                                    <span class="subheading">
                                      Oda Sıra</span
                                    >
                                  </td>
                                  <td v-show="(showVoucherField('pnrNo'))" style="width: 10%">
                                    <span class="subheading">
                                      Pnr No</span
                                    >
                                  </td>
                                  <td v-show="(showVoucherField('personType'))" style="width: 10%">
                                    <span class="subheading">
                                      Kişi Tip </span
                                    >
                                  </td>
                                  <td v-show="(showVoucherField('passengerName'))" style="width: 20%">
                                    <span class="subheading">
                                      İsim </span
                                    >
                                  </td>
                                  <td v-show="(showVoucherField('checkInDate'))" style="width: 15%">
                                    <span class="subheading">
                                      {{$t('Check-in-Date')}}</span
                                    >
                                  </td>
                                  <td v-show="(showVoucherField('checkOutDate'))" style="width: 15%">
                                    <span class="subheading">
                                    {{ $t('Check-out-Date') }} </span
                                    >
                                  </td>
                                  <td v-show="(showVoucherField('nightCount'))" style="width: 5%">
                                    <span class="subheading">
                                      Gece </span
                                    >
                                  </td>
                                  <td v-show="(showVoucherField('boardRoomType'))" style="width: 20%">
                                    <span class="subheading">
                                      {{'Pansiyon Tipi'}} {{ '/'}} {{$t('Room-Type')}}  </span
                                    >
                                  </td>
                                </tr>
                                <tr>
                                  <td colspan="8">
                                    <v-divider></v-divider>
                                  </td>
                                </tr>
                              </table>
                            </td>
                            <td v-show="(showAnyVoucherField(['passengerName', 'passengerReservationNo', 'nationality', 'passportNumber', 'birthDate']))" v-if="isAcente" colspan="5">
                              <table width="100%">
                                <tr
                                  colspan="8"
                                  align="center"
                                  style="
                                    padding-top: 20px;
                                    padding-bottom: 20px;
                                    
                                  "
                                >
                                  <td v-show="(showVoucherField('passengerName'))" style="width: 20%">
                                    <span class="subheading">
                                      İsim</span
                                    >
                                  </td>
                                  <td v-show="(showVoucherField('passengerReservationNo'))" style="width: 20%">
                                    <span class="subheading">
                                      Rezervasyon</span
                                    >
                                  </td>
                                  <td v-show="(showVoucherField('nationality'))" style="width: 20%">
                                    <span class="subheading">
                                      Uyruk </span
                                    >
                                  </td>
                                  <td v-show="(showVoucherField('passportNumber'))" style="width: 20%">
                                    <span class="subheading">
                                      Pasaport No </span
                                    >
                                  </td>
                                  <td v-show="(showVoucherField('birthDate'))" style="width: 20%">
                                    <span class="subheading">
                                      Doğum Tarihi</span
                                    >
                                  </td>
                                </tr>
                                <tr>
                                  <td colspan="5">
                                    <v-divider></v-divider>
                                  </td>
                                </tr>
                              </table>
                            </td>
                            <td v-show="(showAnyVoucherField(['pax', 'passengerName', 'pnrNo', 'counterReservationCode']))" v-if="isRestaurant" colspan="5">
                              <table width="100%">
                                <tr
                                  colspan="8"
                                  align="center"
                                  style="
                                    padding-top: 20px;
                                    padding-bottom: 20px;
                                    
                                  "
                                >
                                  <td v-show="(showVoucherField('pax'))" style="width: 25%">
                                    <span class="subheading">
                                      Pax</span
                                    >
                                  </td>
                                  <td v-show="(showVoucherField('passengerName'))" style="width: 25%">
                                    <span class="subheading">
                                      İsim</span
                                    >
                                  </td>
                                  <td v-show="(showVoucherField('pnrNo'))" style="width: 25%">
                                    <span class="subheading">
                                      Pnr No </span
                                    >
                                  </td>
                                  <td v-show="(showVoucherField('counterReservationCode'))" style="width: 25%">
                                    <span class="subheading">
                                      Karşı Rez. Kod. </span
                                    >
                                  </td>
                                </tr>
                                <tr>
                                  <td colspan="4">
                                    <v-divider></v-divider>
                                  </td>
                                </tr>
                              </table>
                            </td>

                             <td v-show="(showAnyVoucherField(['passengerName', 'pnrNo', 'nationality', 'passportNumber', 'birthDate']))" v-if="isTransfer" colspan="8">
                              <table width="100%">
                                <tr
                                  colspan="8"
                                  align="center"
                                  style="
                                    padding-top: 20px;
                                    padding-bottom: 20px;
                                    
                                  "
                                >
                                  <td v-show="(showVoucherField('passengerName'))" style="width: 20%">
                                    <span class="subheading">
                                      İsim</span
                                    >
                                  </td>
                                  <td v-show="(showVoucherField('pnrNo'))" style="width: 20%">
                                    <span class="subheading">
                                      Pnr No </span
                                    >
                                  </td>
                                  <td v-show="(showVoucherField('nationality'))" style="width: 20%">
                                    <span class="subheading">
                                      Uyruk </span
                                    >
                                  </td>
                                   <td v-show="(showVoucherField('passportNumber'))" style="width: 20%">
                                    <span class="subheading">
                                      Pasaport No </span
                                    >
                                  </td>
                                    <td v-show="(showVoucherField('birthDate'))" style="width: 20%">
                                    <span class="subheading">
                                      Doğum Tarihi </span
                                    >
                                  </td>
                                </tr>
                                <tr>
                                  <td colspan="8">
                                    <v-divider></v-divider>
                                  </td>
                                </tr>
                              </table>
                            </td>

                            <td v-show="(showAnyVoucherField(['passengerName', 'vehicle', 'vehicleCategory', 'vehicleCount', 'vehicleDay']))" v-if="isRentACar" colspan="8">
                              <table width="100%">
                                <tr
                                  colspan="8"
                                  align="center"
                                  style="
                                    padding-top: 20px;
                                    padding-bottom: 20px;
                                    
                                  "
                                >
                                  <td v-show="(showVoucherField('passengerName'))" style="width: 20%">
                                    <span class="subheading">
                                      İsim</span
                                    >
                                  </td>
                                  <td v-show="(showVoucherField('vehicle'))" style="width: 20%">
                                    <span class="subheading">
                                      Arac </span
                                    >
                                  </td>
                                  <td v-show="(showVoucherField('vehicleCategory'))" style="width: 20%">
                                    <span class="subheading">
                                      Kategori </span
                                    >
                                  </td>
                                   <td v-show="(showVoucherField('vehicleCount'))" style="width: 20%">
                                    <span class="subheading">
                                      Adet </span
                                    >
                                  </td>
                                    <td v-show="(showVoucherField('vehicleDay'))" style="width: 20%">
                                    <span class="subheading">
                                      Gün </span
                                    >
                                  </td>
                                </tr>
                                <tr>
                                  <td colspan="8">
                                    <v-divider></v-divider>
                                  </td>
                                </tr>
                              </table>
                            </td>
                            
                          </tr>

                          <tr v-show="(showAnyVoucherField(['roomOrder', 'pnrNo', 'personType', 'passengerName', 'checkInDate', 'checkOutDate', 'nightCount', 'boardRoomType']))" v-if="isOtel">
                            <td colspan="8">
                              <table
                                v-for="itemoda in item.Odalar"
                                :key="itemoda.Sira"
                                width="100%"
                              >
                                <tr
                                  v-for="itemkisi in itemoda.Kisiler"
                                  :key="itemkisi.adsoyad"
                                  colspan="8"
                                  align="center"
                                  style="
                                    padding-top: 20px;
                                    padding-bottom: 20px;
                                  "
                                >
                                  <td v-show="(showVoucherField('roomOrder'))" style="width: 5%">
                                    <span class="subheading">
                                      {{ itemoda.Sira }}</span
                                    >
                                  </td>
                                  <td v-show="(showVoucherField('pnrNo'))" style="width: 10%">
                                    <span class="subheading"> {{ pnr }}</span>
                                  </td>
                                  <td v-show="(showVoucherField('personType'))" style="width: 10%">
                                    <span class="subheading">
                                      {{ KisiTipToStr(itemkisi.kisiTip) }}
                                    </span>
                                  </td>
                                  <td v-show="(showVoucherField('passengerName'))"
                                    align="center"
                                    style="width: 20%"
                                  >
                                    <span class="subheading">
                                      {{ itemkisi.adSoyad }}</span
                                    >
                                  </td>
                                  <td v-show="(showVoucherField('checkInDate'))" style="width: 15%">
                                    <span class="subheading">
                                      {{ itemoda.Kalem.donem1 | dateformat }}</span
                                    >
                                  </td>
                                  <td v-show="(showVoucherField('checkOutDate'))" style="width: 15%">
                                    <span class="subheading">
                                      {{ itemoda.Kalem.donem2 | dateformat }}</span
                                    >
                                  </td>
                                  <td v-show="(showVoucherField('nightCount'))" style="width: 5%">
                                    <span class="subheading">
                                      {{ gunhesapla(itemoda.Kalem) }}</span
                                    >
                                  </td>
                                  <td v-show="(showVoucherField('boardRoomType'))" style="width: 20%">
                                    <span class="subheading">
                                      {{
                                        PansiyonTipToStr(
                                          itemoda.Kalem.kalemOtel.pansiyon
                                        )
                                      }}  {{ '/'}}  {{
                                        itemoda.Kalem.kalemOtel.odaTipi.isim
                                      }}</span
                                    >
                                  </td>
                                </tr>
                             
                              </table>
                            </td>
                          </tr>

                          <tr v-show="(showAnyVoucherField(['passengerName', 'passengerReservationNo', 'nationality', 'passportNumber', 'birthDate']))" v-if="isAcente">
                            <td colspan="5">
                              <table
                                v-for="itemoda in item.Odalar"
                                :key="itemoda.Sira"
                                width="100%"
                              >
                                <tr
                                  v-for="itemkisi in itemoda.Kisiler"
                                  :key="itemkisi.adsoyad"
                                  colspan="5"
                                  align="center"
                                  style="
                                    padding-top: 20px;
                                    padding-bottom: 20px;
                                  "
                                >
                                  <td v-show="(showVoucherField('passengerName'))" style="width: 20%">
                                    <span class="subheading">
                                      {{ itemkisi.adSoyad }} 
                                      </span>
                                  </td>
                                  <td v-show="(showVoucherField('passengerReservationNo'))" style="width: 20%">
                                    <span class="subheading"> {{ itemkisi.kod }}</span>
                                  </td>
                                  <td v-show="(showVoucherField('nationality'))" style="width: 20%">
                                    <span class="subheading">
                                       {{ itemkisi.ulke }}
                                    </span>
                                  </td>
                                  <td v-show="(showVoucherField('passportNumber'))" style="width: 20%" >
                                    <span class="subheading">
                                      {{ itemkisi.pasaportNo }}</span
                                    >
                                  </td>
                                  <td v-show="(showVoucherField('birthDate'))" style="width: 20%">
                                    <span class="subheading">
                                      {{ formatDate(itemkisi.dogumTarihi) }} </span
                                    >
                                  </td>
                                </tr>
                             
                              </table>
                            </td>
                          </tr>


                           <tr v-show="(showAnyVoucherField(['pax', 'passengerName', 'pnrNo', 'counterReservationCode']))" v-if="isRestaurant">
                            <td colspan="4"  >
                              <table
                                v-for="itemoda in item.Odalar"
                                :key="itemoda.Sira"
                                width="100%"
                              >
                                <tr
                                  v-for="itemkisi in itemoda.Kisiler"
                                  :key="itemkisi.adsoyad"
                                  colspan="5"
                                  align="center"
                                  style="
                                    padding-top: 20px;
                                    padding-bottom: 20px;
                                  "
                                >
                                  <td v-show="(showVoucherField('pax'))" style="width: 25%">
                                    <span class="subheading">
                                      {{ itemkisi.Pax }} 
                                      </span>
                                  </td>
                                  <td v-show="(showVoucherField('passengerName'))" style="width: 25%">
                                    <span class="subheading"> {{ itemkisi.adSoyad }}</span>
                                  </td>
                                  <td v-show="(showVoucherField('pnrNo'))" style="width: 25%">
                                    <span class="subheading">
                                      {{ pnr }}    
                                    </span>
                                  </td>
                                  <td v-show="(showVoucherField('counterReservationCode'))" style="width: 25%" >
                                    <span class="subheading">
                                      {{ itemoda.KarsiRezKodu }}</span
                                    >
                                  </td>
                                </tr>
                             
                              </table>
                            </td>
                          </tr> 

                         <tr v-show="(showAnyVoucherField(['passengerName', 'pnrNo', 'nationality', 'passportNumber', 'birthDate']))" v-if="isTransfer">
                            <td colspan="8">
                              <table
                                v-for="itemoda in item.Odalar"
                                :key="itemoda.Sira"
                                width="100%"
                              >
                                <tr
                                  v-for="itemkisi in itemoda.Kisiler"
                                  :key="itemkisi.adsoyad"
                                  colspan="8"
                                  align="center"
                                  style="
                                    padding-top: 20px;
                                    padding-bottom: 20px;
                                  "
                                >
                                  <td v-show="(showVoucherField('passengerName'))" style="width: 20%">
                                    <span class="subheading">
                                      {{ itemkisi.adSoyad }} 
                                      </span>
                                  </td>
                                  <td v-show="(showVoucherField('pnrNo'))" style="width: 20%">
                                    <span class="subheading"> {{ pnr }}</span>
                                  </td>
                                  <td v-show="(showVoucherField('nationality'))" style="width: 20%">
                                    <span class="subheading">
                                      {{itemkisi.ulke}}  
                                    </span>
                                  </td>
                                  <td v-show="(showVoucherField('passportNumber'))" style="width: 20%" >
                                    <span class="subheading">
                                      {{itemkisi.pasaportNo}}
                                    </span>
                                  </td>
                                  <td v-show="(showVoucherField('birthDate'))" style="width: 20%" >
                                    <span class="subheading">
                                      {{ formatDate(itemkisi.dogumTarihi)}}
                                    </span>
                                  </td>
                                </tr>
                             
                              </table>
                            </td>
                          </tr> 

                          <tr v-show="(showAnyVoucherField(['passengerName', 'vehicle', 'vehicleCategory', 'vehicleCount', 'vehicleDay']))" v-if="isRentACar">
                            <td colspan="8">
                              <table
                                v-for="itemoda in item.Odalar"
                                :key="itemoda.Sira"
                                width="100%"
                              >
                                <tr
                                  v-for="itemkisi in itemoda.Kisiler"
                                  :key="itemkisi.adsoyad"
                                  colspan="8"
                                  align="center"
                                  style="
                                    padding-top: 20px;
                                    padding-bottom: 20px;
                                  "
                                >
                                  <td v-show="(showVoucherField('passengerName'))" style="width: 20%">
                                    <span class="subheading">
                                      {{ itemkisi.adSoyad }} 
                                      </span>
                                  </td>
                                  <td v-show="(showVoucherField('vehicle'))" style="width: 20%">
                                    <span class="subheading"> {{itemoda.Kalem.baseKalem.arac}} </span>
                                  </td>
                                  <td v-show="(showVoucherField('vehicleCategory'))" style="width: 20%">
                                    <span class="subheading">
                                      {{itemoda.Kalem.baseKalem.kategori}}
                                    </span>
                                  </td>
                                  <td v-show="(showVoucherField('vehicleCount'))" style="width: 20%" >
                                    <span class="subheading">
                                      {{itemoda.Kalem.baseKalem.aracAdet}} 
                                    </span>
                                  </td>
                                  <td v-show="(showVoucherField('vehicleDay'))" style="width: 20%" >
                                    <span class="subheading">
                                      {{itemoda.Kalem.baseKalem.gun}} 
                                    </span>
                                  </td>
                                </tr>
                             
                              </table>
                            </td>
                          </tr> 

                          <tr>
                            <td v-show="(showAnyVoucherField(['totalPax', 'totalRoom']))" colspan="4" v-if="isOtel">
                              <table align="left" width="100%">
                                <tr
                                  align="left"
                                  style="
                                    padding-top: 15px;
                                    padding-bottom: 15px;
                                  "
                                >
                                  <td v-show="(showVoucherField('totalPax'))" colspan="2">
                                    <span class="subheading">
                                      Toplam Pax : {{ item.ToplamPax }}</span
                                    >
                                  </td>
                                </tr>
                                <tr
                                  colspan="8"
                                  align="left"
                                  style="
                                    padding-top: 20px;
                                    padding-bottom: 20px;
                                  "
                                >
                                  <td v-show="(showVoucherField('totalRoom'))" colspan="2">
                                    <span class="subheading">
                                      Toplam Oda : {{ toplamOdaText }}
                                    </span>
                                  </td>
                                </tr>
                              </table>
                            </td>
                            <td v-show="(showAnyVoucherField(['totalPax', 'tourType', 'meetingDate', 'tourKind', 'meetingTime', 'tourDuration', 'meetingPlace', 'tourGuide', 'shipName', 'entrancesIncluded', 'returnInfo', 'mealsIncluded']))" colspan="5" v-if="isAcente">
                              <table align="left" width="100%">
                                <tr
                                  style="
                                    padding-top: 15px;
                                    padding-bottom: 15px;
                                  "
                                >
                                  <td v-show="(showVoucherField('totalPax'))" colspan="2">
                                    <span class="subheading">
                                      Toplam Pax : {{ item.ToplamPax }}</span
                                    >
                                  </td>
                                  <td v-show="(showVoucherField('tourType'))" colspan="2">
                                    <span class="subheading">
                                      Tur Tipi : {{ getTurTipi(item.Odalar[0].Kalem.kalemAcente.TurTipi) }} </span
                                    >
                                  </td>
                                </tr>
                                 <tr
                                  style="
                                    padding-top: 15px;
                                    padding-bottom: 15px;
                                  "
                                >
                                  <td v-show="(showVoucherField('meetingDate'))" colspan="2">
                                    <span class="subheading">
                                      Bulusma Tarihi : {{ item.Odalar[0].Kalem.kalemAcente.BulusmaTarihi | dateformat }} </span
                                    >
                                  </td>
                                  <td v-show="(showVoucherField('tourKind'))" colspan="2">
                                    <span class="subheading">
                                      Tur Türü : {{ getTurTuru(item.Odalar[0].Kalem.kalemAcente.TurTuru) }}</span
                                    >
                                  </td>
                                </tr>
                                <tr
                                  style="
                                    padding-top: 15px;
                                    padding-bottom: 15px;
                                  "
                                >
                                  <td v-show="(showVoucherField('meetingTime'))" colspan="2">
                                    <span class="subheading">
                                      Bulusma Saati : {{ item.Odalar[0].Kalem.kalemAcente.Saat | timeformat }} </span
                                    >
                                  </td>
                                  <td v-show="(showVoucherField('tourDuration'))" colspan="2">
                                    <span class="subheading">
                                      Tur Süresi :  </span 
                                    >
                                    <!-- {{ getTurTuru(item.Odalar[0].Kalem.kalemAcente.Tip) }} -->
                                  </td>
                                </tr>
                                <tr
                                  style="
                                    padding-top: 15px;
                                    padding-bottom: 15px;
                                  "
                                >
                                  <td v-show="(showVoucherField('meetingPlace'))" colspan="2">
                                    <span class="subheading">
                                      Bulusma Yeri : {{ item.Odalar[0].Kalem.kalemAcente.BulusmaYeri }}</span
                                    >
                                  </td>
                                  <td v-show="(showVoucherField('tourGuide'))" colspan="2">
                                    <span class="subheading">
                                      Tur Rehberi : {{ item.Odalar[0].Kalem.kalemAcente.Rehber.isim }} </span
                                    >
                                  </td>
                                </tr>
                                <tr
                                  style="
                                    padding-top: 15px;
                                    padding-bottom: 15px;
                                  "
                                >
                                  <td v-show="(showVoucherField('shipName'))" colspan="2">
                                    <span class="subheading">
                                      Gemi Adı : {{ item.Odalar[0].Kalem.kalemAcente.Gemi.isim }}</span
                                    >
                                  </td>
                                  <td v-show="(showVoucherField('entrancesIncluded'))" colspan="2">
                                    <span class="subheading">
                                      Girişler Dahil : {{ checkItemsList(item.Odalar[0].Kalem.kalemAcente.Girisler)  }}  </span
                                    >
                                  </td>
                                </tr>
                                <tr
                                  style="
                                    padding-top: 15px;
                                    padding-bottom: 15px;
                                  "
                                >
                                  <td v-show="(showVoucherField('returnInfo'))" colspan="2" style="max-width:100px;">
                                    <span class="subheading">
                                      Dönüş Bilgileri : {{ item.Odalar[0].Kalem.kalemAcente.DonusBilgisi }}</span
                                    >
                                  </td>
                                  <td v-show="(showVoucherField('mealsIncluded'))" colspan="2">
                                    <span class="subheading">
                                      Yemekler Dahil : {{ checkItemsList(item.Odalar[0].Kalem.kalemAcente.OgleYemegi) }}  </span
                                    >
                                  </td>
                                </tr>
                              
                              </table>
                            </td>
                            <td v-show="(showAnyVoucherField(['totalPax', 'restaurantMenu']))" colspan="4" v-if="isRestaurant">
                              <table align="left" width="100%">
                                <tr
                                  align="left"
                                  style="
                                    padding-top: 15px;
                                    padding-bottom: 15px;
                                  "
                                >
                                  <td v-show="(showVoucherField('totalPax'))" colspan="4">
                                    <span class="subheading">
                                      Toplam Pax : {{ item.ToplamPax }}</span
                                    >
                                  </td>
                                </tr>
                                <tr v-show="(showVoucherField('restaurantMenu'))"
                                  colspan="4"
                                  align="left"
                                  style="
                                    padding-top: 20px;
                                    padding-bottom: 20px;
                                  "
                                  v-for="itemMenu in item.Satici.stRestaurant.Menu"
                                  :key="itemMenu.Kod"
                                >
                                  <td colspan="4"       
                                  >
                                    <span class="subheading">
                                      {{ itemMenu.Kod }}  : {{ itemMenu.Menu }}
                                    </span>
                                  </td>
                                </tr>
                         
                              </table>
                            </td>
                            <td v-show="(showAnyVoucherField(['departureDate', 'departureTime', 'arrivalDeparture', 'flightNumber', 'flightTime', 'departurePlace', 'destination', 'vehicle']))" colspan="8" v-if="isTransfer">
                             
                              <table align="left" width="100%">
                                   <tr>
                                  <td colspan="8">
                                    <v-divider></v-divider>
                                  </td>
                                </tr>
                                  <tr>
                            <td v-show="(showAnyVoucherField(['departureDate', 'departureTime', 'arrivalDeparture', 'flightNumber', 'flightTime', 'departurePlace', 'destination', 'vehicle']))" v-if="isTransfer" colspan="8">
                              <table width="100%">
                                <tr
                                  colspan="8"
                                  align="center"
                                  style="
                                    padding-top: 20px;
                                    padding-bottom: 20px;
                                    
                                  "
                                >
                                  <td v-show="(showVoucherField('departureDate'))" style="width: 15%">
                                    <span class="subheading">
                                      Hareket Tarihi</span
                                    >
                                  </td>
                                  <td v-show="(showVoucherField('departureTime'))" style="width: 10%">
                                    <span class="subheading">
                                      Hareket Saati </span
                                    >
                                  </td>
                                  <td v-show="(showVoucherField('arrivalDeparture'))" style="width: 5%">
                                    <span class="subheading">
                                      A/D </span
                                    >
                                  </td>
                                   <td v-show="(showVoucherField('flightNumber'))" style="width: 10%">
                                    <span class="subheading">
                                      Uçuş No </span
                                    >
                                  </td>
                                    <td v-show="(showVoucherField('flightTime'))" style="width: 10%">
                                    <span class="subheading">
                                      Uçuş Saati </span
                                    >
                                  </td>
                                   <td v-show="(showVoucherField('departurePlace'))" style="width: 15%">
                                    <span class="subheading">
                                      Hareket Yeri </span
                                    >
                                  </td>
                                   <td v-show="(showVoucherField('destination'))" style="width: 15%">
                                    <span class="subheading">
                                      Varış Yeri </span
                                    >
                                  </td>
                                   <td v-show="(showVoucherField('vehicle'))" style="width: 20%">
                                    <span class="subheading">
                                      Araç </span
                                    >
                                  </td>
                                </tr>
                                <tr>
                                  <td colspan="8">
                                    <v-divider></v-divider>
                                  </td>
                                </tr>
                              </table>
                            </td>
                                  </tr>
                                  <tr >
                               <td colspan="8">
                                 <table
                                   v-for="itemoda in item.Odalar"
                                   :key="itemoda.Sira"
                                   width="100%"
                                 >
                                   <tr
                                     v-for="itemkisi in itemoda.Kisiler"
                                     :key="itemkisi.adsoyad"
                                     colspan="5"
                                     align="center"
                                     style="
                                       padding-top: 20px;
                                       padding-bottom: 20px;
                                     "
                                   >
                                     <td v-show="(showVoucherField('departureDate'))" style="width: 15%">
                                       <span class="subheading">
                                         {{ itemoda.Kalem.donem1 | dateformat }} 
                                          
                                         </span>
                                     </td>
                                     <td v-show="(showVoucherField('departureTime'))" style="width: 10%">
                                       <span class="subheading"> {{ itemoda.Kalem.kalemArac.seferSaat | timeformat }} </span>
                                     </td>
                                     <td v-show="(showVoucherField('arrivalDeparture'))" style="width: 5%">
                                       <span class="subheading">
                                         {{ itemoda.Kalem.baseKalem.ADT }}
                                       </span>
                                     </td>
                                     <td v-show="(showVoucherField('flightNumber'))" style="width: 10%" >
                                       <span class="subheading">
                                        {{ itemoda.Kalem.baseKalem.ucusNo }}
                                       </span>
                                     </td>
                                     <td v-show="(showVoucherField('flightTime'))" style="width: 10%" >
                                       <span class="subheading">
                                         {{ itemoda.Kalem.baseKalem.ucusSaat | timeformat }}
                                       </span>
                                     </td>
                                     <td v-show="(showVoucherField('departurePlace'))" style="width: 15%" >
                                       <span class="subheading">
                                         {{ itemoda.Kalem.baseKalem.nerden }}
                                       </span>
                                     </td>
                                     <td v-show="(showVoucherField('destination'))" style="width: 15%" >
                                       <span class="subheading">
                                         {{ itemoda.Kalem.baseKalem.nereye }}
                                       </span>
                                     </td>
                                      <td v-show="(showVoucherField('vehicle'))" style="width: 20%" >
                                       <span class="subheading">
                                         {{ itemoda.Kalem.baseKalem.arac }}
                                       </span>
                                     </td>
                                   </tr>

                                 </table>
                                </td>
                               </tr> 
                      
                              </table>
                            </td>

                            <td v-show="(showAnyVoucherField(['pickupReturnInfo', 'extraServices']))" colspan="8" v-if="isRentACar">
                              <table align="left" width="100%">
                                <tr>
                                  <td colspan="8">
                                    <v-divider></v-divider>
                                  </td>
                                </tr>
                                <tr>
                                  <td  colspan="8">
                                    <table v-show="(showVoucherField('pickupReturnInfo'))" width="100%">
                                <tr>
                                  <th style="width: 10%"> </th>
                                  <th style="width: 30%">Tarih </th>
                                  <th style="width: 30%">Saat </th>
                                  <th style="width: 30%">Yer </th>
                                </tr>
                                   <tr
                                   v-for="itemoda in item.Odalar"
                                   :key="itemoda.Sira"
                                     colspan="5"
                                     align="center"
                                     style="
                                       padding-top: 20px;
                                       padding-bottom: 20px;
                                     "
                                   >
                                     <td style="width: 20%">
                                       <span class="subheading">
                                         Alış Bilgileri
                                         </span>
                                     </td> 
                                     <td style="width: 10%">
                                       <span class="subheading"> {{ itemoda.Kalem.baseKalem.alisTarih | dateformat }} </span>
                                     </td>
                                     <td style="width: 5%">
                                       <span class="subheading">
                                         {{ itemoda.Kalem.baseKalem.alisSaat | timeformat }}
                                       </span>
                                     </td>
                                     <td style="width: 10%" >
                                       <span class="subheading">
                                         {{ itemoda.Kalem.baseKalem.alisYeri }}
                                       </span>
                                     </td>
                                   </tr>
                                      <tr
                                   v-for="itemoda in item.Odalar"
                                   :key="itemoda.Sira"
                                     colspan="5"
                                     align="center"
                                     style="
                                       padding-top: 20px;
                                       padding-bottom: 20px;
                                     "
                                   >
                                     <td style="width: 10%">
                                       <span class="subheading">
                                         Bırakış Bilgileri
                                         </span>
                                     </td> 
                                     <td style="width: 30%">
                                       <span class="subheading"> {{ itemoda.Kalem.baseKalem.musteriTeslimTarihi | dateformat }} </span>
                                     </td>
                                     <td style="width: 30%">
                                       <span class="subheading">
                                         {{ itemoda.Kalem.baseKalem.teslimSaat | timeformat }}
                                       </span>
                                     </td>
                                     <td style="width: 30%" >
                                       <span class="subheading">
                                         {{ itemoda.Kalem.baseKalem.teslimYeri }}
                                       </span>
                                     </td>
                                   </tr>
                                    </table>
                                  </td>
                                </tr>
                                <tr>
                                  <td colspan="8">
                                    <v-divider></v-divider>
                                  </td>
                                </tr>
                                 <tr v-show="(showVoucherField('extraServices'))" style="padding-top: 50px">

                            <td colspan="8" >
                              <table width="100%">
                                <tr>
                                  <th style="width: 100%" colspan="4">Ek Hizmetler </th>
                                  
                                </tr>
                                   <tr
                                     align="left"
                                     style="
                                       padding-top: 20px;
                                       padding-bottom: 20px;
                                     "
                                   >
                                     <td style="width: 40%" >
                                     <tr>
                                       <td>
                                          <span class="subheading">
                                         Drop  
                                         </span>
                                       </td>
                                       <td>
                                         : {{ checkTrueFalse(item.Odalar[0].Kalem.baseKalem.checkDropUcreti) }}
                                       </td>
                                     </tr>

                                     <tr>
                                       <td>
                                          <span class="subheading">
                                         Otomatik Vites  
                                         </span>
                                       </td>
                                       <td>
                                         : {{ checkTrueFalse(item.Odalar[0].Kalem.baseKalem.checkOtomatikVites) }}
                                       </td>
                                     </tr>

                                    <tr>
                                       <td>
                                          <span class="subheading">
                                         İptal Sigortası
                                         </span>
                                       </td>
                                       <td>
                                         : {{ checkTrueFalse(item.Odalar[0].Kalem.baseKalem.checkIptalSigortasi) }}
                                       </td>
                                     </tr>
                                    </td>


                                    <td style="width: 40%">
                                     <tr>
                                       <td>
                                          <span class="subheading">
                                         Bebek Koltuğu  
                                         </span>
                                       </td>
                                       <td>
                                         : {{ checkTrueFalse(item.Odalar[0].Kalem.baseKalem.checkBebekKoltugu) }}
                                       </td>
                                     </tr>

                                     <tr>
                                       <td>
                                          <span class="subheading">
                                         Klima  
                                         </span>
                                       </td>
                                       <td>
                                         : {{ checkTrueFalse(item.Odalar[0].Kalem.baseKalem.checkKlima) }}
                                       </td>
                                     </tr>

                                    <tr>
                                       <td>
                                          <span class="subheading">
                                         Navigasyon
                                         </span>
                                       </td>
                                       <td>
                                         : {{ checkTrueFalse(item.Odalar[0].Kalem.baseKalem.checkNavigation) }}
                                       </td>
                                     </tr>
                                    </td>

                                    <td style="width: 20%">
                                     <tr>
                                       <td>
                                          <span class="subheading">
                                         Çocuk Koltuğu  
                                         </span>
                                       </td>
                                       <td>
                                         : {{ checkTrueFalse(item.Odalar[0].Kalem.baseKalem.checkCocukKoltugu) }}
                                       </td>
                                     </tr>

                                     <tr>
                                       <td>
                                          <span class="subheading">
                                         Temizlik  
                                         </span>
                                       </td>
                                       <td>
                                         : {{ checkTrueFalse(item.Odalar[0].Kalem.baseKalem.checkTemizlik) }}
                                       </td>
                                     </tr>

                                    <tr>
                                       <td>
                                          <span class="subheading">
                                         Diğer
                                         </span>
                                       </td>
                                       <td>
                                         : {{ checkTrueFalse(item.Odalar[0].Kalem.baseKalem.checkDiger) }}
                                       </td>
                                     </tr>
                                    </td>

                                   </tr>
                                     
                              </table>
                            </td>
                            </tr>
                              </table>
                            </td>
                            
                          </tr>

                          <tr v-show="(showVoucherField('note'))" style="height: 100%; padding-top: 50px">
                            <td
                              colspan="4"
                              align="center"
                              style="padding-top: 10px; padding-bottom: 10px"
                            >
                            <v-divider></v-divider>
                              <span v-if="isOtel || isRestaurant || isTransfer" class="title pt-2 pb-2">
                               İPTAL, NO SHOW VE ERKEN ÇIKIŞ PROSEDURÜ
                              </span>
                              <span v-if="isAcente" class="title pt-2 pb-2">
                               AÇIKLAMALAR
                              </span>
                            <v-divider></v-divider>
                            </td>
                          </tr>
                          <tr v-show="(showVoucherField('note'))">
                            <td
                              colspan="4"
                              width="100%"
                              style="
                                vertical-align: top;
                                padding-top: 5px;
                                padding-bottom: 5px;
                              "
                            >
                              <v-layout id="skip3" justify-end>
                                <v-btn
                                  color="info"
                                  flat
                                  @click="aciklamaDialogOpen('NOT')"
                                >
                                  <v-icon small>edit</v-icon> &nbsp; {{ $t('Edit-Note') }}
                                </v-btn>
                              </v-layout>
                              {{ selectedVoucherItems.Aciklamalar.Not }}
                            </td>
                          </tr>

                          <tr v-show="(showVoucherField('terms'))" style="height: 100%">
                            <td
                              colspan="4"
                              align="center"
                              style="padding-top: 5px; padding-bottom: 5px"
                            >
                              <v-divider></v-divider>
                              <span class="title">
                                ŞARTLAR VE KOŞULLAR
                              </span>
                              <v-divider></v-divider>
                            </td>
                          </tr>
                          <tr v-show="(showVoucherField('terms'))">
                            <td
                              colspan="4"
                              width="100%"
                              style="
                                vertical-align: top;
                                padding-top: 10px;
                                padding-bottom: 10px;
                              "
                            >
                              <span style="text-align: center">
                                <v-layout id="skip2" justify-end>
                                  <v-btn
                                    color="info"
                                    flat
                                    @click="aciklamaDialogOpen('ACIKLAMA1')"
                                  >
                                    <v-icon small>edit</v-icon> &nbsp; {{ $t('Edit-Description1') }}
                                  </v-btn>
                                </v-layout>
                                {{ selectedVoucherItems.Aciklamalar.Aciklama1 }}
                                <br />
                                <v-layout id="skip" justify-end>
                                  <v-btn
                                    color="info"
                                    flat
                                    @click="aciklamaDialogOpen('ACIKLAMA2')"
                                  >
                                    <v-icon small>edit</v-icon> &nbsp; {{ $t('Edit-Description2') }}
                                    
                                  </v-btn>
                                </v-layout>
                                {{ selectedVoucherItems.Aciklamalar.Aciklama2 }}
                              </span>
                            </td>
                          </tr>
                          <tr></tr>

                          <tr v-show="(showAnyVoucherField(['companyInfo', 'bookedByInfo']))" pt-5 style="margin-top: 10px">
                            <td colspan="4">
                              <table width="100%">
                                <tr>
                                  <td v-show="(showVoucherField('companyInfo'))">
                                    
                                    {{
                                      
                                      voucherDisplayCompanyName
                                    }}
                                  </td>
                                  <td v-show="(showVoucherField('bookedByInfo'))">Rezervasyon Yapan;</td>
                                </tr>
                                <tr>
                                  <td v-show="(showVoucherField('companyInfo'))">
                                    {{
                                      selectedVoucherItems.SirketBilgileri.SirketAdres1
                                    }}
                                  </td>
                                  <td v-show="(showVoucherField('bookedByInfo'))">
                                    Ad Soyad : &nbsp;
                                    {{ item.RezervasyonYapan.Isim }}
                                  </td>
                                </tr>
                                <tr>
                                  <td v-show="(showVoucherField('companyInfo'))">
                                    {{
                                      selectedVoucherItems.SirketBilgileri.SirketAdres2
                                    }}
                                  </td>
                                  <td v-show="(showVoucherField('bookedByInfo'))">
                                    Email : &nbsp;
                                    {{ item.RezervasyonYapan.EMail }}
                                  </td>
                                </tr>
                                <tr>
                                  <td v-show="(showVoucherField('companyInfo'))">
                                    {{
                                      selectedVoucherItems.SirketBilgileri.SirketTelefon
                                    }}
                                  </td>
                                  <td v-show="(showVoucherField('bookedByInfo'))">
                                    Telefon : &nbsp;
                                    {{ item.RezervasyonYapan.Telefon }}
                                  </td>
                                </tr>
                                <tr>
                                  <td v-show="(showVoucherField('companyInfo'))">
                                    {{
                                      selectedVoucherItems.SirketBilgileri.SirketFaks
                                    }}
                                  </td>
                                  <td v-show="(showVoucherField('bookedByInfo'))">
                                    Acente : &nbsp;
                                    {{ item.RezervasyonYapan.Acente }}
                                  </td>
                                </tr>
                              </table>
                            </td>

                            <td></td>
                          </tr>

                          <tr v-show="(showVoucherField('printDate'))">
                            <td colspan="8">
                              <span class="grey--text caption">
                                {{ getDateNow() | dateformat }}
                                {{ getdatetimenow() }}</span
                              >
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div v-show="(showVoucherField('lowerLogo'))" id="imgAlt"></div>
                            </td>
                          </tr>
                        </thead>
                      </table>
                    </div>
                  </v-flex>
                </v-layout>
              </v-card>
            </v-flex>

          <v-flex xs12 pa-2 sm10 v-if="locale == 'en' && vouchergoster">
              <v-card flat>
                <v-layout justify-end row wrap>
                  <v-flex xs12 pa-3 sm12>
                    <div id="printJS-form" class="voucher-print-container">
                      <table
                        style="page-break-after: always"
                        v-for="item in selectedVoucherItems.Sayfalar"
                        :key="item.id"
                        width="100%"
                      >
                        <thead
                          v-if="item.Satici.Kod.trim() == secilenSaticiKod.trim()"
                          class="print"
                        >
                          <tr>
                            <td colspan="8">
                              <table width="100%">
                                <tr
                                  colspan="8"
                                  align="center"
                                  style="
                                    padding-top: 20px;
                                    padding-bottom: 20px;
                                  "
                                >
                                  <td v-show="(showVoucherField('upperLogo'))"
                                    align="left"
                                    style="
                                      width: 100%;
                                      vertical-align: top;
                                      padding-top: 10px;
                                      padding-bottom: 10px;
                                    "
                                    id="imgUst"
                                  ></td>
                                </tr>
                              </table>
                            </td>
                          </tr>
                          <tr>
                            <td v-show="(showVoucherField('voucherTitle'))"
                              colspan="10"
                              align="center"
                              style="padding-top: 10px; padding-bottom: 10px"
                            >
                              <span v-if="isOtel" class="black--text title">
                                HOTEL VOUCHER</span
                              >
                              <span v-if="isAcente" class="black--text title">
                                AGENCY VOUCHER </span
                              >
                              <span v-if="isRestaurant" class="black--text title">
                                RESTAURANT VOUCHER </span
                              >
                              <span v-if="isTransfer" class="black--text title">
                                TRANSFER VOUCHER </span
                              >
                               <span v-if="isRentACar" class="black--text title">
                                RENT A CAR VOUCHER </span
                              >
                            </td>
                          </tr>
                          <tr align="left">
                            <td colspan="8">
                              <table width="100%">
                                <tr v-show="(showAnyVoucherField(['supplierName', 'supplierPhone']))"
                                  colspan="8"
                                  align="center"
                                  style="
                                    padding-top: 20px;
                                    padding-bottom: 20px;
                                  "
                                >
                                  <td v-show="(showVoucherField('supplierName'))"
                                    align="left"
                                    style="
                                      width: 15%;
                                      vertical-align: top;
                                      padding-top: 10px;
                                      padding-bottom: 10px;
                                    "
                                  >
                                    The-Company Name
                                  </td>

                                  <td v-show="(showVoucherField('supplierName'))" style="width: 35%">
                                    {{ item.Satici.Isim }}
                                  </td>

                                  <td v-show="(showVoucherField('supplierPhone'))" style="width: 15%">Telephone</td>

                                  <td v-show="(showVoucherField('supplierPhone'))" style="width: 35%" align="left">
                                    {{ item.Satici.Tel1 }} /
                                    {{ item.Satici.Tel2 }}
                                  </td>
                                </tr>
                              </table>
                            </td>
                          </tr>
                          <tr align="left">
                            <td colspan="8">
                              <table width="100%">
                                <tr v-show="(showAnyVoucherField(['supplierAddress', 'supplierEmail']))"
                                  colspan="8"
                                  align="center"
                                  style="
                                    padding-top: 20px;
                                    padding-bottom: 20px;
                                  "
                                >
                                  <td v-show="(showVoucherField('supplierAddress'))"
                                    align="left"
                                    style="
                                      width: 15%;
                                      vertical-align: top;
                                      padding-top: 10px;
                                      padding-bottom: 10px;
                                    "
                                  >
                                    The-Company Address
                                  </td>
                                  <td v-show="(showVoucherField('supplierAddress'))" style="width: 35%">
                                    {{ item.Satici.Adres }} &nbsp;
                                    {{ item.Satici.Yer }} &nbsp;
                                    {{ item.Satici.Sehir }} &nbsp;
                                    {{ item.Satici.Ulke }}
                                  </td>
                                  <td v-show="(showVoucherField('supplierEmail'))" style="width: 15%">
                                    Email
                                  </td>
                                  <td v-show="(showVoucherField('supplierEmail'))" style="width: 35%" align="left">
                                    {{ item.Satici.Email || item.Satici.EMail || '-' }}
                                  </td>
                                </tr>
                              </table>
                            </td>
                          </tr>
<tr align="left">
                            <td colspan="10">
                              <table width="100%">
                                <tr v-show="(showAnyVoucherField(['counterReservationCode', 'bookedByPhone']))"
                                  colspan="8"
                                  align="center"
                                  style="
                                    padding-top: 20px;
                                    padding-bottom: 20px;
                                  "
                                >
                                  <td v-show="(showVoucherField('counterReservationCode'))"
                                    align="left"
                                    style="
                                      width: 20%;
                                      vertical-align: top;
                                      padding-top: 10px;
                                      padding-bottom: 10px;
                                    "
                                  >
                                  Counter res. code
                                  </td>
                                  <td v-show="(showVoucherField('counterReservationCode'))" style="width: 30%">
                                    {{ item.KarsiRezKodu }} 
                                  </td>
                                  <td v-show="(showVoucherField('bookedByPhone'))" style="width: 20%">
                                   Booked by phone
                                  </td>
                                  <td v-show="(showVoucherField('bookedByPhone'))" style="width: 30%" align="left">
                                    {{ item.RezervasyonYapan.Telefon }} 
                                  </td>
                                </tr>
   
                              </table>
                            </td>
                          </tr>
                          <tr>
                            <tr>
                                  <td colspan="8">
                                    <v-divider></v-divider>
                                  </td>
                            </tr>
                            <td v-show="(showAnyVoucherField(['roomOrder', 'pnrNo', 'personType', 'passengerName', 'checkInDate', 'checkOutDate', 'nightCount', 'boardRoomType']))" v-if="isOtel" colspan="8">
                              <table width="100%">
                                <tr
                                  colspan="8"
                                  align="center"
                                  style="
                                    padding-top: 20px;
                                    padding-bottom: 20px;
                                    
                                  "
                                >
                                  <td v-show="(showVoucherField('roomOrder'))" style="width: 5%">
                                    <span class="subheading">
                                      Room Row</span
                                    >
                                  </td>
                                  <td v-show="(showVoucherField('pnrNo'))" style="width: 10%">
                                    <span class="subheading">
                                      Pnr No</span
                                    >
                                  </td>
                                  <td v-show="(showVoucherField('personType'))" style="width: 10%">
                                    <span class="subheading">
                                      Person Type </span
                                    >
                                  </td>
                                  <td v-show="(showVoucherField('passengerName'))" style="width: 20%">
                                    <span class="subheading">
                                      Name </span
                                    >
                                  </td>
                                  <td v-show="(showVoucherField('checkInDate'))" style="width: 15%">
                                    <span class="subheading">
                                      Entry date</span
                                    >
                                  </td>
                                  <td v-show="(showVoucherField('checkOutDate'))" style="width: 15%">
                                    <span class="subheading">
                                      Release date </span
                                    >
                                  </td>
                                  <td v-show="(showVoucherField('nightCount'))" style="width: 5%">
                                    <span class="subheading">
                                      Night </span
                                    >
                                  </td>
                                  <td v-show="(showVoucherField('boardRoomType'))" style="width: 20%">
                                    <span class="subheading">
                                      Room type </span
                                    >
                                  </td>
                                </tr>
                                <tr>
                                  <td colspan="8">
                                    <v-divider></v-divider>
                                  </td>
                                </tr>
                              </table>
                            </td>
                                <td v-show="(showAnyVoucherField(['passengerName', 'passengerReservationNo', 'nationality', 'passportNumber', 'birthDate']))" v-if="isAcente" colspan="5">
                              <table width="100%">
                                <tr
                                  colspan="8"
                                  align="center"
                                  style="
                                    padding-top: 20px;
                                    padding-bottom: 20px;
                                    
                                  "
                                >
                                  <td v-show="(showVoucherField('passengerName'))" style="width: 20%">
                                    <span class="subheading">
                                      Name</span
                                    >
                                  </td>
                                  <td v-show="(showVoucherField('passengerReservationNo'))" style="width: 20%">
                                    <span class="subheading">
                                      Reservation</span
                                    >
                                  </td>
                                  <td v-show="(showVoucherField('nationality'))" style="width: 20%">
                                    <span class="subheading">
                                      Nationality </span
                                    >
                                  </td>
                                  <td v-show="(showVoucherField('passportNumber'))" style="width: 20%">
                                    <span class="subheading">
                                      Passport Number </span
                                    >
                                  </td>
                                  <td v-show="(showVoucherField('birthDate'))" style="width: 20%">
                                    <span class="subheading">
                                      Date of birth </span
                                    >
                                  </td>
                                </tr>
                                <tr>
                                  <td colspan="5">
                                    <v-divider></v-divider>
                                  </td>
                                </tr>
                              </table>
                            </td>
                            <td v-show="(showAnyVoucherField(['pax', 'passengerName', 'pnrNo', 'counterReservationCode']))" v-if="isRestaurant" colspan="5">
                              <table width="100%">
                                <tr
                                  colspan="8"
                                  align="center"
                                  style="
                                    padding-top: 20px;
                                    padding-bottom: 20px;
                                    
                                  "
                                >
                                  <td v-show="(showVoucherField('pax'))" style="width: 25%">
                                    <span class="subheading">
                                      Pax</span
                                    >
                                  </td>
                                  <td v-show="(showVoucherField('passengerName'))" style="width: 25%">
                                    <span class="subheading">
                                      Name</span
                                    >
                                  </td>
                                  <td v-show="(showVoucherField('pnrNo'))" style="width: 25%">
                                    <span class="subheading">
                                      Pnr No </span
                                    >
                                  </td>
                                  <td v-show="(showVoucherField('counterReservationCode'))" style="width: 25%">
                                    <span class="subheading">
                                      Against Res. Code </span
                                    >
                                  </td>
                                </tr>
                                <tr>
                                  <td colspan="4">
                                    <v-divider></v-divider>
                                  </td>
                                </tr>
                              </table>
                            </td>

                             <td v-show="(showAnyVoucherField(['passengerName', 'pnrNo', 'nationality', 'passportNumber', 'birthDate']))" v-if="isTransfer" colspan="8">
                              <table width="100%">
                                <tr
                                  colspan="8"
                                  align="center"
                                  style="
                                    padding-top: 20px;
                                    padding-bottom: 20px;
                                    
                                  "
                                >
                                  <td v-show="(showVoucherField('passengerName'))" style="width: 20%">
                                    <span class="subheading">
                                      Name</span
                                    >
                                  </td>
                                  <td v-show="(showVoucherField('pnrNo'))" style="width: 20%">
                                    <span class="subheading">
                                      Pnr No </span
                                    >
                                  </td>
                                  <td v-show="(showVoucherField('nationality'))" style="width: 20%">
                                    <span class="subheading">
                                      Nationality </span
                                    >
                                  </td>
                                   <td v-show="(showVoucherField('passportNumber'))" style="width: 20%">
                                    <span class="subheading">
                                      Passport Number </span
                                    >
                                  </td>
                                    <td v-show="(showVoucherField('birthDate'))" style="width: 20%">
                                    <span class="subheading">
                                      Birth Date </span
                                    >
                                  </td>
                                </tr>
                                <tr>
                                  <td colspan="8">
                                    <v-divider></v-divider>
                                  </td>
                                </tr>
                              </table>
                            </td>

                            <td v-show="(showAnyVoucherField(['passengerName', 'vehicle', 'vehicleCategory', 'vehicleCount', 'vehicleDay']))" v-if="isRentACar" colspan="8">
                              <table width="100%">
                                <tr
                                  colspan="8"
                                  align="center"
                                  style="
                                    padding-top: 20px;
                                    padding-bottom: 20px;
                                    
                                  "
                                >
                                  <td v-show="(showVoucherField('passengerName'))" style="width: 20%">
                                    <span class="subheading">
                                      Name</span
                                    >
                                  </td>
                                  <td v-show="(showVoucherField('vehicle'))" style="width: 20%">
                                    <span class="subheading">
                                      Vehicle </span
                                    >
                                  </td>
                                  <td v-show="(showVoucherField('vehicleCategory'))" style="width: 20%">
                                    <span class="subheading">
                                      Kategori </span
                                    >
                                  </td>
                                   <td v-show="(showVoucherField('vehicleCount'))" style="width: 20%">
                                    <span class="subheading">
                                      Category </span
                                    >
                                  </td>
                                    <td v-show="(showVoucherField('vehicleDay'))" style="width: 20%">
                                    <span class="subheading">
                                      Day </span
                                    >
                                  </td>
                                </tr>
                                <tr>
                                  <td colspan="8">
                                    <v-divider></v-divider>
                                  </td>
                                </tr>
                              </table>
                            </td>
                          </tr>

                          <tr v-show="(showAnyVoucherField(['roomOrder', 'pnrNo', 'personType', 'passengerName', 'checkInDate', 'checkOutDate', 'nightCount', 'boardRoomType']))" v-if="isOtel">
                            <td colspan="8">
                              <table
                                v-for="itemoda in item.Odalar"
                                :key="itemoda.Sira"
                                width="100%"
                              >
                                <tr
                                  v-for="itemkisi in itemoda.Kisiler"
                                  :key="itemkisi.adsoyad"
                                  colspan="8"
                                  align="center"
                                  style="
                                    padding-top: 20px;
                                    padding-bottom: 20px;
                                  "
                                >
                                  <td v-show="(showVoucherField('roomOrder'))" style="width: 5%">
                                    <span class="subheading">
                                      {{ itemoda.Sira }}</span
                                    >
                                  </td>
                                  <td v-show="(showVoucherField('pnrNo'))" style="width: 10%">
                                    <span class="subheading"> {{ pnr }}</span>
                                  </td>
                                  <td v-show="(showVoucherField('personType'))" style="width: 10%">
                                    <span class="subheading">
                                      {{ KisiTipToStr(itemkisi.kisiTip) }}
                                    </span>
                                  </td>
                                  <td v-show="(showVoucherField('passengerName'))"
                                    align="left"
                                    style="align: left; width: 20%"
                                  >
                                    <span class="subheading">
                                      {{ itemkisi.adSoyad }} </span
                                    >
                                  </td>
                                  <td v-show="(showVoucherField('checkInDate'))" style="width: 15%">
                                    <span class="subheading">
                                      {{ itemoda.Kalem.donem1 | dateformat }}</span
                                    >
                                  </td>
                                  <td v-show="(showVoucherField('checkOutDate'))" style="width: 15%">
                                    <span class="subheading">
                                      {{ itemoda.Kalem.donem2 | dateformat }}</span
                                    >
                                  </td>
                                  <td v-show="(showVoucherField('nightCount'))" style="width: 5%">
                                    <span class="subheading">
                                      {{ gunhesapla(itemoda.Kalem) }}</span
                                    >
                                  </td>
                                  <td v-show="(showVoucherField('boardRoomType'))" style="width: 20%">
                                    <span class="subheading">
                                      {{
                                        PansiyonTipToStr(
                                          itemoda.Kalem.kalemOtel.pansiyon
                                        )
                                      }}{{
                                        itemoda.Kalem.kalemOtel.odaTipi.isim
                                      }}</span
                                    >
                                  </td>
                                </tr>
                             
                              </table>
                            </td>
                          </tr>

                          <tr v-show="(showAnyVoucherField(['passengerName', 'passengerReservationNo', 'nationality', 'passportNumber', 'birthDate']))" v-if="isAcente">
                            <td colspan="5">
                              <table
                                v-for="itemoda in item.Odalar"
                                :key="itemoda.Sira"
                                width="100%"
                              >
                                <tr
                                  v-for="itemkisi in itemoda.Kisiler"
                                  :key="itemkisi.adsoyad"
                                  colspan="5"
                                  align="center"
                                  style="
                                    padding-top: 20px;
                                    padding-bottom: 20px;
                                  "
                                >
                                  <td v-show="(showVoucherField('passengerName'))" style="width: 20%">
                                    <span class="subheading">
                                      {{ itemkisi.adSoyad }} 
                                      </span>
                                  </td>
                                  <td v-show="(showVoucherField('passengerReservationNo'))" style="width: 20%">
                                    <span class="subheading"> {{ itemkisi.kod }}</span>
                                  </td>
                                  <td v-show="(showVoucherField('nationality'))" style="width: 20%">
                                    <span class="subheading">
                                       {{ itemkisi.ulke }}
                                    </span>
                                  </td>
                                  <td v-show="(showVoucherField('passportNumber'))" style="width: 20%" >
                                    <span class="subheading">
                                      {{ itemkisi.pasaportNo }}</span
                                    >
                                  </td>
                                  <td v-show="(showVoucherField('birthDate'))" style="width: 20%">
                                    <span class="subheading">
                                      {{ formatDate(itemkisi.dogumTarihi) }} </span
                                    >
                                  </td>
                                </tr>
                             
                              </table>
                            </td>
                          </tr>


                           <tr v-show="(showAnyVoucherField(['pax', 'passengerName', 'pnrNo', 'counterReservationCode']))" v-if="isRestaurant">
                            <td colspan="4"  >
                              <table
                                v-for="itemoda in item.Odalar"
                                :key="itemoda.Sira"
                                width="100%"
                              >
                                <tr
                                  v-for="itemkisi in itemoda.Kisiler"
                                  :key="itemkisi.adsoyad"
                                  colspan="5"
                                  align="center"
                                  style="
                                    padding-top: 20px;
                                    padding-bottom: 20px;
                                  "
                                >
                                  <td v-show="(showVoucherField('pax'))" style="width: 25%">
                                    <span class="subheading">
                                      {{ itemkisi.Pax }} 
                                      </span>
                                  </td>
                                  <td v-show="(showVoucherField('passengerName'))" style="width: 25%">
                                    <span class="subheading"> {{ itemkisi.adSoyad }}</span>
                                  </td>
                                  <td v-show="(showVoucherField('pnrNo'))" style="width: 25%">
                                    <span class="subheading">
                                      {{ pnr }}    
                                    </span>
                                  </td>
                                  <td v-show="(showVoucherField('counterReservationCode'))" style="width: 25%" >
                                    <span class="subheading">
                                      {{ itemoda.KarsiRezKodu }}</span
                                    >
                                  </td>
                                </tr>
                             
                              </table>
                            </td>
                          </tr> 

                         <tr v-show="(showAnyVoucherField(['passengerName', 'pnrNo', 'nationality', 'passportNumber', 'birthDate']))" v-if="isTransfer">
                            <td colspan="8">
                              <table
                                v-for="itemoda in item.Odalar"
                                :key="itemoda.Sira"
                                width="100%"
                              >
                                <tr
                                  v-for="itemkisi in itemoda.Kisiler"
                                  :key="itemkisi.adsoyad"
                                  colspan="8"
                                  align="center"
                                  style="
                                    padding-top: 20px;
                                    padding-bottom: 20px;
                                  "
                                >
                                  <td v-show="(showVoucherField('passengerName'))" style="width: 20%">
                                    <span class="subheading">
                                      {{ itemkisi.adSoyad }} 
                                      </span>
                                  </td>
                                  <td v-show="(showVoucherField('pnrNo'))" style="width: 20%">
                                    <span class="subheading"> {{ pnr }}</span>
                                  </td>
                                  <td v-show="(showVoucherField('nationality'))" style="width: 20%">
                                    <span class="subheading">
                                      {{itemkisi.ulke}}  
                                    </span>
                                  </td>
                                  <td v-show="(showVoucherField('passportNumber'))" style="width: 20%" >
                                    <span class="subheading">
                                      {{itemkisi.pasaportNo}}
                                    </span>
                                  </td>
                                  <td v-show="(showVoucherField('birthDate'))" style="width: 20%" >
                                    <span class="subheading">
                                      {{ formatDate(itemkisi.dogumTarihi)}}
                                    </span>
                                  </td>
                                </tr>
                             
                              </table>
                            </td>
                          </tr> 

                          <tr v-show="(showAnyVoucherField(['passengerName', 'vehicle', 'vehicleCategory', 'vehicleCount', 'vehicleDay']))" v-if="isRentACar">
                            <td colspan="8">
                              <table
                                v-for="itemoda in item.Odalar"
                                :key="itemoda.Sira"
                                width="100%"
                              >
                                <tr
                                  v-for="itemkisi in itemoda.Kisiler"
                                  :key="itemkisi.adsoyad"
                                  colspan="8"
                                  align="center"
                                  style="
                                    padding-top: 20px;
                                    padding-bottom: 20px;
                                  "
                                >
                                  <td v-show="(showVoucherField('passengerName'))" style="width: 20%">
                                    <span class="subheading">
                                      {{ itemkisi.adSoyad }} 
                                      </span>
                                  </td>
                                  <td v-show="(showVoucherField('vehicle'))" style="width: 20%">
                                    <span class="subheading"> {{itemoda.Kalem.baseKalem.arac}} </span>
                                  </td>
                                  <td v-show="(showVoucherField('vehicleCategory'))" style="width: 20%">
                                    <span class="subheading">
                                      {{itemoda.Kalem.baseKalem.kategori}}
                                    </span>
                                  </td>
                                  <td v-show="(showVoucherField('vehicleCount'))" style="width: 20%" >
                                    <span class="subheading">
                                      {{itemoda.Kalem.baseKalem.aracAdet}} 
                                    </span>
                                  </td>
                                  <td v-show="(showVoucherField('vehicleDay'))" style="width: 20%" >
                                    <span class="subheading">
                                      {{itemoda.Kalem.baseKalem.gun}} 
                                    </span>
                                  </td>
                                </tr>
                             
                              </table>
                            </td>
                          </tr> 

                          <tr>
                            <td v-show="(showAnyVoucherField(['totalPax', 'totalRoom']))" v-if="isOtel" colspan="4">
                              <table align="left" width="100%">
                                <tr
                                  align="left"
                                  style="
                                    padding-top: 15px;
                                    padding-bottom: 15px;
                                  "
                                >
                                  <td v-show="(showVoucherField('totalPax'))" colspan="2">
                                    <span class="subheading">
                                     Total Passengers : {{ item.ToplamPax }}</span
                                    >
                                  </td>
                                </tr>
                                <tr
                                  colspan="8"
                                  align="left"
                                  style="
                                    padding-top: 20px;
                                    padding-bottom: 20px;
                                  "
                                >
                                  <td v-show="(showVoucherField('totalRoom'))" colspan="2">
                                    <span class="subheading">
                                      Total Rooms : {{ toplamOdaText }}
                                    </span>
                                  </td>
                                </tr>
                              </table>
                            </td>

                            <td v-show="(showAnyVoucherField(['totalPax', 'tourType', 'meetingDate', 'tourKind', 'meetingTime', 'tourDuration', 'meetingPlace', 'tourGuide', 'shipName', 'entrancesIncluded', 'returnInfo', 'mealsIncluded']))" colspan="5" v-if="isAcente">
                              <table align="left" width="100%">
                                <tr
                                  style="
                                    padding-top: 15px;
                                    padding-bottom: 15px;
                                  "
                                >
                                  <td v-show="(showVoucherField('totalPax'))" colspan="2">
                                    <span class="subheading">
                                      Total Pax : {{ item.ToplamPax }}</span
                                    >
                                  </td>
                                  <td v-show="(showVoucherField('tourType'))" colspan="2">
                                    <span class="subheading">
                                     Tour Type : {{ getTurTipi(item.Odalar[0].Kalem.kalemAcente.TurTipi) }} </span
                                    >
                                  </td>
                                </tr>
                                 <tr
                                  style="
                                    padding-top: 15px;
                                    padding-bottom: 15px;
                                  "
                                >
                                  <td v-show="(showVoucherField('meetingDate'))" colspan="2">
                                    <span class="subheading">
                                      Meeting Date : {{ item.Odalar[0].Kalem.kalemAcente.BulusmaTarihi | dateformat }} </span
                                    >
                                  </td>
                                  <td v-show="(showVoucherField('tourKind'))" colspan="2">
                                    <span class="subheading">
                                       Tour Type : {{ getTurTuru(item.Odalar[0].Kalem.kalemAcente.TurTuru) }}</span
                                    >
                                  </td>
                                </tr>
                                <tr
                                  style="
                                    padding-top: 15px;
                                    padding-bottom: 15px;
                                  "
                                >
                                  <td v-show="(showVoucherField('meetingTime'))" colspan="2">
                                    <span class="subheading">
                                      Meeting time : {{ item.Odalar[0].Kalem.kalemAcente.Saat | timeformat }} </span
                                    >
                                  </td>
                                  <td v-show="(showVoucherField('tourDuration'))" colspan="2">
                                    <span class="subheading">
                                      Lap Duration :  </span 
                                    >
                                    <!-- {{ getTurTuru(item.Odalar[0].Kalem.kalemAcente.Tip) }} -->
                                  </td>
                                </tr>
                                <tr
                                  style="
                                    padding-top: 15px;
                                    padding-bottom: 15px;
                                  "
                                >
                                  <td v-show="(showVoucherField('meetingPlace'))" colspan="2">
                                    <span class="subheading">
                                     Meeting place : {{ item.Odalar[0].Kalem.kalemAcente.BulusmaYeri }}</span
                                    >
                                  </td>
                                  <td v-show="(showVoucherField('tourGuide'))" colspan="2">
                                    <span class="subheading">
                                     The tour guide : {{ item.Odalar[0].Kalem.kalemAcente.Rehber.isim }} </span
                                    >
                                  </td>
                                </tr>
                                <tr
                                  style="
                                    padding-top: 15px;
                                    padding-bottom: 15px;
                                  "
                                >
                                  <td v-show="(showVoucherField('shipName'))" colspan="2">
                                    <span class="subheading">
                                      Ship name : {{ item.Odalar[0].Kalem.kalemAcente.Gemi.isim }}</span
                                    >
                                  </td>
                                  <td v-show="(showVoucherField('entrancesIncluded'))" colspan="2">
                                    <span class="subheading">
                                      Entries Included : {{ checkItemsList(item.Odalar[0].Kalem.kalemAcente.Girisler)  }}  </span
                                    >
                                  </td>
                                </tr>
                                <tr
                                  style="
                                    padding-top: 15px;
                                    padding-bottom: 15px;
                                  "
                                >
                                  <td v-show="(showVoucherField('returnInfo'))" colspan="2" style="max-width:100px;">
                                    <span class="subheading">
                                      Return Information : {{ item.Odalar[0].Kalem.kalemAcente.DonusBilgisi }}</span
                                    >
                                  </td>
                                  <td v-show="(showVoucherField('mealsIncluded'))" colspan="2">
                                    <span class="subheading">
                                      Meals Included : {{ checkItemsList(item.Odalar[0].Kalem.kalemAcente.OgleYemegi) }}  </span
                                    >
                                  </td>
                                </tr>
                              
                              </table>
                            </td>

                            <td v-show="(showAnyVoucherField(['totalPax', 'restaurantMenu']))" colspan="4" v-if="isRestaurant">
                              <table align="left" width="100%">
                                <tr
                                  align="left"
                                  style="
                                    padding-top: 15px;
                                    padding-bottom: 15px;
                                  "
                                >
                                  <td v-show="(showVoucherField('totalPax'))" colspan="4">
                                    <span class="subheading">
                                      Toplam Pax : {{ item.ToplamPax }}</span
                                    >
                                  </td>
                                </tr>
                                <tr v-show="(showVoucherField('restaurantMenu'))"
                                  colspan="4"
                                  align="left"
                                  style="
                                    padding-top: 20px;
                                    padding-bottom: 20px;
                                  "
                                  v-for="itemMenu in item.Satici.stRestaurant.Menu"
                                  :key="itemMenu.Kod"
                                >
                                  <td colspan="4"       
                                  >
                                    <span class="subheading">
                                      {{ itemMenu.Kod }}  : {{ itemMenu.Menu }}
                                    </span>
                                  </td>
                                </tr>
                         
                              </table>
                            </td>
                            <td v-show="(showAnyVoucherField(['departureDate', 'departureTime', 'arrivalDeparture', 'flightNumber', 'flightTime', 'departurePlace', 'destination', 'vehicle']))" colspan="8" v-if="isTransfer">
                             
                              <table align="left" width="100%">
                                   <tr>
                                  <td colspan="8">
                                    <v-divider></v-divider>
                                  </td>
                                </tr>
                                  <tr>
                            <td v-show="(showAnyVoucherField(['departureDate', 'departureTime', 'arrivalDeparture', 'flightNumber', 'flightTime', 'departurePlace', 'destination', 'vehicle']))" v-if="isTransfer" colspan="8">
                              <table width="100%">
                                <tr
                                  colspan="8"
                                  align="center"
                                  style="
                                    padding-top: 20px;
                                    padding-bottom: 20px;
                                    
                                  "
                                >
                                  <td v-show="(showVoucherField('departureDate'))" style="width: 15%">
                                    <span class="subheading">
                                      Departure date</span
                                    >
                                  </td>
                                  <td v-show="(showVoucherField('departureTime'))" style="width: 10%">
                                    <span class="subheading">
                                      Departure time </span
                                    >
                                  </td>
                                  <td v-show="(showVoucherField('arrivalDeparture'))" style="width: 5%">
                                    <span class="subheading">
                                      A/D </span
                                    >
                                  </td>
                                   <td v-show="(showVoucherField('flightNumber'))" style="width: 10%">
                                    <span class="subheading">
                                      Flight number </span
                                    >
                                  </td>
                                    <td v-show="(showVoucherField('flightTime'))" style="width: 10%">
                                    <span class="subheading">
                                      Flight time </span
                                    >
                                  </td>
                                   <td v-show="(showVoucherField('departurePlace'))" style="width: 15%">
                                    <span class="subheading">
                                      Place of action </span
                                    >
                                  </td>
                                   <td v-show="(showVoucherField('destination'))" style="width: 15%">
                                    <span class="subheading">
                                      Destination </span
                                    >
                                  </td>
                                   <td v-show="(showVoucherField('vehicle'))" style="width: 20%">
                                    <span class="subheading">
                                      Vehicle </span
                                    >
                                  </td>
                                </tr>
                                <tr>
                                  <td colspan="8">
                                    <v-divider></v-divider>
                                  </td>
                                </tr>
                              </table>
                            </td>
                                  </tr>
                                  <tr >
                               <td colspan="8">
                                 <table
                                   v-for="itemoda in item.Odalar"
                                   :key="itemoda.Sira"
                                   width="100%"
                                 >
                                   <tr
                                     v-for="itemkisi in itemoda.Kisiler"
                                     :key="itemkisi.adsoyad"
                                     colspan="5"
                                     align="center"
                                     style="
                                       padding-top: 20px;
                                       padding-bottom: 20px;
                                     "
                                   >
                                     <td v-show="(showVoucherField('departureDate'))" style="width: 15%">
                                       <span class="subheading">
                                         {{ itemoda.Kalem.donem1 | dateformat }} 
                                          
                                         </span>
                                     </td>
                                     <td v-show="(showVoucherField('departureTime'))" style="width: 10%">
                                       <span class="subheading"> {{ itemoda.Kalem.kalemArac.seferSaat | timeformat }} </span>
                                     </td>
                                     <td v-show="(showVoucherField('arrivalDeparture'))" style="width: 5%">
                                       <span class="subheading">
                                         {{ itemoda.Kalem.baseKalem.ADT }}
                                       </span>
                                     </td>
                                     <td v-show="(showVoucherField('flightNumber'))" style="width: 10%" >
                                       <span class="subheading">
                                        {{ itemoda.Kalem.baseKalem.ucusNo }}
                                       </span>
                                     </td>
                                     <td v-show="(showVoucherField('flightTime'))" style="width: 10%" >
                                       <span class="subheading">
                                         {{ itemoda.Kalem.baseKalem.ucusSaat | timeformat }}
                                       </span>
                                     </td>
                                     <td v-show="(showVoucherField('departurePlace'))" style="width: 15%" >
                                       <span class="subheading">
                                         {{ itemoda.Kalem.baseKalem.nerden }}
                                       </span>
                                     </td>
                                     <td v-show="(showVoucherField('destination'))" style="width: 15%" >
                                       <span class="subheading">
                                         {{ itemoda.Kalem.baseKalem.nereye }}
                                       </span>
                                     </td>
                                      <td v-show="(showVoucherField('vehicle'))" style="width: 20%" >
                                       <span class="subheading">
                                         {{ itemoda.Kalem.baseKalem.arac }}
                                       </span>
                                     </td>
                                   </tr>

                                 </table>
                                </td>
                               </tr> 
                      
                              </table>
                            </td>

                            <td v-show="(showAnyVoucherField(['pickupReturnInfo', 'extraServices']))" colspan="8" v-if="isRentACar">
                              <table align="left" width="100%">
                                <tr>
                                  <td colspan="8">
                                    <v-divider></v-divider>
                                  </td>
                                </tr>
                                <tr>
                                  <td  colspan="8">
                                    <table v-show="(showVoucherField('pickupReturnInfo'))" width="100%">
                                <tr>
                                  <th style="width: 10%"> </th>
                                  <th style="width: 30%">Date </th>
                                  <th style="width: 30%">Hour </th>
                                  <th style="width: 30%">Place </th>
                                </tr>
                                   <tr
                                   v-for="itemoda in item.Odalar"
                                   :key="itemoda.Sira"
                                     colspan="5"
                                     align="center"
                                     style="
                                       padding-top: 20px;
                                       padding-bottom: 20px;
                                     "
                                   >
                                     <td style="width: 20%">
                                       <span class="subheading">
                                         Purchase Information
                                         </span>
                                     </td> 
                                     <td style="width: 10%">
                                       <span class="subheading"> {{ itemoda.Kalem.baseKalem.alisTarih | dateformat }} </span>
                                     </td>
                                     <td style="width: 5%">
                                       <span class="subheading">
                                         {{ itemoda.Kalem.baseKalem.alisSaat | timeformat }}
                                       </span>
                                     </td>
                                     <td style="width: 10%" >
                                       <span class="subheading">
                                         {{ itemoda.Kalem.baseKalem.alisYeri }}
                                       </span>
                                     </td>
                                   </tr>
                                      <tr
                                   v-for="itemoda in item.Odalar"
                                   :key="itemoda.Sira"
                                     colspan="5"
                                     align="center"
                                     style="
                                       padding-top: 20px;
                                       padding-bottom: 20px;
                                     "
                                   >
                                     <td style="width: 10%">
                                       <span class="subheading">
                                         Drop Information
                                         </span>
                                     </td> 
                                     <td style="width: 30%">
                                       <span class="subheading"> {{ itemoda.Kalem.baseKalem.musteriTeslimTarihi | dateformat }} </span>
                                     </td>
                                     <td style="width: 30%">
                                       <span class="subheading">
                                         {{ itemoda.Kalem.baseKalem.teslimSaat | timeformat }}
                                       </span>
                                     </td>
                                     <td style="width: 30%" >
                                       <span class="subheading">
                                         {{ itemoda.Kalem.baseKalem.teslimYeri }}
                                       </span>
                                     </td>
                                   </tr>
                                    </table>
                                  </td>
                                </tr>
                                <tr>
                                  <td colspan="8">
                                    <v-divider></v-divider>
                                  </td>
                                </tr>
                                 <tr v-show="(showVoucherField('extraServices'))" style="padding-top: 50px">

                            <td colspan="8" >
                              <table width="100%">
                                <tr>
                                  <th style="width: 100%" colspan="4">Additional services </th>
                                  
                                </tr>
                                   <tr
                                     align="left"
                                     style="
                                       padding-top: 20px;
                                       padding-bottom: 20px;
                                     "
                                   >
                                     <td style="width: 40%" >
                                     <tr>
                                       <td>
                                          <span class="subheading">
                                         Drop  
                                         </span>
                                       </td>
                                       <td>
                                         : {{ checkTrueFalse(item.Odalar[0].Kalem.baseKalem.checkDropUcreti) }}
                                       </td>
                                     </tr>

                                     <tr>
                                       <td>
                                          <span class="subheading">
                                         Automatic transmission 
                                         </span>
                                       </td>
                                       <td>
                                         : {{ checkTrueFalse(item.Odalar[0].Kalem.baseKalem.checkOtomatikVites) }}
                                       </td>
                                     </tr>

                                    <tr>
                                       <td>
                                          <span class="subheading">
                                         Cancellation Insurance
                                         </span>
                                       </td>
                                       <td>
                                         : {{ checkTrueFalse(item.Odalar[0].Kalem.baseKalem.checkIptalSigortasi) }}
                                       </td>
                                     </tr>
                                    </td>


                                    <td style="width: 40%">
                                     <tr>
                                       <td>
                                          <span class="subheading">
                                         Baby chair  
                                         </span>
                                       </td>
                                       <td>
                                         : {{ checkTrueFalse(item.Odalar[0].Kalem.baseKalem.checkBebekKoltugu) }}
                                       </td>
                                     </tr>

                                     <tr>
                                       <td>
                                          <span class="subheading">
                                         Air conditioning  
                                         </span>
                                       </td>
                                       <td>
                                         : {{ checkTrueFalse(item.Odalar[0].Kalem.baseKalem.checkKlima) }}
                                       </td>
                                     </tr>

                                    <tr>
                                       <td>
                                          <span class="subheading">
                                         Navigation
                                         </span>
                                       </td>
                                       <td>
                                         : {{ checkTrueFalse(item.Odalar[0].Kalem.baseKalem.checkNavigation) }}
                                       </td>
                                     </tr>
                                    </td>

                                    <td style="width: 20%">
                                     <tr>
                                       <td>
                                          <span class="subheading">
                                       Child seat 
                                         </span>
                                       </td>
                                       <td>
                                         : {{ checkTrueFalse(item.Odalar[0].Kalem.baseKalem.checkCocukKoltugu) }}
                                       </td>
                                     </tr>

                                     <tr>
                                       <td>
                                          <span class="subheading">
                                         Cleaning  
                                         </span>
                                       </td>
                                       <td>
                                         : {{ checkTrueFalse(item.Odalar[0].Kalem.baseKalem.checkTemizlik) }}
                                       </td>
                                     </tr>

                                    <tr>
                                       <td>
                                          <span class="subheading">
                                         Other
                                         </span>
                                       </td>
                                       <td>
                                         : {{ checkTrueFalse(item.Odalar[0].Kalem.baseKalem.checkDiger) }}
                                       </td>
                                     </tr>
                                    </td>

                                   </tr>
                                     
                              </table>
                            </td>
                            </tr>
                              </table>
                            </td>
                          </tr>

                          <tr v-show="(showVoucherField('note'))" style="height: 100%; padding-top: 50px">
                            <td
                              colspan="4"
                              align="center"
                              style="padding-top: 10px; padding-bottom: 10px"
                            >
                            <v-divider></v-divider>
                              <span class="title pt-2 pb-2">
                                CANCELLATION, NO SHOW AND EARLY EXIT PROCEDURE
                              </span>
                            <v-divider></v-divider>
                            </td>
                          </tr>
                          <tr v-show="(showVoucherField('note'))">
                            <td
                              colspan="4"
                              width="100%"
                              style="
                                vertical-align: top;
                                padding-top: 5px;
                                padding-bottom: 5px;
                              "
                            >
                              <v-layout id="skip3" justify-end>
                                <v-btn
                                  color="info"
                                  flat
                                  @click="aciklamaDialogOpen('NOT')"
                                >
                                  <v-icon small>edit</v-icon> &nbsp; {{ $t('Edit-Note') }}
                                </v-btn>
                              </v-layout>
                              {{ selectedVoucherItems.Aciklamalar.Not }}
                            </td>
                          </tr>

                          <tr v-show="(showVoucherField('terms'))" style="height: 100%">
                            <td
                              colspan="4"
                              align="center"
                              style="padding-top: 5px; padding-bottom: 5px"
                            >
                              <v-divider></v-divider>
                              <span class="title">
                               TERMS AND CONDITIONS
                              </span>
                              <v-divider></v-divider>
                            </td>
                          </tr>
                          <tr v-show="(showVoucherField('terms'))">
                            <td
                              colspan="4"
                              width="100%"
                              style="
                                vertical-align: top;
                                padding-top: 10px;
                                padding-bottom: 10px;
                              "
                            >
                              <span style="text-align: center">
                                <v-layout id="skip2" justify-end>
                                  <v-btn
                                    color="info"
                                    flat
                                    @click="aciklamaDialogOpen('ACIKLAMA1')"
                                  >
                                    <v-icon small>edit</v-icon> &nbsp; {{ $t('Edit-Description1') }}
                                   
                                  </v-btn>
                                </v-layout>
                                {{ selectedVoucherItems.Aciklamalar.Aciklama1 }}
                                <br />
                                <v-layout id="skip" justify-end>
                                  <v-btn
                                    color="info"
                                    flat
                                    @click="aciklamaDialogOpen('ACIKLAMA2')"
                                  >
                                    <v-icon small>edit</v-icon> &nbsp; {{ $t('Edit-Description2') }}
                                    
                                  </v-btn>
                                </v-layout>
                                {{ selectedVoucherItems.Aciklamalar.Aciklama2 }}
                              </span>
                            </td>
                          </tr>
                          <tr></tr>

                          <tr v-show="(showAnyVoucherField(['companyInfo', 'bookedByInfo']))" pt-5 style="margin-top: 10px">
                            <td colspan="4">
                              <table width="100%">
                                <tr>
                                  <td v-show="(showVoucherField('companyInfo'))">
                                    
                                    {{
                                      voucherDisplayCompanyName
                                    }}
                                  </td>
                                  <td v-show="(showVoucherField('bookedByInfo'))">Booker;</td>
                                </tr>
                                <tr>
                                  <td v-show="(showVoucherField('companyInfo'))">
                                    {{
                                      selectedVoucherItems.SirketBilgileri.SirketAdres1
                                    }}
                                  </td>
                                  <td v-show="(showVoucherField('bookedByInfo'))">
                                    Name Surname : &nbsp;
                                    {{ item.RezervasyonYapan.Isim }}
                                  </td>
                                </tr>
                                <tr>
                                  <td v-show="(showVoucherField('companyInfo'))">
                                    {{
                                      selectedVoucherItems.SirketBilgileri.SirketAdres2
                                    }}
                                  </td>
                                  <td v-show="(showVoucherField('bookedByInfo'))">
                                    Email :
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    {{ item.RezervasyonYapan.EMail }}
                                  </td>
                                </tr>
                                <tr>
                                  <td v-show="(showVoucherField('companyInfo'))">
                                    {{
                                      selectedVoucherItems.SirketBilgileri.SirketTelefon
                                    }}
                                  </td>
                                  <td v-show="(showVoucherField('bookedByInfo'))">
                                    Telephone : &nbsp;&nbsp;
                                    {{ item.RezervasyonYapan.Telefon }}
                                  </td>
                                </tr>
                                <tr>
                                  <td v-show="(showVoucherField('companyInfo'))">
                                    {{
                                      selectedVoucherItems.SirketBilgileri.SirketFaks
                                    }}
                                  </td>
                                  <td v-show="(showVoucherField('bookedByInfo'))">
                                    Agency : &nbsp;&nbsp;&nbsp;
                                    {{ item.RezervasyonYapan.Acente }}
                                  </td>
                                </tr>
                              </table>
                            </td>

                            <td></td>
                          </tr>

                          <tr v-show="(showVoucherField('printDate'))">
                            <td colspan="8">
                              <span class="grey--text caption">
                                {{ getDateNow() | dateformat }}
                                {{ getdatetimenow() }}</span
                              >
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div v-show="(showVoucherField('lowerLogo'))" id="imgAlt"></div>
                            </td>
                          </tr>
                        </thead>
                      </table>
                    </div>
                  </v-flex>
                </v-layout>
              </v-card>
            </v-flex>

           <v-flex xs12 pa-2 sm10 v-if="locale == 'de' && vouchergoster">
              <v-card flat>
                <v-layout justify-end row wrap>
                  <v-flex xs12 pa-3 sm12>
                    <div id="printJS-form" class="voucher-print-container">
                      <table
                        style="page-break-after: always"
                        v-for="item in selectedVoucherItems.Sayfalar"
                        :key="item.id"
                        width="100%"
                      >
                        <thead
                          v-if="item.Satici.Kod.trim() == secilenSaticiKod.trim()"
                          class="print"
                        >
                          <tr>
                            <td colspan="8">
                              <table width="100%">
                                <tr
                                  colspan="8"
                                  align="center"
                                  style="
                                    padding-top: 20px;
                                    padding-bottom: 20px;
                                  "
                                >
                                  <td v-show="(showVoucherField('upperLogo'))"
                                    align="left"
                                    style="
                                      width: 100%;
                                      vertical-align: top;
                                      padding-top: 10px;
                                      padding-bottom: 10px;
                                    "
                                    id="imgUst"
                                  ></td>
                                </tr>
                              </table>
                            </td>
                          </tr>
                          <tr>
                            <td v-show="(showVoucherField('voucherTitle'))"
                              colspan="10"
                              align="center"
                              style="padding-top: 10px; padding-bottom: 10px"
                            >
                              <span v-if="isOtel" class="black--text title">
                                HOTELGUTSCHEIN </span
                              >
                               <span v-if="isAcente" class="black--text title">
                                AGENTEN-GUTSCHEIN </span
                              >
                              <span v-if="isRestaurant" class="black--text title">
                                RESTAURANT-GUTSCHEIN </span
                              >
                              <span v-if="isTransfer" class="black--text title">
                                ÜBERTRAGUNGSGUTSCHEIN </span
                              >
                               <span v-if="isRentACar" class="black--text title">
                                MIETWAGEN-GUTSCHEIN </span
                              >
                            </td>
                          </tr>
                          <tr align="left">
                            <td colspan="8">
                              <table width="100%">
                                <tr v-show="(showAnyVoucherField(['supplierName', 'supplierPhone']))"
                                  colspan="8"
                                  align="center"
                                  style="
                                    padding-top: 20px;
                                    padding-bottom: 20px;
                                  "
                                >
                                  <td v-show="(showVoucherField('supplierName'))"
                                    align="left"
                                    style="
                                      width: 15%;
                                      vertical-align: top;
                                      padding-top: 10px;
                                      padding-bottom: 10px;
                                    "
                                  >
                                    Name der Firma
                                  </td>

                                  <td v-show="(showVoucherField('supplierName'))" style="width: 35%">
                                    {{ item.Satici.Isim }}
                                  </td>

                                  <td v-show="(showVoucherField('supplierPhone'))" style="width: 15%">Telefon</td>

                                  <td v-show="(showVoucherField('supplierPhone'))" style="width: 35%" align="left">
                                    {{ item.Satici.Tel1 }} /
                                    {{ item.Satici.Tel2 }}
                                  </td>
                                </tr>
                              </table>
                            </td>
                          </tr>
                          <tr align="left">
                            <td colspan="8">
                              <table width="100%">
                                <tr v-show="(showAnyVoucherField(['supplierAddress', 'supplierEmail']))"
                                  colspan="8"
                                  align="center"
                                  style="
                                    padding-top: 20px;
                                    padding-bottom: 20px;
                                  "
                                >
                                  <td v-show="(showVoucherField('supplierAddress'))"
                                    align="left"
                                    style="
                                      width: 15%;
                                      vertical-align: top;
                                      padding-top: 10px;
                                      padding-bottom: 10px;
                                    "
                                  >
                                  Firmenanschrift
                                  </td>
                                  <td v-show="(showVoucherField('supplierAddress'))" style="width: 35%">
                                    {{ item.Satici.Adres }} &nbsp;
                                    {{ item.Satici.Yer }} &nbsp;
                                    {{ item.Satici.Sehir }} &nbsp;
                                    {{ item.Satici.Ulke }}
                                  </td>
                                  <td v-show="(showVoucherField('supplierEmail'))" style="width: 15%">
                                    Email
                                  </td>
                                  <td v-show="(showVoucherField('supplierEmail'))" style="width: 35%" align="left">
                                    {{ item.Satici.Email || item.Satici.EMail || '-' }}
                                  </td>
                                </tr>
                              </table>
                            </td>
                          </tr>
                          <tr align="left">
                            <td colspan="8">
                              <table width="100%">
                                <tr v-show="(showAnyVoucherField(['counterReservationCode', 'bookedByPhone']))"
                                  colspan="8"
                                  align="center"
                                  style="
                                    padding-top: 20px;
                                    padding-bottom: 20px;
                                  "
                                >
                                  <td v-show="(showVoucherField('counterReservationCode'))"
                                    align="left"
                                    style="
                                      width: 20%;
                                      vertical-align: top;
                                      padding-top: 10px;
                                      padding-bottom: 10px;
                                    "
                                  >
                                    Gegenreservierungscode
                                  </td>
                                  <td v-show="(showVoucherField('counterReservationCode'))" style="width: 30%">
                                    {{ item.KarsiRezKodu }}
                                  </td>
                                  <td v-show="(showVoucherField('bookedByPhone'))" style="width: 20%">
                                    Telefon des Buchenden
                                  </td>
                                  <td v-show="(showVoucherField('bookedByPhone'))" style="width: 30%" align="left">
                                    {{ item.RezervasyonYapan.Telefon }}
                                  </td>
                                </tr>
                              </table>
                            </td>
                          </tr>

                          <tr>
                            <tr>
                                  <td colspan="8">
                                    <v-divider></v-divider>
                                  </td>
                            </tr>
                            <td v-show="(showAnyVoucherField(['roomOrder', 'pnrNo', 'personType', 'passengerName', 'checkInDate', 'checkOutDate', 'nightCount', 'boardRoomType']))" v-if="isOtel" colspan="8">
                              <table width="100%">
                                <tr
                                  colspan="8"
                                  align="center"
                                  style="
                                    padding-top: 20px;
                                    padding-bottom: 20px;
                                    
                                  "
                                >
                                  <td v-show="(showVoucherField('roomOrder'))" style="width: 5%">
                                    <span class="subheading">
                                      Zimmerreihe</span
                                    >
                                  </td>
                                  <td v-show="(showVoucherField('pnrNo'))" style="width: 10%">
                                    <span class="subheading">
                                      Pnr No</span
                                    >
                                  </td>
                                  <td v-show="(showVoucherField('personType'))" style="width: 10%">
                                    <span class="subheading">
                                      Person Typ </span
                                    >
                                  </td>
                                  <td v-show="(showVoucherField('passengerName'))" style="width: 20%">
                                    <span class="subheading">
                                      das Hauptwort </span
                                    >
                                  </td>
                                  <td v-show="(showVoucherField('checkInDate'))" style="width: 15%">
                                    <span class="subheading">
                                      Eintrittsdatum</span
                                    >
                                  </td>
                                  <td v-show="(showVoucherField('checkOutDate'))" style="width: 15%">
                                    <span class="subheading">
                                      Veröffentlichungsdatum </span
                                    >
                                  </td>
                                  <td v-show="(showVoucherField('nightCount'))" style="width: 5%">
                                    <span class="subheading">
                                     Nacht </span
                                    >
                                  </td>
                                  <td v-show="(showVoucherField('boardRoomType'))" style="width: 20%">
                                    <span class="subheading">
                                      Zimmertyp </span
                                    >
                                  </td>
                                </tr>
                                <tr>
                                  <td colspan="8">
                                    <v-divider></v-divider>
                                  </td>
                                </tr>
                              </table>
                            </td>
                              <td v-show="(showAnyVoucherField(['passengerName', 'passengerReservationNo', 'nationality', 'passportNumber', 'birthDate']))" v-if="isAcente" colspan="5">
                              <table width="100%">
                                <tr
                                  colspan="8"
                                  align="center"
                                  style="
                                    padding-top: 20px;
                                    padding-bottom: 20px;
                                    
                                  "
                                >
                                  <td v-show="(showVoucherField('passengerName'))" style="width: 20%">
                                    <span class="subheading">
                                      Name</span
                                    >
                                  </td>
                                  <td v-show="(showVoucherField('passengerReservationNo'))" style="width: 20%">
                                    <span class="subheading">
                                      Reservierung</span
                                    >
                                  </td>
                                  <td v-show="(showVoucherField('nationality'))" style="width: 20%">
                                    <span class="subheading">
                                      Staatsangehörigkeit </span
                                    >
                                  </td>
                                  <td v-show="(showVoucherField('passportNumber'))" style="width: 20%">
                                    <span class="subheading">
                                      Ausweisnummer </span
                                    >
                                  </td>
                                  <td v-show="(showVoucherField('birthDate'))" style="width: 20%">
                                    <span class="subheading">
                                     Geburtsdatum</span
                                    >
                                  </td>
                                </tr>
                                <tr>
                                  <td colspan="5">
                                    <v-divider></v-divider>
                                  </td>
                                </tr>
                              </table>
                            </td>
                            <td v-show="(showAnyVoucherField(['pax', 'passengerName', 'pnrNo', 'counterReservationCode']))" v-if="isRestaurant" colspan="5">
                              <table width="100%">
                                <tr
                                  colspan="8"
                                  align="center"
                                  style="
                                    padding-top: 20px;
                                    padding-bottom: 20px;
                                    
                                  "
                                >
                                  <td v-show="(showVoucherField('pax'))" style="width: 25%">
                                    <span class="subheading">
                                      Pax</span
                                    >
                                  </td>
                                  <td v-show="(showVoucherField('passengerName'))" style="width: 25%">
                                    <span class="subheading">
                                      Name</span
                                    >
                                  </td>
                                  <td v-show="(showVoucherField('pnrNo'))" style="width: 25%">
                                    <span class="subheading">
                                      Pnr No </span
                                    >
                                  </td>
                                  <td v-show="(showVoucherField('counterReservationCode'))" style="width: 25%">
                                    <span class="subheading">
                                     Gegen Res. Code </span
                                    >
                                  </td>
                                </tr>
                                <tr>
                                  <td colspan="4">
                                    <v-divider></v-divider>
                                  </td>
                                </tr>
                              </table>
                            </td>

                             <td v-show="(showAnyVoucherField(['passengerName', 'pnrNo', 'nationality', 'passportNumber', 'birthDate']))" v-if="isTransfer" colspan="8">
                              <table width="100%">
                                <tr
                                  colspan="8"
                                  align="center"
                                  style="
                                    padding-top: 20px;
                                    padding-bottom: 20px;
                                    
                                  "
                                >
                                  <td v-show="(showVoucherField('passengerName'))" style="width: 20%">
                                    <span class="subheading">
                                      Name</span
                                    >
                                  </td>
                                  <td v-show="(showVoucherField('pnrNo'))" style="width: 20%">
                                    <span class="subheading">
                                      Pnr No </span
                                    >
                                  </td>
                                  <td v-show="(showVoucherField('nationality'))" style="width: 20%">
                                    <span class="subheading">
                                      Staatsangehörigkeit </span
                                    >
                                  </td>
                                   <td v-show="(showVoucherField('passportNumber'))" style="width: 20%">
                                    <span class="subheading">
                                     Ausweisnummer </span
                                    >
                                  </td>
                                    <td v-show="(showVoucherField('birthDate'))" style="width: 20%">
                                    <span class="subheading">
                                      Geburtsdatum </span
                                    >
                                  </td>
                                </tr>
                                <tr>
                                  <td colspan="8">
                                    <v-divider></v-divider>
                                  </td>
                                </tr>
                              </table>
                            </td>

                            <td v-show="(showAnyVoucherField(['passengerName', 'vehicle', 'vehicleCategory', 'vehicleCount', 'vehicleDay']))" v-if="isRentACar" colspan="8">
                              <table width="100%">
                                <tr
                                  colspan="8"
                                  align="center"
                                  style="
                                    padding-top: 20px;
                                    padding-bottom: 20px;
                                    
                                  "
                                >
                                  <td v-show="(showVoucherField('passengerName'))" style="width: 20%">
                                    <span class="subheading">
                                      Name</span
                                    >
                                  </td>
                                  <td v-show="(showVoucherField('vehicle'))" style="width: 20%">
                                    <span class="subheading">
                                      Fahrzeug </span
                                    >
                                  </td>
                                  <td v-show="(showVoucherField('vehicleCategory'))" style="width: 20%">
                                    <span class="subheading">
                                      Kategorie </span
                                    >
                                  </td>
                                   <td v-show="(showVoucherField('vehicleCount'))" style="width: 20%">
                                    <span class="subheading">
                                      Stück </span
                                    >
                                  </td>
                                    <td v-show="(showVoucherField('vehicleDay'))" style="width: 20%">
                                    <span class="subheading">
                                      Tag </span
                                    >
                                  </td>
                                </tr>
                                <tr>
                                  <td colspan="8">
                                    <v-divider></v-divider>
                                  </td>
                                </tr>
                              </table>
                            </td>
                          </tr>

                          <tr v-show="(showAnyVoucherField(['roomOrder', 'pnrNo', 'personType', 'passengerName', 'checkInDate', 'checkOutDate', 'nightCount', 'boardRoomType']))" v-if="isOtel">
                            <td colspan="8">
                              <table
                                v-for="itemoda in item.Odalar"
                                :key="itemoda.Sira"
                                width="100%"
                              >
                                <tr
                                  v-for="itemkisi in itemoda.Kisiler"
                                  :key="itemkisi.adsoyad"
                                  colspan="8"
                                  align="center"
                                  style="
                                    padding-top: 20px;
                                    padding-bottom: 20px;
                                  "
                                >
                                  <td v-show="(showVoucherField('roomOrder'))" style="width: 5%">
                                    <span class="subheading">
                                      {{ itemoda.Sira }}</span
                                    >
                                  </td>
                                  <td v-show="(showVoucherField('pnrNo'))" style="width: 10%">
                                    <span class="subheading"> {{ pnr }}</span>
                                  </td>
                                  <td v-show="(showVoucherField('personType'))" style="width: 10%">
                                    <span class="subheading">
                                      {{ KisiTipToStr(itemkisi.kisiTip) }}
                                    </span>
                                  </td>
                                  <td v-show="(showVoucherField('passengerName'))"
                                    align="left"
                                    style="align: left; width: 20%"
                                  >
                                    <span class="subheading">
                                      {{ itemkisi.adSoyad }}</span
                                    >
                                  </td>
                                  <td v-show="(showVoucherField('checkInDate'))" style="width: 15%">
                                    <span class="subheading">
                                      {{ itemoda.Kalem.donem1 | dateformat }}</span
                                    >
                                  </td>
                                  <td v-show="(showVoucherField('checkOutDate'))" style="width: 15%">
                                    <span class="subheading">
                                      {{ itemoda.Kalem.donem2 | dateformat }}</span
                                    >
                                  </td>
                                  <td v-show="(showVoucherField('nightCount'))" style="width: 5%">
                                    <span class="subheading">
                                      {{ gunhesapla(itemoda.Kalem) }}</span
                                    >
                                  </td>
                                  <td v-show="(showVoucherField('boardRoomType'))" style="width: 20%">
                                    <span class="subheading">
                                      {{
                                        PansiyonTipToStr(
                                          itemoda.Kalem.kalemOtel.pansiyon
                                        )
                                      }}{{
                                        itemoda.Kalem.kalemOtel.odaTipi.isim
                                      }}</span
                                    >
                                  </td>
                                </tr>
                             
                              </table>
                            </td>
                          </tr>

                            <tr v-show="(showAnyVoucherField(['passengerName', 'passengerReservationNo', 'nationality', 'passportNumber', 'birthDate']))" v-if="isAcente">
                            <td colspan="5">
                              <table
                                v-for="itemoda in item.Odalar"
                                :key="itemoda.Sira"
                                width="100%"
                              >
                                <tr
                                  v-for="itemkisi in itemoda.Kisiler"
                                  :key="itemkisi.adsoyad"
                                  colspan="5"
                                  align="center"
                                  style="
                                    padding-top: 20px;
                                    padding-bottom: 20px;
                                  "
                                >
                                  <td v-show="(showVoucherField('passengerName'))" style="width: 20%">
                                    <span class="subheading">
                                      {{ itemkisi.adSoyad }} 
                                      </span>
                                  </td>
                                  <td v-show="(showVoucherField('passengerReservationNo'))" style="width: 20%">
                                    <span class="subheading"> {{ itemkisi.kod }}</span>
                                  </td>
                                  <td v-show="(showVoucherField('nationality'))" style="width: 20%">
                                    <span class="subheading">
                                       {{ itemkisi.ulke }}
                                    </span>
                                  </td>
                                  <td v-show="(showVoucherField('passportNumber'))" style="width: 20%" >
                                    <span class="subheading">
                                      {{ itemkisi.pasaportNo }}</span
                                    >
                                  </td>
                                  <td v-show="(showVoucherField('birthDate'))" style="width: 20%">
                                    <span class="subheading">
                                      {{ formatDate(itemkisi.dogumTarihi) }} </span
                                    >
                                  </td>
                                </tr>
                             
                              </table>
                            </td>
                          </tr>


                           <tr v-show="(showAnyVoucherField(['pax', 'passengerName', 'pnrNo', 'counterReservationCode']))" v-if="isRestaurant">
                            <td colspan="4"  >
                              <table
                                v-for="itemoda in item.Odalar"
                                :key="itemoda.Sira"
                                width="100%"
                              >
                                <tr
                                  v-for="itemkisi in itemoda.Kisiler"
                                  :key="itemkisi.adsoyad"
                                  colspan="5"
                                  align="center"
                                  style="
                                    padding-top: 20px;
                                    padding-bottom: 20px;
                                  "
                                >
                                  <td v-show="(showVoucherField('pax'))" style="width: 25%">
                                    <span class="subheading">
                                      {{ itemkisi.Pax }} 
                                      </span>
                                  </td>
                                  <td v-show="(showVoucherField('passengerName'))" style="width: 25%">
                                    <span class="subheading"> {{ itemkisi.adSoyad }}</span>
                                  </td>
                                  <td v-show="(showVoucherField('pnrNo'))" style="width: 25%">
                                    <span class="subheading">
                                      {{ pnr }}    
                                    </span>
                                  </td>
                                  <td v-show="(showVoucherField('counterReservationCode'))" style="width: 25%" >
                                    <span class="subheading">
                                      {{ itemoda.KarsiRezKodu }}</span
                                    >
                                  </td>
                                </tr>
                             
                              </table>
                            </td>
                          </tr> 

                         <tr v-show="(showAnyVoucherField(['passengerName', 'pnrNo', 'nationality', 'passportNumber', 'birthDate']))" v-if="isTransfer">
                            <td colspan="8">
                              <table
                                v-for="itemoda in item.Odalar"
                                :key="itemoda.Sira"
                                width="100%"
                              >
                                <tr
                                  v-for="itemkisi in itemoda.Kisiler"
                                  :key="itemkisi.adsoyad"
                                  colspan="8"
                                  align="center"
                                  style="
                                    padding-top: 20px;
                                    padding-bottom: 20px;
                                  "
                                >
                                  <td v-show="(showVoucherField('passengerName'))" style="width: 20%">
                                    <span class="subheading">
                                      {{ itemkisi.adSoyad }} 
                                      </span>
                                  </td>
                                  <td v-show="(showVoucherField('pnrNo'))" style="width: 20%">
                                    <span class="subheading"> {{ pnr }}</span>
                                  </td>
                                  <td v-show="(showVoucherField('nationality'))" style="width: 20%">
                                    <span class="subheading">
                                      {{itemkisi.ulke}}  
                                    </span>
                                  </td>
                                  <td v-show="(showVoucherField('passportNumber'))" style="width: 20%" >
                                    <span class="subheading">
                                      {{itemkisi.pasaportNo}}
                                    </span>
                                  </td>
                                  <td v-show="(showVoucherField('birthDate'))" style="width: 20%" >
                                    <span class="subheading">
                                      {{ formatDate(itemkisi.dogumTarihi)}}
                                    </span>
                                  </td>
                                </tr>
                             
                              </table>
                            </td>
                          </tr> 

                          <tr v-show="(showAnyVoucherField(['passengerName', 'vehicle', 'vehicleCategory', 'vehicleCount', 'vehicleDay']))" v-if="isRentACar">
                            <td colspan="8">
                              <table
                                v-for="itemoda in item.Odalar"
                                :key="itemoda.Sira"
                                width="100%"
                              >
                                <tr
                                  v-for="itemkisi in itemoda.Kisiler"
                                  :key="itemkisi.adsoyad"
                                  colspan="8"
                                  align="center"
                                  style="
                                    padding-top: 20px;
                                    padding-bottom: 20px;
                                  "
                                >
                                  <td v-show="(showVoucherField('passengerName'))" style="width: 20%">
                                    <span class="subheading">
                                      {{ itemkisi.adSoyad }} 
                                      </span>
                                  </td>
                                  <td v-show="(showVoucherField('vehicle'))" style="width: 20%">
                                    <span class="subheading"> {{itemoda.Kalem.baseKalem.arac}} </span>
                                  </td>
                                  <td v-show="(showVoucherField('vehicleCategory'))" style="width: 20%">
                                    <span class="subheading">
                                      {{itemoda.Kalem.baseKalem.kategori}}
                                    </span>
                                  </td>
                                  <td v-show="(showVoucherField('vehicleCount'))" style="width: 20%" >
                                    <span class="subheading">
                                      {{itemoda.Kalem.baseKalem.aracAdet}} 
                                    </span>
                                  </td>
                                  <td v-show="(showVoucherField('vehicleDay'))" style="width: 20%" >
                                    <span class="subheading">
                                      {{itemoda.Kalem.baseKalem.gun}} 
                                    </span>
                                  </td>
                                </tr>
                             
                              </table>
                            </td>
                          </tr> 

                          <tr>
                            <td v-show="(showAnyVoucherField(['totalPax', 'totalRoom']))" v-if="isOtel" colspan="4">
                              <table align="left" width="100%">
                                <tr
                                  align="left"
                                  style="
                                    padding-top: 15px;
                                    padding-bottom: 15px;
                                  "
                                >
                                  <td v-show="(showVoucherField('totalPax'))" colspan="2">
                                    <span class="subheading">
                                      Gesamtzahl der Passagiere : {{ item.ToplamPax }}</span
                                    >
                                  </td>
                                </tr>
                                <tr
                                  colspan="8"
                                  align="left"
                                  style="
                                    padding-top: 20px;
                                    padding-bottom: 20px;
                                  "
                                >
                                  <td v-show="(showVoucherField('totalRoom'))" colspan="2">
                                    <span class="subheading">
                                      Nombre total de chambres : {{ toplamOdaText }}
                                    </span>
                                  </td>
                                </tr>
                              </table>
                            </td>
                               <td v-show="(showAnyVoucherField(['totalPax', 'tourType', 'meetingDate', 'tourKind', 'meetingTime', 'tourDuration', 'meetingPlace', 'tourGuide', 'shipName', 'entrancesIncluded', 'returnInfo', 'mealsIncluded']))" colspan="5" v-if="isAcente">
                              <table align="left" width="100%">
                                <tr
                                  style="
                                    padding-top: 15px;
                                    padding-bottom: 15px;
                                  "
                                >
                                  <td v-show="(showVoucherField('totalPax'))" colspan="2">
                                    <span class="subheading">
                                      Gesamt Pax : {{ item.ToplamPax }}</span
                                    >
                                  </td>
                                  <td v-show="(showVoucherField('tourType'))" colspan="2">
                                    <span class="subheading">
                                      Tourtyp : {{ getTurTipi(item.Odalar[0].Kalem.kalemAcente.TurTipi) }} </span
                                    >
                                  </td>
                                </tr>
                                 <tr
                                  style="
                                    padding-top: 15px;
                                    padding-bottom: 15px;
                                  "
                                >
                                  <td v-show="(showVoucherField('meetingDate'))" colspan="2">
                                    <span class="subheading">
                                      Datum des Treffens : {{ item.Odalar[0].Kalem.kalemAcente.BulusmaTarihi | dateformat }} </span
                                    >
                                  </td>
                                  <td v-show="(showVoucherField('tourKind'))" colspan="2">
                                    <span class="subheading">
                                      Tourtyp : {{ getTurTuru(item.Odalar[0].Kalem.kalemAcente.TurTuru) }}</span
                                    >
                                  </td>
                                </tr>
                                <tr
                                  style="
                                    padding-top: 15px;
                                    padding-bottom: 15px;
                                  "
                                >
                                  <td v-show="(showVoucherField('meetingTime'))" colspan="2">
                                    <span class="subheading">
                                      Verabredungszeitpunkt : {{ item.Odalar[0].Kalem.kalemAcente.Saat | timeformat }} </span
                                    >
                                  </td>
                                  <td v-show="(showVoucherField('tourDuration'))" colspan="2">
                                    <span class="subheading">
                                     Rundendauer :  </span 
                                    >
                                    <!-- {{ getTurTuru(item.Odalar[0].Kalem.kalemAcente.Tip) }} -->
                                  </td>
                                </tr>
                                <tr
                                  style="
                                    padding-top: 15px;
                                    padding-bottom: 15px;
                                  "
                                >
                                  <td v-show="(showVoucherField('meetingPlace'))" colspan="2">
                                    <span class="subheading">
                                      Treffpunkt : {{ item.Odalar[0].Kalem.kalemAcente.BulusmaYeri }}</span
                                    >
                                  </td>
                                  <td v-show="(showVoucherField('tourGuide'))" colspan="2">
                                    <span class="subheading">
                                      Der Reiseleiter : {{ item.Odalar[0].Kalem.kalemAcente.Rehber.isim }} </span
                                    >
                                  </td>
                                </tr>
                                <tr
                                  style="
                                    padding-top: 15px;
                                    padding-bottom: 15px;
                                  "
                                >
                                  <td v-show="(showVoucherField('shipName'))" colspan="2">
                                    <span class="subheading">
                                      Schiffsname : {{ item.Odalar[0].Kalem.kalemAcente.Gemi.isim }}</span
                                    >
                                  </td>
                                  <td v-show="(showVoucherField('entrancesIncluded'))" colspan="2">
                                    <span class="subheading">
                                     Einträge enthalten : {{ checkItemsList(item.Odalar[0].Kalem.kalemAcente.Girisler)  }}  </span
                                    >
                                  </td>
                                </tr>
                                <tr
                                  style="
                                    padding-top: 15px;
                                    padding-bottom: 15px;
                                  "
                                >
                                  <td v-show="(showVoucherField('returnInfo'))" colspan="2" style="max-width:100px;">
                                    <span class="subheading">
                                      Rücksendeinformationen : {{ item.Odalar[0].Kalem.kalemAcente.DonusBilgisi }}</span
                                    >
                                  </td>
                                  <td v-show="(showVoucherField('mealsIncluded'))" colspan="2">
                                    <span class="subheading">
                                      Mahlzeiten inbegriffen : {{ checkItemsList(item.Odalar[0].Kalem.kalemAcente.OgleYemegi) }}  </span
                                    >
                                  </td>
                                </tr>
                              
                              </table>
                            </td>
                            <td v-show="(showAnyVoucherField(['totalPax', 'restaurantMenu']))" colspan="4" v-if="isRestaurant">
                              <table align="left" width="100%">
                                <tr
                                  align="left"
                                  style="
                                    padding-top: 15px;
                                    padding-bottom: 15px;
                                  "
                                >
                                  <td v-show="(showVoucherField('totalPax'))" colspan="4">
                                    <span class="subheading">
                                      Gesamt Pax : {{ item.ToplamPax }}</span
                                    >
                                  </td>
                                </tr>
                                <tr v-show="(showVoucherField('restaurantMenu'))"
                                  colspan="4"
                                  align="left"
                                  style="
                                    padding-top: 20px;
                                    padding-bottom: 20px;
                                  "
                                  v-for="itemMenu in item.Satici.stRestaurant.Menu"
                                  :key="itemMenu.Kod"
                                >
                                  <td colspan="4"       
                                  >
                                    <span class="subheading">
                                      {{ itemMenu.Kod }}  : {{ itemMenu.Menu }}
                                    </span>
                                  </td>
                                </tr>
                         
                              </table>
                            </td>
                            <td v-show="(showAnyVoucherField(['departureDate', 'departureTime', 'arrivalDeparture', 'flightNumber', 'flightTime', 'departurePlace', 'destination', 'vehicle']))" colspan="8" v-if="isTransfer">
                             
                              <table align="left" width="100%">
                                   <tr>
                                  <td colspan="8">
                                    <v-divider></v-divider>
                                  </td>
                                </tr>
                                  <tr>
                            <td v-show="(showAnyVoucherField(['departureDate', 'departureTime', 'arrivalDeparture', 'flightNumber', 'flightTime', 'departurePlace', 'destination', 'vehicle']))" v-if="isTransfer" colspan="8">
                              <table width="100%">
                                <tr
                                  colspan="8"
                                  align="center"
                                  style="
                                    padding-top: 20px;
                                    padding-bottom: 20px;
                                    
                                  "
                                >
                                  <td v-show="(showVoucherField('departureDate'))" style="width: 15%">
                                    <span class="subheading">
                                      Abreisedatum</span
                                    >
                                  </td>
                                  <td v-show="(showVoucherField('departureTime'))" style="width: 10%">
                                    <span class="subheading">
                                      Abfahrtszeit </span
                                    >
                                  </td>
                                  <td v-show="(showVoucherField('arrivalDeparture'))" style="width: 5%">
                                    <span class="subheading">
                                      A/D </span
                                    >
                                  </td>
                                   <td v-show="(showVoucherField('flightNumber'))" style="width: 10%">
                                    <span class="subheading">
                                      Flugnummer </span
                                    >
                                  </td>
                                    <td v-show="(showVoucherField('flightTime'))" style="width: 10%">
                                    <span class="subheading">
                                      Flugzeit </span
                                    >
                                  </td>
                                   <td v-show="(showVoucherField('departurePlace'))" style="width: 15%">
                                    <span class="subheading">
                                      Ort der Handlung </span
                                    >
                                  </td>
                                   <td v-show="(showVoucherField('destination'))" style="width: 15%">
                                    <span class="subheading">
                                      Ziel </span
                                    >
                                  </td>
                                   <td v-show="(showVoucherField('vehicle'))" style="width: 20%">
                                    <span class="subheading">
                                      Fahrzeug </span
                                    >
                                  </td>
                                </tr>
                                <tr>
                                  <td colspan="8">
                                    <v-divider></v-divider>
                                  </td>
                                </tr>
                              </table>
                            </td>
                                  </tr>
                                  <tr >
                               <td colspan="8">
                                 <table
                                   v-for="itemoda in item.Odalar"
                                   :key="itemoda.Sira"
                                   width="100%"
                                 >
                                   <tr
                                     v-for="itemkisi in itemoda.Kisiler"
                                     :key="itemkisi.adsoyad"
                                     colspan="5"
                                     align="center"
                                     style="
                                       padding-top: 20px;
                                       padding-bottom: 20px;
                                     "
                                   >
                                     <td v-show="(showVoucherField('departureDate'))" style="width: 15%">
                                       <span class="subheading">
                                         {{ itemoda.Kalem.donem1 | dateformat }} 
                                          
                                         </span>
                                     </td>
                                     <td v-show="(showVoucherField('departureTime'))" style="width: 10%">
                                       <span class="subheading"> {{ itemoda.Kalem.kalemArac.seferSaat | timeformat }} </span>
                                     </td>
                                     <td v-show="(showVoucherField('arrivalDeparture'))" style="width: 5%">
                                       <span class="subheading">
                                         {{ itemoda.Kalem.baseKalem.ADT }}
                                       </span>
                                     </td>
                                     <td v-show="(showVoucherField('flightNumber'))" style="width: 10%" >
                                       <span class="subheading">
                                        {{ itemoda.Kalem.baseKalem.ucusNo }}
                                       </span>
                                     </td>
                                     <td v-show="(showVoucherField('flightTime'))" style="width: 10%" >
                                       <span class="subheading">
                                         {{ itemoda.Kalem.baseKalem.ucusSaat | timeformat }}
                                       </span>
                                     </td>
                                     <td v-show="(showVoucherField('departurePlace'))" style="width: 15%" >
                                       <span class="subheading">
                                         {{ itemoda.Kalem.baseKalem.nerden }}
                                       </span>
                                     </td>
                                     <td v-show="(showVoucherField('destination'))" style="width: 15%" >
                                       <span class="subheading">
                                         {{ itemoda.Kalem.baseKalem.nereye }}
                                       </span>
                                     </td>
                                      <td v-show="(showVoucherField('vehicle'))" style="width: 20%" >
                                       <span class="subheading">
                                         {{ itemoda.Kalem.baseKalem.arac }}
                                       </span>
                                     </td>
                                   </tr>

                                 </table>
                                </td>
                               </tr> 
                      
                              </table>
                            </td>

                            <td v-show="(showAnyVoucherField(['pickupReturnInfo', 'extraServices']))" colspan="8" v-if="isRentACar">
                              <table align="left" width="100%">
                                <tr>
                                  <td colspan="8">
                                    <v-divider></v-divider>
                                  </td>
                                </tr>
                                <tr>
                                  <td  colspan="8">
                                    <table v-show="(showVoucherField('pickupReturnInfo'))" width="100%">
                                <tr>
                                  <th style="width: 10%"> </th>
                                  <th style="width: 30%">Geschichte </th>
                                  <th style="width: 30%">Stunde </th>
                                  <th style="width: 30%">Ort </th>
                                </tr>
                                   <tr
                                   v-for="itemoda in item.Odalar"
                                   :key="itemoda.Sira"
                                     colspan="5"
                                     align="center"
                                     style="
                                       padding-top: 20px;
                                       padding-bottom: 20px;
                                     "
                                   >
                                     <td style="width: 20%">
                                       <span class="subheading">
                                         Informationen zum Kauf
                                         </span>
                                     </td> 
                                     <td style="width: 10%">
                                       <span class="subheading"> {{ itemoda.Kalem.baseKalem.alisTarih | dateformat }} </span>
                                     </td>
                                     <td style="width: 5%">
                                       <span class="subheading">
                                         {{ itemoda.Kalem.baseKalem.alisSaat | timeformat }}
                                       </span>
                                     </td>
                                     <td style="width: 10%" >
                                       <span class="subheading">
                                         {{ itemoda.Kalem.baseKalem.alisYeri }}
                                       </span>
                                     </td>
                                   </tr>
                                      <tr
                                   v-for="itemoda in item.Odalar"
                                   :key="itemoda.Sira"
                                     colspan="5"
                                     align="center"
                                     style="
                                       padding-top: 20px;
                                       padding-bottom: 20px;
                                     "
                                   >
                                     <td style="width: 10%">
                                       <span class="subheading">
                                        Drop-Informationen
                                         </span>
                                     </td> 
                                     <td style="width: 30%">
                                       <span class="subheading"> {{ itemoda.Kalem.baseKalem.musteriTeslimTarihi | dateformat }} </span>
                                     </td>
                                     <td style="width: 30%">
                                       <span class="subheading">
                                         {{ itemoda.Kalem.baseKalem.teslimSaat | timeformat }}
                                       </span>
                                     </td>
                                     <td style="width: 30%" >
                                       <span class="subheading">
                                         {{ itemoda.Kalem.baseKalem.teslimYeri }}
                                       </span>
                                     </td>
                                   </tr>
                                    </table>
                                  </td>
                                </tr>
                                <tr>
                                  <td colspan="8">
                                    <v-divider></v-divider>
                                  </td>
                                </tr>
                                 <tr v-show="(showVoucherField('extraServices'))" style="padding-top: 50px">

                            <td colspan="8" >
                              <table width="100%">
                                <tr>
                                  <th style="width: 100%" colspan="4">Ek Hizmetler </th>
                                  
                                </tr>
                                   <tr
                                     align="left"
                                     style="
                                       padding-top: 20px;
                                       padding-bottom: 20px;
                                     "
                                   >
                                     <td style="width: 40%" >
                                     <tr>
                                       <td>
                                          <span class="subheading">
                                         Drop  
                                         </span>
                                       </td>
                                       <td>
                                         : {{ checkTrueFalse(item.Odalar[0].Kalem.baseKalem.checkDropUcreti) }}
                                       </td>
                                     </tr>

                                     <tr>
                                       <td>
                                          <span class="subheading">
                                         Otomatik Vites  
                                         </span>
                                       </td>
                                       <td>
                                         : {{ checkTrueFalse(item.Odalar[0].Kalem.baseKalem.checkOtomatikVites) }}
                                       </td>
                                     </tr>

                                    <tr>
                                       <td>
                                          <span class="subheading">
                                         İptal Sigortası
                                         </span>
                                       </td>
                                       <td>
                                         : {{ checkTrueFalse(item.Odalar[0].Kalem.baseKalem.checkIptalSigortasi) }}
                                       </td>
                                     </tr>
                                    </td>


                                    <td style="width: 40%">
                                     <tr>
                                       <td>
                                          <span class="subheading">
                                         Bebek Koltuğu  
                                         </span>
                                       </td>
                                       <td>
                                         : {{ checkTrueFalse(item.Odalar[0].Kalem.baseKalem.checkBebekKoltugu) }}
                                       </td>
                                     </tr>

                                     <tr>
                                       <td>
                                          <span class="subheading">
                                         Klima  
                                         </span>
                                       </td>
                                       <td>
                                         : {{ checkTrueFalse(item.Odalar[0].Kalem.baseKalem.checkKlima) }}
                                       </td>
                                     </tr>

                                    <tr>
                                       <td>
                                          <span class="subheading">
                                         Navigasyon
                                         </span>
                                       </td>
                                       <td>
                                         : {{ checkTrueFalse(item.Odalar[0].Kalem.baseKalem.checkNavigation) }}
                                       </td>
                                     </tr>
                                    </td>

                                    <td style="width: 20%">
                                     <tr>
                                       <td>
                                          <span class="subheading">
                                         Çocuk Koltuğu  
                                         </span>
                                       </td>
                                       <td>
                                         : {{ checkTrueFalse(item.Odalar[0].Kalem.baseKalem.checkCocukKoltugu) }}
                                       </td>
                                     </tr>

                                     <tr>
                                       <td>
                                          <span class="subheading">
                                         Temizlik  
                                         </span>
                                       </td>
                                       <td>
                                         : {{ checkTrueFalse(item.Odalar[0].Kalem.baseKalem.checkTemizlik) }}
                                       </td>
                                     </tr>

                                    <tr>
                                       <td>
                                          <span class="subheading">
                                         Diğer
                                         </span>
                                       </td>
                                       <td>
                                         : {{ checkTrueFalse(item.Odalar[0].Kalem.baseKalem.checkDiger) }}
                                       </td>
                                     </tr>
                                    </td>

                                   </tr>
                                     
                              </table>
                            </td>
                            </tr>
                              </table>
                            </td>
                          </tr>

                          <tr v-show="(showVoucherField('note'))" style="height: 100%; padding-top: 50px">
                            <td
                              colspan="4"
                              align="center"
                              style="padding-top: 10px; padding-bottom: 10px"
                            >
                            <v-divider></v-divider>
                              <span class="title pt-2 pb-2">
                                STORNIERUNG, NO SHOW UND VORZEITIGES EXIT-VERFAHREN
                              </span>
                            <v-divider></v-divider>
                            </td>
                          </tr>
                          <tr v-show="(showVoucherField('note'))">
                            <td
                              colspan="4"
                              width="100%"
                              style="
                                vertical-align: top;
                                padding-top: 5px;
                                padding-bottom: 5px;
                              "
                            >
                              <v-layout id="skip3" justify-end>
                                <v-btn
                                  color="info"
                                  flat
                                  @click="aciklamaDialogOpen('NOT')"
                                >
                                  <v-icon small>edit</v-icon> &nbsp; {{ $t('Edit-Note') }}
                                </v-btn>
                              </v-layout>
                              {{ selectedVoucherItems.Aciklamalar.Not }}
                            </td>
                          </tr>

                          <tr v-show="(showVoucherField('terms'))" style="height: 100%">
                            <td
                              colspan="4"
                              align="center"
                              style="padding-top: 5px; padding-bottom: 5px"
                            >
                              <v-divider></v-divider>
                              <span class="title">
                               GESCHÄFTSBEDINGUNGEN
                              </span>
                              <v-divider></v-divider>
                            </td>
                          </tr>
                          <tr v-show="(showVoucherField('terms'))">
                            <td
                              colspan="4"
                              width="100%"
                              style="
                                vertical-align: top;
                                padding-top: 10px;
                                padding-bottom: 10px;
                              "
                            >
                              <span style="text-align: center">
                                <v-layout id="skip2" justify-end>
                                  <v-btn
                                    color="info"
                                    flat
                                    @click="aciklamaDialogOpen('ACIKLAMA1')"
                                  >
                                    <v-icon small>edit</v-icon> &nbsp; {{ $t('Edit-Description1') }}
                                    
                                  </v-btn>
                                </v-layout>
                                {{ selectedVoucherItems.Aciklamalar.Aciklama1 }}
                                <br />
                                <v-layout id="skip" justify-end>
                                  <v-btn
                                    color="info"
                                    flat
                                    @click="aciklamaDialogOpen('ACIKLAMA2')"
                                  >
                                    <v-icon small>edit</v-icon> &nbsp; {{ $t('Edit-Description2') }}
                                    
                                  </v-btn>
                                </v-layout>
                                {{ selectedVoucherItems.Aciklamalar.Aciklama2 }}
                              </span>
                            </td>
                          </tr>
                          <tr></tr>

                          <tr v-show="(showAnyVoucherField(['companyInfo', 'bookedByInfo']))" pt-5 style="margin-top: 10px">
                            <td colspan="4">
                              <table width="100%">
                                <tr>
                                  <td v-show="(showVoucherField('companyInfo'))">
                                    
                                    {{
                                      voucherDisplayCompanyName
                                    }}
                                  </td>
                                  <td v-show="(showVoucherField('bookedByInfo'))">Bucher;</td>
                                </tr>
                                <tr>
                                  <td v-show="(showVoucherField('companyInfo'))">
                                    {{
                                      selectedVoucherItems.SirketBilgileri.SirketAdres1
                                    }}
                                  </td>
                                  <td v-show="(showVoucherField('bookedByInfo'))">
                                    Name und Nachname : &nbsp;
                                    {{ item.RezervasyonYapan.Isim }}
                                  </td>
                                </tr>
                                <tr>
                                  <td v-show="(showVoucherField('companyInfo'))">
                                    {{
                                      selectedVoucherItems.SirketBilgileri.SirketAdres2
                                    }}
                                  </td>
                                  <td v-show="(showVoucherField('bookedByInfo'))">
                                    Email :
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    {{ item.RezervasyonYapan.EMail }}
                                  </td>
                                </tr>
                                <tr>
                                  <td v-show="(showVoucherField('companyInfo'))">
                                    {{
                                      selectedVoucherItems.SirketBilgileri.SirketTelefon
                                    }}
                                  </td>
                                  <td v-show="(showVoucherField('bookedByInfo'))">
                                    Telefon : &nbsp;&nbsp;
                                    {{ item.RezervasyonYapan.Telefon }}
                                  </td>
                                </tr>
                                <tr>
                                  <td v-show="(showVoucherField('companyInfo'))">
                                    {{
                                      selectedVoucherItems.SirketBilgileri.SirketFaks
                                    }}
                                  </td>
                                  <td v-show="(showVoucherField('bookedByInfo'))">
                                    Agentur : &nbsp;&nbsp;&nbsp;
                                    {{ item.RezervasyonYapan.Acente }}
                                  </td>
                                </tr>
                              </table>
                            </td>

                            <td></td>
                          </tr>

                          <tr v-show="(showVoucherField('printDate'))">
                            <td colspan="8">
                              <span class="grey--text caption">
                                {{ getDateNow() | dateformat }}
                                {{ getdatetimenow() }}</span
                              >
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div v-show="(showVoucherField('lowerLogo'))" id="imgAlt"></div>
                            </td>
                          </tr>
                        </thead>
                      </table>
                    </div>
                  </v-flex>
                </v-layout>
              </v-card>
            </v-flex>


            <v-flex xs12 pa-2 sm10 v-if="locale == 'fr' && vouchergoster">
              <v-card flat>
                <v-layout justify-end row wrap>
                  <v-flex xs12 pa-3 sm12>
                    <div id="printJS-form" class="voucher-print-container">
                      <table
                        style="page-break-after: always"
                        v-for="item in selectedVoucherItems.Sayfalar"
                        :key="item.id"
                        width="100%"
                      >
                        <thead
                          v-if="item.Satici.Kod.trim() == secilenSaticiKod.trim()"
                          class="print"
                        >
                          <tr>
                            <td colspan="8">
                              <table width="100%">
                                <tr
                                  colspan="8"
                                  align="center"
                                  style="
                                    padding-top: 20px;
                                    padding-bottom: 20px;
                                  "
                                >
                                  <td v-show="(showVoucherField('upperLogo'))"
                                    align="left"
                                    style="
                                      width: 100%;
                                      vertical-align: top;
                                      padding-top: 10px;
                                      padding-bottom: 10px;
                                    "
                                    id="imgUst"
                                  ></td>
                                </tr>
                              </table>
                            </td>
                          </tr>
                          <tr>
                            <td v-show="(showVoucherField('voucherTitle'))"
                              colspan="10"
                              align="center"
                              style="padding-top: 10px; padding-bottom: 10px"
                            >
                              <span v-if="isOtel" class="black--text title">
                                Voucher Hotel</span
                              >
                               <span v-if="isAcente" class="black--text title">
                                BON D'AGENT </span
                              >
                              <span v-if="isRestaurant" class="black--text title">
                                BON RESTAURANT </span
                              >
                              <span v-if="isTransfer" class="black--text title">
                                BON DE TRANSFERT </span
                              >
                               <span v-if="isRentACar" class="black--text title">
                                BON DE LOCATION DE VOITURE </span
                              >
                            </td>
                          </tr>
                          <tr align="left">
                            <td colspan="8">
                              <table width="100%">
                                <tr v-show="(showAnyVoucherField(['supplierName', 'supplierPhone']))"
                                  colspan="8"
                                  align="center"
                                  style="
                                    padding-top: 20px;
                                    padding-bottom: 20px;
                                  "
                                >
                                  <td v-show="(showVoucherField('supplierName'))"
                                    align="left"
                                    style="
                                      width: 15%;
                                      vertical-align: top;
                                      padding-top: 10px;
                                      padding-bottom: 10px;
                                    "
                                  >
                                    Nom de l'entreprise
                                  </td>

                                  <td v-show="(showVoucherField('supplierName'))" style="width: 35%">
                                    {{ item.Satici.Isim }}
                                  </td>

                                  <td v-show="(showVoucherField('supplierPhone'))" style="width: 15%">Téléphone</td>

                                  <td v-show="(showVoucherField('supplierPhone'))" style="width: 35%" align="left">
                                    {{ item.Satici.Tel1 }} /
                                    {{ item.Satici.Tel2 }}
                                  </td>
                                </tr>
                              </table>
                            </td>
                          </tr>
                          <tr align="left">
                            <td colspan="8">
                              <table width="100%">
                                <tr v-show="(showAnyVoucherField(['supplierAddress', 'supplierEmail']))"
                                  colspan="8"
                                  align="center"
                                  style="
                                    padding-top: 20px;
                                    padding-bottom: 20px;
                                  "
                                >
                                  <td v-show="(showVoucherField('supplierAddress'))"
                                    align="left"
                                    style="
                                      width: 15%;
                                      vertical-align: top;
                                      padding-top: 10px;
                                      padding-bottom: 10px;
                                    "
                                  >
                                    Adresse de la société
                                  </td>
                                  <td v-show="(showVoucherField('supplierAddress'))" style="width: 35%">
                                    {{ item.Satici.Adres }} &nbsp;
                                    {{ item.Satici.Yer }} &nbsp;
                                    {{ item.Satici.Sehir }} &nbsp;
                                    {{ item.Satici.Ulke }}
                                  </td>
                                  <td v-show="(showVoucherField('supplierEmail'))" style="width: 15%">
                                    Email
                                  </td>
                                  <td v-show="(showVoucherField('supplierEmail'))" style="width: 35%" align="left">
                                    {{ item.Satici.Email || item.Satici.EMail || '-' }}
                                  </td>
                                </tr>
                              </table>
                            </td>
                          </tr>
<tr align="left">
                            <td colspan="10">
                              <table width="100%">
                                <tr v-show="(showAnyVoucherField(['counterReservationCode', 'bookedByPhone']))"
                                  colspan="8"
                                  align="center"
                                  style="
                                    padding-top: 20px;
                                    padding-bottom: 20px;
                                  "
                                >
                                  <td v-show="(showVoucherField('counterReservationCode'))"
                                    align="left"
                                    style="
                                      width: 20%;
                                      vertical-align: top;
                                      padding-top: 10px;
                                      padding-bottom: 10px;
                                    "
                                  >
                                   Code de réservation au comptoir
                                  </td>
                                  <td v-show="(showVoucherField('counterReservationCode'))" style="width: 30%">
                                    {{ item.KarsiRezKodu }} 
                                  </td>
                                  <td v-show="(showVoucherField('bookedByPhone'))" style="width: 20%">
                                    Numéro de téléphone pour les réservations :
                                  </td>
                                  <td v-show="(showVoucherField('bookedByPhone'))" style="width: 30%" align="left">
                                    {{ item.RezervasyonYapan.Telefon }} 
                                  </td>
                                </tr>
   
                              </table>
                            </td>
                          </tr>
                          <tr>
                            <tr>
                                  <td colspan="8">
                                    <v-divider></v-divider>
                                  </td>
                            </tr>
                            <td v-show="(showAnyVoucherField(['roomOrder', 'pnrNo', 'personType', 'passengerName', 'checkInDate', 'checkOutDate', 'nightCount', 'boardRoomType']))" v-if="isOtel" colspan="8">
                              <table width="100%">
                                <tr
                                  colspan="8"
                                  align="center"
                                  style="
                                    padding-top: 20px;
                                    padding-bottom: 20px;
                                    
                                  "
                                >
                                  <td v-show="(showVoucherField('roomOrder'))" style="width: 5%">
                                    <span class="subheading">
                                      Chambre en rangée</span
                                    >
                                  </td>
                                  <td v-show="(showVoucherField('pnrNo'))" style="width: 10%">
                                    <span class="subheading">
                                      Pnr No</span
                                    >
                                  </td>
                                  <td v-show="(showVoucherField('personType'))" style="width: 10%">
                                    <span class="subheading">
                                      Type de personne </span
                                    >
                                  </td>
                                  <td v-show="(showVoucherField('passengerName'))" style="width: 20%">
                                    <span class="subheading">
                                      Nom </span
                                    >
                                  </td>
                                  <td v-show="(showVoucherField('checkInDate'))" style="width: 15%">
                                    <span class="subheading">
                                      Date d'entrée</span
                                    >
                                  </td>
                                  <td v-show="(showVoucherField('checkOutDate'))" style="width: 15%">
                                    <span class="subheading">
                                      Date de sortie </span
                                    >
                                  </td>
                                  <td v-show="(showVoucherField('nightCount'))" style="width: 5%">
                                    <span class="subheading">
                                      Nuit </span
                                    >
                                  </td>
                                  <td v-show="(showVoucherField('boardRoomType'))" style="width: 20%">
                                    <span class="subheading">
                                      Type de chambre </span
                                    >
                                  </td>
                                </tr>
                                <tr>
                                  <td colspan="8">
                                    <v-divider></v-divider>
                                  </td>
                                </tr>
                              </table>
                            </td>

                             <td v-show="(showAnyVoucherField(['passengerName', 'passengerReservationNo', 'nationality', 'passportNumber', 'birthDate']))" v-if="isAcente" colspan="5">
                              <table width="100%">
                                <tr
                                  colspan="8"
                                  align="center"
                                  style="
                                    padding-top: 20px;
                                    padding-bottom: 20px;
                                    
                                  "
                                >
                                  <td v-show="(showVoucherField('passengerName'))" style="width: 20%">
                                    <span class="subheading">
                                      Nom</span
                                    >
                                  </td>
                                  <td v-show="(showVoucherField('passengerReservationNo'))" style="width: 20%">
                                    <span class="subheading">
                                      Réservation</span
                                    >
                                  </td>
                                  <td v-show="(showVoucherField('nationality'))" style="width: 20%">
                                    <span class="subheading">
                                      nationalité </span
                                    >
                                  </td>
                                  <td v-show="(showVoucherField('passportNumber'))" style="width: 20%">
                                    <span class="subheading">
                                      Numéro de passeport </span
                                    >
                                  </td>
                                  <td v-show="(showVoucherField('birthDate'))" style="width: 20%">
                                    <span class="subheading">
                                      Date de naissance</span
                                    >
                                  </td>
                                </tr>
                                <tr>
                                  <td colspan="5">
                                    <v-divider></v-divider>
                                  </td>
                                </tr>
                              </table>
                            </td>
                            <td v-show="(showAnyVoucherField(['pax', 'passengerName', 'pnrNo', 'counterReservationCode']))" v-if="isRestaurant" colspan="5">
                              <table width="100%">
                                <tr
                                  colspan="8"
                                  align="center"
                                  style="
                                    padding-top: 20px;
                                    padding-bottom: 20px;
                                    
                                  "
                                >
                                  <td v-show="(showVoucherField('pax'))" style="width: 25%">
                                    <span class="subheading">
                                      Pax</span
                                    >
                                  </td>
                                  <td v-show="(showVoucherField('passengerName'))" style="width: 25%">
                                    <span class="subheading">
                                      Nom</span
                                    >
                                  </td>
                                  <td v-show="(showVoucherField('pnrNo'))" style="width: 25%">
                                    <span class="subheading">
                                      Pnr No </span
                                    >
                                  </td>
                                  <td v-show="(showVoucherField('counterReservationCode'))" style="width: 25%">
                                    <span class="subheading">
                                     Contre Rés. Code </span
                                    >
                                  </td>
                                </tr>
                                <tr>
                                  <td colspan="4">
                                    <v-divider></v-divider>
                                  </td>
                                </tr>
                              </table>
                            </td>

                             <td v-show="(showAnyVoucherField(['passengerName', 'pnrNo', 'nationality', 'passportNumber', 'birthDate']))" v-if="isTransfer" colspan="8">
                              <table width="100%">
                                <tr
                                  colspan="8"
                                  align="center"
                                  style="
                                    padding-top: 20px;
                                    padding-bottom: 20px;
                                    
                                  "
                                >
                                  <td v-show="(showVoucherField('passengerName'))" style="width: 20%">
                                    <span class="subheading">
                                      Nom</span
                                    >
                                  </td>
                                  <td v-show="(showVoucherField('pnrNo'))" style="width: 20%">
                                    <span class="subheading">
                                      Pnr No </span
                                    >
                                  </td>
                                  <td v-show="(showVoucherField('nationality'))" style="width: 20%">
                                    <span class="subheading">
                                      nationalité </span
                                    >
                                  </td>
                                   <td v-show="(showVoucherField('passportNumber'))" style="width: 20%">
                                    <span class="subheading">
                                      Numéro de passeport </span
                                    >
                                  </td>
                                    <td v-show="(showVoucherField('birthDate'))" style="width: 20%">
                                    <span class="subheading">
                                      Date de naissance </span
                                    >
                                  </td>
                                </tr>
                                <tr>
                                  <td colspan="8">
                                    <v-divider></v-divider>
                                  </td>
                                </tr>
                              </table>
                            </td>

                            <td v-show="(showAnyVoucherField(['passengerName', 'vehicle', 'vehicleCategory', 'vehicleCount', 'vehicleDay']))" v-if="isRentACar" colspan="8">
                              <table width="100%">
                                <tr
                                  colspan="8"
                                  align="center"
                                  style="
                                    padding-top: 20px;
                                    padding-bottom: 20px;
                                    
                                  "
                                >
                                  <td v-show="(showVoucherField('passengerName'))" style="width: 20%">
                                    <span class="subheading">
                                      Nom</span
                                    >
                                  </td>
                                  <td v-show="(showVoucherField('vehicle'))" style="width: 20%">
                                    <span class="subheading">
                                      Véhicule </span
                                    >
                                  </td>
                                  <td v-show="(showVoucherField('vehicleCategory'))" style="width: 20%">
                                    <span class="subheading">
                                      Catégorie </span
                                    >
                                  </td>
                                   <td v-show="(showVoucherField('vehicleCount'))" style="width: 20%">
                                    <span class="subheading">
                                      Pièce </span
                                    >
                                  </td>
                                    <td v-show="(showVoucherField('vehicleDay'))" style="width: 20%">
                                    <span class="subheading">
                                      Jour </span
                                    >
                                  </td>
                                </tr>
                                <tr>
                                  <td colspan="8">
                                    <v-divider></v-divider>
                                  </td>
                                </tr>
                              </table>
                            </td>

                          </tr>

                          <tr v-show="(showAnyVoucherField(['roomOrder', 'pnrNo', 'personType', 'passengerName', 'checkInDate', 'checkOutDate', 'nightCount', 'boardRoomType']))" v-if="isOtel">
                            <td colspan="8">
                              <table
                                v-for="itemoda in item.Odalar"
                                :key="itemoda.Sira"
                                width="100%"
                              >
                                <tr
                                  v-for="itemkisi in itemoda.Kisiler"
                                  :key="itemkisi.adsoyad"
                                  colspan="8"
                                  align="center"
                                  style="
                                    padding-top: 20px;
                                    padding-bottom: 20px;
                                  "
                                >
                                  <td v-show="(showVoucherField('roomOrder'))" style="width: 5%">
                                    <span class="subheading">
                                      {{ itemoda.Sira }}</span
                                    >
                                  </td>
                                  <td v-show="(showVoucherField('pnrNo'))" style="width: 10%">
                                    <span class="subheading"> {{ pnr }}</span>
                                  </td>
                                  <td v-show="(showVoucherField('personType'))" style="width: 10%">
                                    <span class="subheading">
                                      {{ KisiTipToStr(itemkisi.kisiTip) }}
                                    </span>
                                  </td>
                                  <td v-show="(showVoucherField('passengerName'))"
                                    align="left"
                                    style="align: left; width: 20%"
                                  >
                                    <span class="subheading">
                                      {{ itemkisi.adSoyad }}</span
                                    >
                                  </td>
                                  <td v-show="(showVoucherField('checkInDate'))" style="width: 15%">
                                    <span class="subheading">
                                      {{ itemoda.Kalem.donem1 | dateformat }}</span
                                    >
                                  </td>
                                  <td v-show="(showVoucherField('checkOutDate'))" style="width: 15%">
                                    <span class="subheading">
                                      {{ itemoda.Kalem.donem2 | dateformat }}</span
                                    >
                                  </td>
                                  <td v-show="(showVoucherField('nightCount'))" style="width: 5%">
                                    <span class="subheading">
                                      {{ gunhesapla(itemoda.Kalem) }}</span
                                    >
                                  </td>
                                  <td v-show="(showVoucherField('boardRoomType'))" style="width: 20%">
                                    <span class="subheading">
                                      {{
                                        PansiyonTipToStr(
                                          itemoda.Kalem.kalemOtel.pansiyon
                                        )
                                      }}{{
                                        itemoda.Kalem.kalemOtel.odaTipi.isim
                                      }}</span
                                    >
                                  </td>
                                </tr>
                             
                              </table>
                            </td>
                          </tr>

                           <tr v-show="(showAnyVoucherField(['passengerName', 'passengerReservationNo', 'nationality', 'passportNumber', 'birthDate']))" v-if="isAcente">
                            <td colspan="5">
                              <table
                                v-for="itemoda in item.Odalar"
                                :key="itemoda.Sira"
                                width="100%"
                              >
                                <tr
                                  v-for="itemkisi in itemoda.Kisiler"
                                  :key="itemkisi.adsoyad"
                                  colspan="5"
                                  align="center"
                                  style="
                                    padding-top: 20px;
                                    padding-bottom: 20px;
                                  "
                                >
                                  <td v-show="(showVoucherField('passengerName'))" style="width: 20%">
                                    <span class="subheading">
                                      {{ itemkisi.adSoyad }} 
                                      </span>
                                  </td>
                                  <td v-show="(showVoucherField('passengerReservationNo'))" style="width: 20%">
                                    <span class="subheading"> {{ itemkisi.kod }}</span>
                                  </td>
                                  <td v-show="(showVoucherField('nationality'))" style="width: 20%">
                                    <span class="subheading">
                                       {{ itemkisi.ulke }}
                                    </span>
                                  </td>
                                  <td v-show="(showVoucherField('passportNumber'))" style="width: 20%" >
                                    <span class="subheading">
                                      {{ itemkisi.pasaportNo }}</span
                                    >
                                  </td>
                                  <td v-show="(showVoucherField('birthDate'))" style="width: 20%">
                                    <span class="subheading">
                                      {{ formatDate(itemkisi.dogumTarihi) }} </span
                                    >
                                  </td>
                                </tr>
                             
                              </table>
                            </td>
                          </tr>


                           <tr v-show="(showAnyVoucherField(['pax', 'passengerName', 'pnrNo', 'counterReservationCode']))" v-if="isRestaurant">
                            <td colspan="4"  >
                              <table
                                v-for="itemoda in item.Odalar"
                                :key="itemoda.Sira"
                                width="100%"
                              >
                                <tr
                                  v-for="itemkisi in itemoda.Kisiler"
                                  :key="itemkisi.adsoyad"
                                  colspan="5"
                                  align="center"
                                  style="
                                    padding-top: 20px;
                                    padding-bottom: 20px;
                                  "
                                >
                                  <td v-show="(showVoucherField('pax'))" style="width: 25%">
                                    <span class="subheading">
                                      {{ itemkisi.Pax }} 
                                      </span>
                                  </td>
                                  <td v-show="(showVoucherField('passengerName'))" style="width: 25%">
                                    <span class="subheading"> {{ itemkisi.adSoyad }}</span>
                                  </td>
                                  <td v-show="(showVoucherField('pnrNo'))" style="width: 25%">
                                    <span class="subheading">
                                      {{ pnr }}    
                                    </span>
                                  </td>
                                  <td v-show="(showVoucherField('counterReservationCode'))" style="width: 25%" >
                                    <span class="subheading">
                                      {{ itemoda.KarsiRezKodu }}</span
                                    >
                                  </td>
                                </tr>
                             
                              </table>
                            </td>
                          </tr> 

                         <tr v-show="(showAnyVoucherField(['passengerName', 'pnrNo', 'nationality', 'passportNumber', 'birthDate']))" v-if="isTransfer">
                            <td colspan="8">
                              <table
                                v-for="itemoda in item.Odalar"
                                :key="itemoda.Sira"
                                width="100%"
                              >
                                <tr
                                  v-for="itemkisi in itemoda.Kisiler"
                                  :key="itemkisi.adsoyad"
                                  colspan="8"
                                  align="center"
                                  style="
                                    padding-top: 20px;
                                    padding-bottom: 20px;
                                  "
                                >
                                  <td v-show="(showVoucherField('passengerName'))" style="width: 20%">
                                    <span class="subheading">
                                      {{ itemkisi.adSoyad }} 
                                      </span>
                                  </td>
                                  <td v-show="(showVoucherField('pnrNo'))" style="width: 20%">
                                    <span class="subheading"> {{ pnr }}</span>
                                  </td>
                                  <td v-show="(showVoucherField('nationality'))" style="width: 20%">
                                    <span class="subheading">
                                      {{itemkisi.ulke}}  
                                    </span>
                                  </td>
                                  <td v-show="(showVoucherField('passportNumber'))" style="width: 20%" >
                                    <span class="subheading">
                                      {{itemkisi.pasaportNo}}
                                    </span>
                                  </td>
                                  <td v-show="(showVoucherField('birthDate'))" style="width: 20%" >
                                    <span class="subheading">
                                      {{ formatDate(itemkisi.dogumTarihi)}}
                                    </span>
                                  </td>
                                </tr>
                             
                              </table>
                            </td>
                          </tr> 

                          <tr v-show="(showAnyVoucherField(['passengerName', 'vehicle', 'vehicleCategory', 'vehicleCount', 'vehicleDay']))" v-if="isRentACar">
                            <td colspan="8">
                              <table
                                v-for="itemoda in item.Odalar"
                                :key="itemoda.Sira"
                                width="100%"
                              >
                                <tr
                                  v-for="itemkisi in itemoda.Kisiler"
                                  :key="itemkisi.adsoyad"
                                  colspan="8"
                                  align="center"
                                  style="
                                    padding-top: 20px;
                                    padding-bottom: 20px;
                                  "
                                >
                                  <td v-show="(showVoucherField('passengerName'))" style="width: 20%">
                                    <span class="subheading">
                                      {{ itemkisi.adSoyad }} 
                                      </span>
                                  </td>
                                  <td v-show="(showVoucherField('vehicle'))" style="width: 20%">
                                    <span class="subheading"> {{itemoda.Kalem.baseKalem.arac}} </span>
                                  </td>
                                  <td v-show="(showVoucherField('vehicleCategory'))" style="width: 20%">
                                    <span class="subheading">
                                      {{itemoda.Kalem.baseKalem.kategori}}
                                    </span>
                                  </td>
                                  <td v-show="(showVoucherField('vehicleCount'))" style="width: 20%" >
                                    <span class="subheading">
                                      {{itemoda.Kalem.baseKalem.aracAdet}} 
                                    </span>
                                  </td>
                                  <td v-show="(showVoucherField('vehicleDay'))" style="width: 20%" >
                                    <span class="subheading">
                                      {{itemoda.Kalem.baseKalem.gun}} 
                                    </span>
                                  </td>
                                </tr>
                             
                              </table>
                            </td>
                          </tr> 


                          <tr>
                            <td v-show="(showAnyVoucherField(['totalPax', 'totalRoom']))" v-if="isOtel" colspan="4">
                              <table align="left" width="100%">
                                <tr
                                  align="left"
                                  style="
                                    padding-top: 15px;
                                    padding-bottom: 15px;
                                  "
                                >
                                  <td v-show="(showVoucherField('totalPax'))" colspan="2">
                                    <span class="subheading">
                                     Nombre total de passagers : {{ item.ToplamPax }}</span
                                    >
                                  </td>
                                </tr>
                                <tr
                                  colspan="8"
                                  align="left"
                                  style="
                                    padding-top: 20px;
                                    padding-bottom: 20px;
                                  "
                                >
                                  <td v-show="(showVoucherField('totalRoom'))" colspan="2">
                                    <span class="subheading">
                                      Total Rooms : {{ toplamOdaText }}
                                    </span>
                                  </td>
                                </tr>
                              </table>
                            </td>
                            <td v-show="(showAnyVoucherField(['totalPax', 'tourType', 'meetingDate', 'tourKind', 'meetingTime', 'tourDuration', 'meetingPlace', 'tourGuide', 'shipName', 'entrancesIncluded', 'returnInfo', 'mealsIncluded']))" colspan="5" v-if="isAcente">
                              <table align="left" width="100%">
                                <tr
                                  style="
                                    padding-top: 15px;
                                    padding-bottom: 15px;
                                  "
                                >
                                  <td v-show="(showVoucherField('totalPax'))" colspan="2">
                                    <span class="subheading">
                                      Total Pax : {{ item.ToplamPax }}</span
                                    >
                                  </td>
                                  <td v-show="(showVoucherField('tourType'))" colspan="2">
                                    <span class="subheading">
                                      Type de visite : {{ getTurTipi(item.Odalar[0].Kalem.kalemAcente.TurTipi) }} </span
                                    >
                                  </td>
                                </tr>
                                 <tr
                                  style="
                                    padding-top: 15px;
                                    padding-bottom: 15px;
                                  "
                                >
                                  <td v-show="(showVoucherField('meetingDate'))" colspan="2">
                                    <span class="subheading">
                                      Date de la réunion : {{ item.Odalar[0].Kalem.kalemAcente.BulusmaTarihi | dateformat }} </span
                                    >
                                  </td>
                                  <td v-show="(showVoucherField('tourKind'))" colspan="2">
                                    <span class="subheading">
                                      Type de visite : {{ getTurTuru(item.Odalar[0].Kalem.kalemAcente.TurTuru) }}</span
                                    >
                                  </td>
                                </tr>
                                <tr
                                  style="
                                    padding-top: 15px;
                                    padding-bottom: 15px;
                                  "
                                >
                                  <td v-show="(showVoucherField('meetingTime'))" colspan="2">
                                    <span class="subheading">
                                     Heure de réunion : {{ item.Odalar[0].Kalem.kalemAcente.Saat | timeformat }} </span
                                    >
                                  </td>
                                  <td v-show="(showVoucherField('tourDuration'))" colspan="2">
                                    <span class="subheading">
                                      Durée du tour :  </span 
                                    >
                                    <!-- {{ getTurTuru(item.Odalar[0].Kalem.kalemAcente.Tip) }} -->
                                  </td>
                                </tr>
                                <tr
                                  style="
                                    padding-top: 15px;
                                    padding-bottom: 15px;
                                  "
                                >
                                  <td v-show="(showVoucherField('meetingPlace'))" colspan="2">
                                    <span class="subheading">
                                      Lieu de rencontre : {{ item.Odalar[0].Kalem.kalemAcente.BulusmaYeri }}</span
                                    >
                                  </td>
                                  <td v-show="(showVoucherField('tourGuide'))" colspan="2">
                                    <span class="subheading">
                                      Le guide touristique : {{ item.Odalar[0].Kalem.kalemAcente.Rehber.isim }} </span
                                    >
                                  </td>
                                </tr>
                                <tr
                                  style="
                                    padding-top: 15px;
                                    padding-bottom: 15px;
                                  "
                                >
                                  <td v-show="(showVoucherField('shipName'))" colspan="2">
                                    <span class="subheading">
                                      Nom de bateau : {{ item.Odalar[0].Kalem.kalemAcente.Gemi.isim }}</span
                                    >
                                  </td>
                                  <td v-show="(showVoucherField('entrancesIncluded'))" colspan="2">
                                    <span class="subheading">
                                      Entrées incluses : {{ checkItemsList(item.Odalar[0].Kalem.kalemAcente.Girisler)  }}  </span
                                    >
                                  </td>
                                </tr>
                                <tr
                                  style="
                                    padding-top: 15px;
                                    padding-bottom: 15px;
                                  "
                                >
                                  <td v-show="(showVoucherField('returnInfo'))" colspan="2" style="max-width:100px;">
                                    <span class="subheading">
                                      Informations de retour : {{ item.Odalar[0].Kalem.kalemAcente.DonusBilgisi }}</span
                                    >
                                  </td>
                                  <td v-show="(showVoucherField('mealsIncluded'))" colspan="2">
                                    <span class="subheading">
                                      Repas inclus : {{ checkItemsList(item.Odalar[0].Kalem.kalemAcente.OgleYemegi) }}  </span
                                    >
                                  </td>
                                </tr>
                              
                              </table>
                            </td>
                            <td v-show="(showAnyVoucherField(['totalPax', 'restaurantMenu']))" colspan="4" v-if="isRestaurant">
                              <table align="left" width="100%">
                                <tr
                                  align="left"
                                  style="
                                    padding-top: 15px;
                                    padding-bottom: 15px;
                                  "
                                >
                                  <td v-show="(showVoucherField('totalPax'))" colspan="4">
                                    <span class="subheading">
                                      Total Pax : {{ item.ToplamPax }}</span
                                    >
                                  </td>
                                </tr>
                                <tr v-show="(showVoucherField('restaurantMenu'))"
                                  colspan="4"
                                  align="left"
                                  style="
                                    padding-top: 20px;
                                    padding-bottom: 20px;
                                  "
                                  v-for="itemMenu in item.Satici.stRestaurant.Menu"
                                  :key="itemMenu.Kod"
                                >
                                  <td colspan="4"       
                                  >
                                    <span class="subheading">
                                      {{ itemMenu.Kod }}  : {{ itemMenu.Menu }}
                                    </span>
                                  </td>
                                </tr>
                         
                              </table>
                            </td>
                            <td v-show="(showAnyVoucherField(['departureDate', 'departureTime', 'arrivalDeparture', 'flightNumber', 'flightTime', 'departurePlace', 'destination', 'vehicle']))" colspan="8" v-if="isTransfer">
                             
                              <table align="left" width="100%">
                                   <tr>
                                  <td colspan="8">
                                    <v-divider></v-divider>
                                  </td>
                                </tr>
                                  <tr>
                            <td v-show="(showAnyVoucherField(['departureDate', 'departureTime', 'arrivalDeparture', 'flightNumber', 'flightTime', 'departurePlace', 'destination', 'vehicle']))" v-if="isTransfer" colspan="8">
                              <table width="100%">
                                <tr
                                  colspan="8"
                                  align="center"
                                  style="
                                    padding-top: 20px;
                                    padding-bottom: 20px;
                                    
                                  "
                                >
                                  <td v-show="(showVoucherField('departureDate'))" style="width: 15%">
                                    <span class="subheading">
                                      Date de départ</span
                                    >
                                  </td>
                                  <td v-show="(showVoucherField('departureTime'))" style="width: 10%">
                                    <span class="subheading">
                                      Heure de départ </span
                                    >
                                  </td>
                                  <td v-show="(showVoucherField('arrivalDeparture'))" style="width: 5%">
                                    <span class="subheading">
                                      A/D </span
                                    >
                                  </td>
                                   <td v-show="(showVoucherField('flightNumber'))" style="width: 10%">
                                    <span class="subheading">
                                      Numéro de vol </span
                                    >
                                  </td>
                                    <td v-show="(showVoucherField('flightTime'))" style="width: 10%">
                                    <span class="subheading">
                                      Temps de vol </span
                                    >
                                  </td>
                                   <td v-show="(showVoucherField('departurePlace'))" style="width: 15%">
                                    <span class="subheading">
                                      lieu d'action </span
                                    >
                                  </td>
                                   <td v-show="(showVoucherField('destination'))" style="width: 15%">
                                    <span class="subheading">
                                      Destination </span
                                    >
                                  </td>
                                   <td v-show="(showVoucherField('vehicle'))" style="width: 20%">
                                    <span class="subheading">
                                      Véhicule </span
                                    >
                                  </td>
                                </tr>
                                <tr>
                                  <td colspan="8">
                                    <v-divider></v-divider>
                                  </td>
                                </tr>
                              </table>
                            </td>
                                  </tr>
                                  <tr >
                               <td colspan="8">
                                 <table
                                   v-for="itemoda in item.Odalar"
                                   :key="itemoda.Sira"
                                   width="100%"
                                 >
                                   <tr
                                     v-for="itemkisi in itemoda.Kisiler"
                                     :key="itemkisi.adsoyad"
                                     colspan="5"
                                     align="center"
                                     style="
                                       padding-top: 20px;
                                       padding-bottom: 20px;
                                     "
                                   >
                                     <td v-show="(showVoucherField('departureDate'))" style="width: 15%">
                                       <span class="subheading">
                                         {{ itemoda.Kalem.donem1 | dateformat }} 
                                          
                                         </span>
                                     </td>
                                     <td v-show="(showVoucherField('departureTime'))" style="width: 10%">
                                       <span class="subheading"> {{ itemoda.Kalem.kalemArac.seferSaat | timeformat }} </span>
                                     </td>
                                     <td v-show="(showVoucherField('arrivalDeparture'))" style="width: 5%">
                                       <span class="subheading">
                                         {{ itemoda.Kalem.baseKalem.ADT }}
                                       </span>
                                     </td>
                                     <td v-show="(showVoucherField('flightNumber'))" style="width: 10%" >
                                       <span class="subheading">
                                        {{ itemoda.Kalem.baseKalem.ucusNo }}
                                       </span>
                                     </td>
                                     <td v-show="(showVoucherField('flightTime'))" style="width: 10%" >
                                       <span class="subheading">
                                         {{ itemoda.Kalem.baseKalem.ucusSaat | timeformat }}
                                       </span>
                                     </td>
                                     <td v-show="(showVoucherField('departurePlace'))" style="width: 15%" >
                                       <span class="subheading">
                                         {{ itemoda.Kalem.baseKalem.nerden }}
                                       </span>
                                     </td>
                                     <td v-show="(showVoucherField('destination'))" style="width: 15%" >
                                       <span class="subheading">
                                         {{ itemoda.Kalem.baseKalem.nereye }}
                                       </span>
                                     </td>
                                      <td v-show="(showVoucherField('vehicle'))" style="width: 20%" >
                                       <span class="subheading">
                                         {{ itemoda.Kalem.baseKalem.arac }}
                                       </span>
                                     </td>
                                   </tr>

                                 </table>
                                </td>
                               </tr> 
                      
                              </table>
                            </td>

                            <td v-show="(showAnyVoucherField(['pickupReturnInfo', 'extraServices']))" colspan="8" v-if="isRentACar">
                              <table align="left" width="100%">
                                <tr>
                                  <td colspan="8">
                                    <v-divider></v-divider>
                                  </td>
                                </tr>
                                <tr>
                                  <td  colspan="8">
                                    <table v-show="(showVoucherField('pickupReturnInfo'))" width="100%">
                                <tr>
                                  <th style="width: 10%"> </th>
                                  <th style="width: 30%">Histoire </th>
                                  <th style="width: 30%">Heure </th>
                                  <th style="width: 30%">Place </th>
                                </tr>
                                   <tr
                                   v-for="itemoda in item.Odalar"
                                   :key="itemoda.Sira"
                                     colspan="5"
                                     align="center"
                                     style="
                                       padding-top: 20px;
                                       padding-bottom: 20px;
                                     "
                                   >
                                     <td style="width: 20%">
                                       <span class="subheading">
                                         Informations d'achat
                                         </span>
                                     </td> 
                                     <td style="width: 10%">
                                       <span class="subheading"> {{ itemoda.Kalem.baseKalem.alisTarih | dateformat }} </span>
                                     </td>
                                     <td style="width: 5%">
                                       <span class="subheading">
                                         {{ itemoda.Kalem.baseKalem.alisSaat | timeformat }}
                                       </span>
                                     </td>
                                     <td style="width: 10%" >
                                       <span class="subheading">
                                         {{ itemoda.Kalem.baseKalem.alisYeri }}
                                       </span>
                                     </td>
                                   </tr>
                                      <tr
                                   v-for="itemoda in item.Odalar"
                                   :key="itemoda.Sira"
                                     colspan="5"
                                     align="center"
                                     style="
                                       padding-top: 20px;
                                       padding-bottom: 20px;
                                     "
                                   >
                                     <td style="width: 10%">
                                       <span class="subheading">
                                         Informations sur le dépôt
                                         </span>
                                     </td> 
                                     <td style="width: 30%">
                                       <span class="subheading"> {{ itemoda.Kalem.baseKalem.musteriTeslimTarihi | dateformat }} </span>
                                     </td>
                                     <td style="width: 30%">
                                       <span class="subheading">
                                         {{ itemoda.Kalem.baseKalem.teslimSaat | timeformat }}
                                       </span>
                                     </td>
                                     <td style="width: 30%" >
                                       <span class="subheading">
                                         {{ itemoda.Kalem.baseKalem.teslimYeri }}
                                       </span>
                                     </td>
                                   </tr>
                                    </table>
                                  </td>
                                </tr>
                                <tr>
                                  <td colspan="8">
                                    <v-divider></v-divider>
                                  </td>
                                </tr>
                                 <tr v-show="(showVoucherField('extraServices'))" style="padding-top: 50px">

                            <td colspan="8" >
                              <table width="100%">
                                <tr>
                                  <th style="width: 100%" colspan="4">Ek Hizmetler </th>
                                  
                                </tr>
                                   <tr
                                     align="left"
                                     style="
                                       padding-top: 20px;
                                       padding-bottom: 20px;
                                     "
                                   >
                                     <td style="width: 40%" >
                                     <tr>
                                       <td>
                                          <span class="subheading">
                                         Drop  
                                         </span>
                                       </td>
                                       <td>
                                         : {{ checkTrueFalse(item.Odalar[0].Kalem.baseKalem.checkDropUcreti) }}
                                       </td>
                                     </tr>

                                     <tr>
                                       <td>
                                          <span class="subheading">
                                         Otomatik Vites  
                                         </span>
                                       </td>
                                       <td>
                                         : {{ checkTrueFalse(item.Odalar[0].Kalem.baseKalem.checkOtomatikVites) }}
                                       </td>
                                     </tr>

                                    <tr>
                                       <td>
                                          <span class="subheading">
                                         İptal Sigortası
                                         </span>
                                       </td>
                                       <td>
                                         : {{ checkTrueFalse(item.Odalar[0].Kalem.baseKalem.checkIptalSigortasi) }}
                                       </td>
                                     </tr>
                                    </td>


                                    <td style="width: 40%">
                                     <tr>
                                       <td>
                                          <span class="subheading">
                                         Bebek Koltuğu  
                                         </span>
                                       </td>
                                       <td>
                                         : {{ checkTrueFalse(item.Odalar[0].Kalem.baseKalem.checkBebekKoltugu) }}
                                       </td>
                                     </tr>

                                     <tr>
                                       <td>
                                          <span class="subheading">
                                         Klima  
                                         </span>
                                       </td>
                                       <td>
                                         : {{ checkTrueFalse(item.Odalar[0].Kalem.baseKalem.checkKlima) }}
                                       </td>
                                     </tr>

                                    <tr>
                                       <td>
                                          <span class="subheading">
                                         Navigasyon
                                         </span>
                                       </td>
                                       <td>
                                         : {{ checkTrueFalse(item.Odalar[0].Kalem.baseKalem.checkNavigation) }}
                                       </td>
                                     </tr>
                                    </td>

                                    <td style="width: 20%">
                                     <tr>
                                       <td>
                                          <span class="subheading">
                                         Çocuk Koltuğu  
                                         </span>
                                       </td>
                                       <td>
                                         : {{ checkTrueFalse(item.Odalar[0].Kalem.baseKalem.checkCocukKoltugu) }}
                                       </td>
                                     </tr>

                                     <tr>
                                       <td>
                                          <span class="subheading">
                                         Temizlik  
                                         </span>
                                       </td>
                                       <td>
                                         : {{ checkTrueFalse(item.Odalar[0].Kalem.baseKalem.checkTemizlik) }}
                                       </td>
                                     </tr>

                                    <tr>
                                       <td>
                                          <span class="subheading">
                                         Diğer
                                         </span>
                                       </td>
                                       <td>
                                         : {{ checkTrueFalse(item.Odalar[0].Kalem.baseKalem.checkDiger) }}
                                       </td>
                                     </tr>
                                    </td>

                                   </tr>
                                     
                              </table>
                            </td>
                            </tr>
                              </table>
                            </td>
                          </tr>

                          <tr v-show="(showVoucherField('note'))" style="height: 100%; padding-top: 50px">
                            <td
                              colspan="4"
                              align="center"
                              style="padding-top: 10px; padding-bottom: 10px"
                            >
                            <v-divider></v-divider>
                              <span class="title pt-2 pb-2">
                                ANNULATION, NO SHOW ET PROCÉDURE DE SORTIE ANTICIPÉE
                              </span>
                            <v-divider></v-divider>
                            </td>
                          </tr>
                          <tr v-show="(showVoucherField('note'))">
                            <td
                              colspan="4"
                              width="100%"
                              style="
                                vertical-align: top;
                                padding-top: 5px;
                                padding-bottom: 5px;
                              "
                            >
                              <v-layout id="skip3" justify-end>
                                <v-btn
                                  color="info"
                                  flat
                                  @click="aciklamaDialogOpen('NOT')"
                                >
                                  <v-icon small>edit</v-icon> &nbsp; {{ $t('Edit-Note') }}
                                </v-btn>
                              </v-layout>
                              {{ selectedVoucherItems.Aciklamalar.Not }}
                            </td>
                          </tr>

                          <tr v-show="(showVoucherField('terms'))" style="height: 100%">
                            <td
                              colspan="4"
                              align="center"
                              style="padding-top: 5px; padding-bottom: 5px"
                            >
                              <v-divider></v-divider>
                              <span class="title">
                                TERMES ET CONDITIONS
                              </span>
                              <v-divider></v-divider>
                            </td>
                          </tr>
                          <tr v-show="(showVoucherField('terms'))">
                            <td
                              colspan="4"
                              width="100%"
                              style="
                                vertical-align: top;
                                padding-top: 10px;
                                padding-bottom: 10px;
                              "
                            >
                              <span style="text-align: center">
                                <v-layout id="skip2" justify-end>
                                  <v-btn
                                    color="info"
                                    flat
                                    @click="aciklamaDialogOpen('ACIKLAMA1')"
                                  >
                                    <v-icon small>edit</v-icon> &nbsp; {{ $t('Edit-Description1') }}
                                   
                                  </v-btn>
                                </v-layout>
                                {{ selectedVoucherItems.Aciklamalar.Aciklama1 }}
                                <br />
                                <v-layout id="skip" justify-end>
                                  <v-btn
                                    color="info"
                                    flat
                                    @click="aciklamaDialogOpen('ACIKLAMA2')"
                                  >
                                    <v-icon small>edit</v-icon> &nbsp; {{ $t('Edit-Description2') }}
                                    
                                  </v-btn>
                                </v-layout>
                                {{ selectedVoucherItems.Aciklamalar.Aciklama2 }}
                              </span>
                            </td>
                          </tr>
                          <tr></tr>

                          <tr v-show="(showAnyVoucherField(['companyInfo', 'bookedByInfo']))" pt-5 style="margin-top: 10px">
                            <td colspan="4">
                              <table width="100%">
                                <tr>
                                  <td v-show="(showVoucherField('companyInfo'))">
                                    
                                    {{
                                      voucherDisplayCompanyName
                                    }}
                                  </td>
                                  <td v-show="(showVoucherField('bookedByInfo'))">Booker;</td>
                                </tr>
                                <tr>
                                  <td v-show="(showVoucherField('companyInfo'))">
                                    {{
                                      selectedVoucherItems.SirketBilgileri.SirketAdres1
                                    }}
                                  </td>
                                  <td v-show="(showVoucherField('bookedByInfo'))">
                                    Name Surname : &nbsp;
                                    {{ item.RezervasyonYapan.Isim }}
                                  </td>
                                </tr>
                                <tr>
                                  <td v-show="(showVoucherField('companyInfo'))">
                                    {{
                                      selectedVoucherItems.SirketBilgileri.SirketAdres2
                                    }}
                                  </td>
                                  <td v-show="(showVoucherField('bookedByInfo'))">
                                    Email :
                                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    {{ item.RezervasyonYapan.EMail }}
                                  </td>
                                </tr>
                                <tr>
                                  <td v-show="(showVoucherField('companyInfo'))">
                                    {{
                                      selectedVoucherItems.SirketBilgileri.SirketTelefon
                                    }}
                                  </td>
                                  <td v-show="(showVoucherField('bookedByInfo'))">
                                    Téléphone : &nbsp;&nbsp;
                                    {{ item.RezervasyonYapan.Telefon }}
                                  </td>
                                </tr>
                                <tr>
                                  <td v-show="(showVoucherField('companyInfo'))">
                                    {{
                                      selectedVoucherItems.SirketBilgileri.SirketFaks
                                    }}
                                  </td>
                                  <td v-show="(showVoucherField('bookedByInfo'))">
                                    Agent : &nbsp;&nbsp;&nbsp;
                                    {{ item.RezervasyonYapan.Acente }}
                                  </td>
                                </tr>
                              </table>
                            </td>

                            <td></td>
                          </tr>

                          <tr v-show="(showVoucherField('printDate'))">
                            <td colspan="8">
                              <span class="grey--text caption">
                                {{ getDateNow() | dateformat }}
                                {{ getdatetimenow() }}</span
                              >
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <div v-show="(showVoucherField('lowerLogo'))" id="imgAlt"></div>
                            </td>
                          </tr>
                        </thead>
                      </table>
                    </div>
                  </v-flex>
                </v-layout>
              </v-card>
            </v-flex>



            <v-flex xs12 pa-2 sm2 v-if="vouchergoster">
              <v-card flat>
                <v-layout row wrap>
                  <v-flex xs12 pa-3 sm12>
                    <v-layout row wrap>
                      <v-flex xs6 sm12>
                        <v-btn
                          block
                          @click.native="dialogTaslak = true"
                          color="info"
                          outline
                        >
                          {{ $t('Edit-Draft') }}
                          <v-icon right small>assignment</v-icon>
                        </v-btn>
                      </v-flex>
                      <v-flex xs6 sm12>
                        <v-btn
                          block
                          color="info"
                          outline
                          @click="LogoKaydet('Üst Logo Seçiniz', 'UstLogo')"
                        >
                          {{ $t('Upper-Logo') }}  <v-icon right small>save</v-icon>
                        </v-btn>
                      </v-flex>

                      <v-flex xs6 sm12>
                        <v-btn
                          block
                          color="info"
                          @click="LogoKaydet('Alt Logo Seçiniz', 'AltLogo')"
                          outline
                        >
                          {{ $t('Lower-Logo') }} <v-icon right small>save</v-icon>
                        </v-btn>
                      </v-flex>

                      <v-flex xs6 sm12>
                        <v-btn
                          block
                          @click="onIzlemeOlustur()"
                          color="info"
                          outline
                        >
                          {{ $t('Print') }} <v-icon right small>print</v-icon>
                        </v-btn>
                      </v-flex>
                      <v-flex xs6 sm12>
                        <v-btn block color="info" outline @click="EmailGonderPdf">
                          {{ $t('Send-Mail') }} <v-icon right small>email</v-icon>
                        </v-btn>
                      </v-flex>

                      <v-flex xs6 sm12>
                        <v-btn block color="info" outline @click="openVoucherPdfDialog">
                          {{ $t('Download-PDF') || 'PDF İndir' }}
                          <v-icon right small>picture_as_pdf</v-icon>
                        </v-btn>
                      </v-flex>



                    </v-layout>
                  </v-flex>
                </v-layout>
                
<!-- Mail gönderme popupu -->
<v-dialog v-model="emailDialog" max-width="560px" persistent>
  <v-card>
    <v-card-title class="headline">{{ $t('Send-Mail') }}</v-card-title>

    <v-card-text>
      <!-- VALIDASYON için v-form -->
      <v-form ref="emailForm" v-model="emailValid" lazy-validation>
        <v-text-field
          v-model="form.pnrNo"
          :label="$t('PNR')"
          :rules="[rules.required]"
          required
          clearable
        />
        <v-text-field
          v-model="form.to"
          :label="$t('Recipient-Email')"
          :rules="[rules.required, rules.email]"
          required
          clearable
        />
        <v-text-field
          v-model="form.agencyName"
          :label="$t('Agent-Name')"
          :rules="[rules.required]"
          required
          clearable
        />
        <v-text-field
          v-model="form.agentFullName"
          :label="$t('Name-Surname')"
          :rules="[rules.required]"
          required
          clearable
        />
        <v-select
          v-model="form.docType"
          :items="[
            { text: $t('Reservation-Receipt'), value: 'reservation' },
            { text: 'Voucher', value: 'voucher' }
          ]"
          :label="$t('Document-Type')"
          :rules="[rules.required]"
          required
          clearable
        />
      </v-form>
    </v-card-text>

    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn flat @click="emailDialog=false">{{ $t('Cancel') }}</v-btn>
      <v-btn color="info"
             :disabled="!emailValid || submitting"
             :loading="submitting"
             @click="submitEmail">
        {{ $t('Send-Mail') }}
      </v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>

              </v-card>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-card>

    <v-dialog v-model="dialogDuzenle" max-width="600px">
      <v-card>
        <v-card-title>{{ dialogEditTitle }}  {{ $t('Edit') }}</v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-layout row wrap="">
            <v-flex xs12 sm12 md12>
              <v-card flat class="white--text">
                <v-textarea
                  v-model="dialogEditText"
                  :label="dialogEditTitle"
                ></v-textarea>
              </v-card>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="info" @click="acikalamaDuzenle()">  {{ $t('save_button') }} </v-btn>
          <v-btn color="warning" @click.native="dialogDuzenle = false">
            {{$t('Cancel')}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogTaslak" max-width="600px">
      <v-card>
        <v-card-title> {{$t('Editing-Draft-Information')}}</v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-layout row wrap="">
            <v-flex xs12 sm12 md12>
              <v-card flat class="white--text">
                <v-flex md12 sm12 xs12>
                  <v-textarea
                    v-model="voucherInfo.Aciklamalar.Not"
                    :label="$t('Notes')"
                  ></v-textarea>
                </v-flex>
                <v-flex md12 sm12 xs12>
                  <v-textarea
                    v-model="voucherInfo.Aciklamalar.Aciklama1"
                     :label="$t('EXPLANATION')"
                  >
                  </v-textarea>
                </v-flex>
                <v-flex md12 sm12 xs12>
                  <v-textarea
                    v-model="voucherInfo.Aciklamalar.Aciklama2"
                     :label="$t('EXPLANATION')"
                  >
                  </v-textarea>
                </v-flex>
              </v-card>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="info" @click="aciklamaKaydet()"> {{ $t('save_button') }} </v-btn>
          <v-btn color="warning" @click.native="dialogDuzenle = false">
            {{$t('Cancel')}}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

<!-- Otel voucher PDF oluşturma popupu -->
<v-dialog v-model="voucherPdfDialog" max-width="420px" persistent>
  <v-card>
    <v-card-title class="headline">
      {{ getVoucherPdfDialogTitle() }}
    </v-card-title>

    <v-card-text>
      <v-form ref="voucherPdfForm" v-model="voucherPdfValid" lazy-validation>
        <v-text-field
          v-model="voucherPdf.pnrNo"
          :label="$t('PNR') || 'PNR No'"
          :rules="[rules.required]"
          required
          clearable
        />

        <v-select
          v-model="voucherPdf.lang"
          :items="voucherPdfLangItems"
          item-text="text"
          item-value="value"
          :label="$t('Language-select') || 'Dil'"
          :rules="[rules.required]"
          required
          clearable
        />

        <div class="grey--text text--darken-1 caption mt-2">
          {{
            getVoucherPdfInformationText()
          }}
        </div>
      </v-form>
    </v-card-text>

    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn flat @click="voucherPdfDialog = false">
        {{ $t('Cancel') || 'İptal' }}
      </v-btn>

      <v-btn
        color="info"
        :disabled="!voucherPdfValid || submittingVoucherPdf"
        :loading="submittingVoucherPdf"
        @click="submitVoucherPdfDownload"
      >
        <v-icon left>visibility</v-icon>
        {{ locale === 'en' ? 'Preview' : 'Önizle' }}
      </v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>

<!-- Oluşturulan otel voucher PDF önizlemesi -->
<v-dialog
  v-model="voucherPdfPreviewDialog"
  max-width="1200px"
  persistent
  scrollable
>
  <v-card>
    <v-toolbar color="info" dark flat>
      <v-toolbar-title>
        {{ getVoucherPdfPreviewTitle() }}
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon dark @click="closeVoucherPdfPreview">
        <v-icon>close</v-icon>
      </v-btn>
    </v-toolbar>

    <v-card-text style="height: 78vh; padding: 0; overflow: hidden;">
      <iframe
        v-if="voucherPdfPreviewUrl"
        :src="voucherPdfPreviewUrl"
        :title="getVoucherPdfPreviewTitle()"
        style="width: 100%; height: 100%; border: 0;"
      ></iframe>
    </v-card-text>

    <v-divider></v-divider>

    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn flat @click="closeVoucherPdfPreview">
        {{ locale === 'en' ? 'Close' : 'Kapat' }}
      </v-btn>
      <v-btn color="info" @click="downloadVoucherPdfPreview">
        <v-icon left>file_download</v-icon>
        {{ locale === 'en' ? 'Download PDF' : 'PDF İndir' }}
      </v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>


  </div>
</template>

<script>
import rez from "../../rezervasyon";
import printJS from "print-js";
import helpers from "@/components/app/customcomp/helpers.js";
import snackbarcomp from "@/components/app/customcomp/snackbarcomp";
import yetkidialog from "@/components/app/customcomp/yetkidialog.vue";
import tool from "../../tools";
import imagefiledialog from "@/components/app/coper/comp/imagefiledialog.vue";
import loadingcomp from "@/components/app/customcomp/loadingcomp";
import auth from '@/api/auth'; 

export default {
  components: {
    snackbarcomp,
    yetkidialog,
    imagefiledialog,
    loadingcomp,
  },
  props: ["value"],
  computed: {
    val: {
      get: function () {
        return this.value;
      },
      set: function (newValue) {
        this.$emit("input", newValue);
      },
    },
    voucherFieldItems() {
      var fieldKeys = this.voucherFieldDefinitions[this.selectedSalerType] || [];
      return fieldKeys.map((fieldKey) => {
        return {
          value: fieldKey,
          text: this.getVoucherFieldLabel(fieldKey),
        };
      });
    },
    voucherFieldSelectLabel() {
      return this.getVoucherUiText("fieldSelect");
    },
    voucherSelectAllLabel() {
      return this.getVoucherUiText("selectAll");
    },
    voucherClearLabel() {
      return this.getVoucherUiText("clear");
    },
    voucherCompanyNameLabel() {
      return this.getVoucherUiText("companyNameOverride");
    },
    voucherDisplayCompanyName() {
      if (this.voucherCustomCompanyName && this.voucherCustomCompanyName.trim() !== "") {
        return this.voucherCustomCompanyName;
      }
      return this.selectedVoucherItems.SirketBilgileri.SirketIsmi;
    },
    supportsVoucherFieldSelection() {
      return this.isVoucherFieldSelectionSupported(this.selectedSalerType);
    },
  },

  data() {
    return {
      voucherPdfDialog: false,
    voucherPdfValid: false,
    submittingVoucherPdf: false,
    voucherPdfPreviewDialog: false,
    voucherPdfPreviewUrl: null,
    voucherPdfPreviewBlob: null,
    voucherPdfPreviewFileName: '',

    voucherPdf: {
      pnrNo: '',
      lang: 'tr',
    },

    voucherPdfLangItems: [
      { text: 'Türkçe', value: 'tr' },
      { text: 'English', value: 'en' },
      { text: 'Deutsch', value: 'de' },
      { text: 'Français', value: 'fr' },
    ],

      emailDialog: false,
      submitting: false,
emailValid: false,
      form: {
        pnrNo: '',
        to: '',
        agencyName: '',
        agentFullName: '',
        docType: 'voucher'

      },
docTypeItems: [
        { text: 'Rezervasyon Fişi', value: 'reservation' },
        { text: 'Voucher', value: 'voucher' }
      ],
rules: {
        required: v => !!v || 'Bu alan zorunludur',
        email: v => /.+@.+\..+/.test(v) || 'Geçerli bir e-posta girin',
        pnr: v => (v && String(v).length >= 3) || 'Geçerli bir PNR girin'
      },
    



      PansiyonWithNull: [
    {
      kod: null, 
      aciklama: 'Hostel'
    },{
    kod: 0, //"OB",
    aciklama: "Only Bed"
  },
  {
    kod: 1, //"BB",
    aciklama: "Bed & Breakfast"
  },
  {
    kod: 2, //"HB",
    aciklama: "Half Board"
  },
  {
    kod: 3, //"FB",
    aciklama: "Full Board"
  },
  {
    kod: 6, //"AI",
    aciklama: "All Inclusive"
  },
  {
    kod: 7, //"UAI",
    aciklama: "Ultra All Inclusive"
  }
],
      tmpSayfalar:[],
      IsimleriAyir:false,
      KalemDetay:false,
      dialogTaslak: false,
      dialogEditTitle: null,
      dialogEditText: null,
      dialogDuzenle: false,
      
      secilenVoucherObje:{
        name:'',
                    value:''  ,
                    raporNo:'',
                    saticiTipi:null,
                    icon: null
      },
      locale: "en",
      itemsVoucherSaticilar: [],
      locales: [
        {
          locale: "tr",
          title: "Türkçe",
          href: "turkey",
        },
        {
          locale: "en",
          title: "English",
          href: "english",
        },
        {
          locale: "de",
          title: "Deutsch",
          href: "germany",
        },
        {
          locale: "fr",
          title: "French",
          href: "france",
        },
      ],
      loading: false,
      loadingStatus: false,
      snackbar: false,
      mesaj: null,
      dialogform: false,
      isOtel:false,
      isAcente:false,
      isRestaurant:false,
      isTransfer:false,
      isRentACar:false,
      TurTuru:[{
        text: '',
        value: 0
      },
      {
        text: 'Private',
        value: 1
      },
      {
        text: 'Regular',
        value: 2
      },
      {
        text: 'ShorexGroup',
        value: 3
      },
      {
        text: 'PrivateSatis',
        value: 4
      },
      {
        text: 'RegularSatis',
        value: 5
      }
      ],
      pantipitems: [
        {
          text: "",
          value: 0,
        },
        {
          textTR: "Tam",
          textEN: "Full",
          textDE: "Vollständige",
          textFR: "Plein",
          value: 1,
        },
        {
          textTR: "Yarım",
          textEN: "Half",
          textDE: "Hälfte",
          textFR: "Moitié",
          value: 2,
        },
        {
          textTR: "Gece",
          textEN: "Night",
          textDE: "Nacht",
          textFR: "Nuit",
          value: 3,
        },
      ],
      voucherInfo: {
        UstLogoUrl: null,
        AltLogoUrl: null,
        Sayfalar: null,
        SirketBilgileri: null,
        Aciklamalar: {
          Not: null,
          Aciklama1: null,
          Aciklama2: null,
        },
      },
      YedekAciklamalar: {
        Not: null,
        Aciklama1: null,
        Aciklama2: null,
      },
      AltLogoImageUrl: "",
      UstLogoImageUrl: "",
      pnr: null,
      vouchergoster: false,
      voucheritems: [],
      selectedVoucherItems:[],
      secilenSaticiKod:0,
      toplamOdaText: null,
            SaticiIconList: [
        {
          IconName: "hotel",
          Kod: 1,
        },
        {
          IconName: "rv_hookup",
          Kod: 2,
        },
        {
          IconName: "restaurant",
          Kod: 3,
        },
        {
          IconName: "local_see",
          Kod: 4,
        },
        {
          IconName: "departure_board",
          Kod: 5,
        },
        {
          IconName: "emoji_people",
          Kod: 6,
        },
        {
          IconName: "museum",
          Kod: 7,
        },
        {
          IconName: "flight_takeoff",
          Kod: 8,
        },
        {
          IconName: "directions_boat",
          Kod: 9,
        },
        {
          IconName: "category",
          Kod: 10,
        },
        {
          IconName: "style",
          Kod: 11,
        },
        {
          IconName: "tour",
          Kod: 12,
        },
        {
          IconName: "meeting_room",
          Kod: 13,
        },
        {
          IconName: "verified_user",
          Kod: 14,
        },
        {
          IconName: "directions_boat",
          Kod: 15,
        },
        {
          IconName: "golf_course",
          Kod: 16,
        },
      ],
      checkItems: [
        {
          textTR: "",
          textEN: "",
          textDE: "",
          textFR: "",
          value: 0,
        },
        {
          textTR: "Dahil",
          textEN: "Including",
          textDE: "Einschließlich",
          textFR: "Y compris",
          value: 1,
        },
        {
          textTR: "Hariç",
          textEN: "Excluding",
          textDE: "Ausgeschlossen",
          textFR: "Excluant",
          value: 2,
        },
      ],
      KisiTip: [
        {
          Kod: 0,
          AciklamaTR: "Yetişkin",
          AciklamaEN: "Adult",
          AciklamaDE: "Erwachsene",
          AciklamaFR: "Adulte",
        },
        {
          Kod: 1,
          AciklamaTR: "Çocuk 1",
          AciklamaEN: "Child 1",
          AciklamaDE: "Kind 1",
          AciklamaFR: "Enfant 1",
        },
        {
          Kod: 2,
          AciklamaTR: "Çocuk 2",
          AciklamaEN: "Child 2",
          AciklamaDE: "Kind 2",
          AciklamaFR: "Enfant 2",
        },
        {
          Kod: 3,
          AciklamaTR: "Çocuk 3",
          AciklamaEN: "Child 3",
          AciklamaDE: "Kind 3",
          AciklamaFR: "Enfant 3",
        },
        {
          Kod: 4,
          AciklamaTR: "Çocuk 4",
          AciklamaEN: "Child 4",
          AciklamaDE: "Kind 4",
          AciklamaFR: "Enfant 4",
        },
        {
          Kod: 5,
          AciklamaTR: "Ek Yatak",
          AciklamaEN: "Extra Bed",
          AciklamaDE: "Extra Bett",
          AciklamaFR: "Lit supplémentaire",
        },
      ],
      checkValue:[
        {
          textTR:"Evet",
          textEN:"Yes",
          textFR:"Oui",
          textDE:"Ja",
          value:true
        },
        {
          textTR:"Hayır",
          textEN:"No",
          textFR:"Non",
          textDE:"Nein",
          value:false
        }
      ],
      selectedVoucherFields: [],
      voucherCustomCompanyName: "",
      voucherFieldDefinitions: {
  "1": [
    "upperLogo", "voucherTitle", "supplierName", "supplierPhone",
    "supplierAddress", "supplierEmail", "counterReservationCode",
    "bookedByPhone", "roomOrder", "pnrNo", "personType",
    "passengerName", "checkInDate", "checkOutDate", "nightCount",
    "boardRoomType", "totalPax", "totalRoom", "note", "terms",
    "companyInfo", "bookedByInfo", "printDate", "lowerLogo"
  ],
  "2": [
    "serviceIcon", "upperLogo", "voucherTitle", "pnrNo", "routeSummary",
    "supplierName", "supplierPhone", "supplierAddress", "supplierEmail",
    "counterReservationCode", "bookedByPhone", "transferType",
    "tourOperator", "totalPax", "passengerName", "nationality",
    "passportNumber", "birthDate", "departureDate", "departureTime",
    "arrivalDeparture", "flightNumber", "flightTime", "departurePlace",
    "destination", "driverName", "driverPhone", "plateNumber", "vehicle",
    "priceSummary", "note", "terms", "companyInfo", "bookedByInfo",
    "printDate", "lowerLogo", "footer"
  ],
  "3": [
    "serviceIcon", "upperLogo", "voucherTitle", "supplierName",
    "supplierPhone", "supplierAddress", "supplierEmail",
    "counterReservationCode", "bookedByPhone", "pax", "passengerName",
    "pnrNo", "totalPax", "restaurantMenu", "priceSummary", "note",
    "terms", "companyInfo", "bookedByInfo", "printDate", "lowerLogo",
    "footer"
  ],
  "4": [
    "serviceIcon", "upperLogo", "voucherTitle", "pnrNo",
    "dailyTourSummary", "supplierName", "supplierPhone", "supplierAddress",
    "supplierEmail", "counterReservationCode", "bookedByPhone",
    "tourOperator", "passengerName", "passengerReservationNo",
    "nationality", "passportNumber", "birthDate", "totalPax", "tourType",
    "meetingDate", "tourKind", "meetingTime", "tourDuration",
    "meetingPlace", "tourGuide", "shipName", "entrancesIncluded",
    "returnInfo", "mealsIncluded", "tourCode", "tourDate", "tourTime",
    "program", "priceSummary", "note", "terms", "companyInfo",
    "bookedByInfo", "printDate", "lowerLogo", "footer"
  ],
  "5": [
    "serviceIcon", "upperLogo", "voucherTitle", "pnrNo", "vehicleSummary",
    "supplierName", "supplierPhone", "supplierAddress", "supplierEmail",
    "counterReservationCode", "bookedByPhone", "passengerName", "vehicle",
    "vehicleCategory", "vehicleCount", "vehicleDay", "tourOperator",
    "totalPax", "pickupReturnInfo", "pickupLocation", "pickupDate",
    "pickupTime", "dropoffLocation", "dropoffDate", "dropoffTime",
    "extraServices", "priceSummary", "note", "terms", "companyInfo",
    "bookedByInfo", "printDate", "lowerLogo", "footer"
  ],
  "8": [
    "serviceIcon", "upperLogo", "voucherTitle", "pnrNo",
    "flightRouteSummary", "supplierName", "airlineCode", "flightNumber",
    "flightType", "classType", "departurePlace", "destination",
    "departureDate", "departureTime", "flightTime", "passengerName",
    "priceSummary", "note", "lowerLogo", "footer"
  ],
  "9": [
    "serviceIcon", "upperLogo", "voucherTitle", "pnrNo", "cruiseSummary",
    "cruiseName", "cruiseLocation", "supplierName",
    "counterReservationCode", "cabinType", "vehicleCategory", "country",
    "checkInDate", "checkOutDate", "nightCount", "totalPax",
    "passengerName", "birthDate", "supplierEmail", "supplierPhone",
    "priceSummary", "note", "lowerLogo", "footer"
  ],
  "10": [
    "serviceIcon", "upperLogo", "voucherTitle", "pnrNo", "otherSummary",
    "supplierName", "counterReservationCode", "serviceName", "serviceCode",
    "serviceDate", "serviceEndDate", "totalPax", "description",
    "passengerName", "priceSummary", "note", "lowerLogo", "footer"
  ]
},
      voucherFieldLabels: {
  "upperLogo": {
    "tr": "Üst Logo",
    "en": "Upper Logo",
    "de": "Oberes Logo",
    "fr": "Logo supérieur"
  },
  "voucherTitle": {
    "tr": "Voucher Başlığı",
    "en": "Voucher Title",
    "de": "Voucher-Titel",
    "fr": "Titre du voucher"
  },
  "supplierName": {
    "tr": "Firma / Tedarikçi Adı",
    "en": "Company / Supplier Name",
    "de": "Firmen- / Lieferantenname",
    "fr": "Nom de la société / du fournisseur"
  },
  "supplierPhone": {
    "tr": "Firma Telefonu",
    "en": "Company Telephone",
    "de": "Firmentelefon",
    "fr": "Téléphone de la société"
  },
  "supplierAddress": {
    "tr": "Firma Adresi",
    "en": "Company Address",
    "de": "Firmenadresse",
    "fr": "Adresse de la société"
  },
  "supplierEmail": {
    "tr": "Firma E-postası",
    "en": "Company Email",
    "de": "Firmen-E-Mail",
    "fr": "E-mail de la société"
  },
  "counterReservationCode": {
    "tr": "Karşı Rezervasyon Kodu",
    "en": "Counter Reservation Code",
    "de": "Gegenreservierungscode",
    "fr": "Code de réservation correspondant"
  },
  "bookedByPhone": {
    "tr": "Rezervasyon Yapan Telefonu",
    "en": "Booked By Phone",
    "de": "Telefon des Buchenden",
    "fr": "Téléphone du réservataire"
  },
  "roomOrder": {
    "tr": "Oda Sırası",
    "en": "Room Row",
    "de": "Zimmerreihe",
    "fr": "Ligne de chambre"
  },
  "pnrNo": {
    "tr": "PNR No",
    "en": "PNR No",
    "de": "PNR-Nr.",
    "fr": "N° PNR"
  },
  "personType": {
    "tr": "Kişi Tipi",
    "en": "Person Type",
    "de": "Personentyp",
    "fr": "Type de personne"
  },
  "passengerName": {
    "tr": "Yolcu Adı",
    "en": "Passenger Name",
    "de": "Passagiername",
    "fr": "Nom du passager"
  },
  "passengerReservationNo": {
    "tr": "Yolcu Rezervasyon No",
    "en": "Passenger Reservation No",
    "de": "Passagier-Reservierungsnr.",
    "fr": "N° de réservation du passager"
  },
  "nationality": {
    "tr": "Uyruk",
    "en": "Nationality",
    "de": "Nationalität",
    "fr": "Nationalité"
  },
  "passportNumber": {
    "tr": "Pasaport Numarası",
    "en": "Passport Number",
    "de": "Reisepassnummer",
    "fr": "Numéro de passeport"
  },
  "birthDate": {
    "tr": "Doğum Tarihi",
    "en": "Birth Date",
    "de": "Geburtsdatum",
    "fr": "Date de naissance"
  },
  "checkInDate": {
    "tr": "Giriş Tarihi",
    "en": "Check-in Date",
    "de": "Check-in-Datum",
    "fr": "Date d’arrivée"
  },
  "checkOutDate": {
    "tr": "Çıkış Tarihi",
    "en": "Check-out Date",
    "de": "Check-out-Datum",
    "fr": "Date de départ"
  },
  "nightCount": {
    "tr": "Gece Sayısı",
    "en": "Night Count",
    "de": "Anzahl Nächte",
    "fr": "Nombre de nuits"
  },
  "boardRoomType": {
    "tr": "Pansiyon / Oda Tipi",
    "en": "Board / Room Type",
    "de": "Verpflegung / Zimmertyp",
    "fr": "Pension / Type de chambre"
  },
  "totalPax": {
    "tr": "Toplam Pax",
    "en": "Total Pax",
    "de": "Gesamt-Pax",
    "fr": "Total pax"
  },
  "totalRoom": {
    "tr": "Toplam Oda",
    "en": "Total Rooms",
    "de": "Gesamtzimmer",
    "fr": "Total chambres"
  },
  "pax": {
    "tr": "Pax",
    "en": "Pax",
    "de": "Pax",
    "fr": "Pax"
  },
  "restaurantMenu": {
    "tr": "Menü Bilgileri",
    "en": "Menu Information",
    "de": "Menüinformationen",
    "fr": "Informations du menu"
  },
  "departureDate": {
    "tr": "Hareket Tarihi",
    "en": "Departure Date",
    "de": "Abfahrtsdatum",
    "fr": "Date de départ"
  },
  "departureTime": {
    "tr": "Hareket Saati",
    "en": "Departure Time",
    "de": "Abfahrtszeit",
    "fr": "Heure de départ"
  },
  "arrivalDeparture": {
    "tr": "Arrival / Departure",
    "en": "Arrival / Departure",
    "de": "Ankunft / Abflug",
    "fr": "Arrivée / Départ"
  },
  "flightNumber": {
    "tr": "Uçuş Numarası",
    "en": "Flight Number",
    "de": "Flugnummer",
    "fr": "Numéro de vol"
  },
  "flightTime": {
    "tr": "Uçuş Saati",
    "en": "Flight Time",
    "de": "Flugzeit",
    "fr": "Heure de vol"
  },
  "departurePlace": {
    "tr": "Hareket Yeri",
    "en": "Departure Place",
    "de": "Abfahrtsort",
    "fr": "Lieu de départ"
  },
  "destination": {
    "tr": "Varış Yeri",
    "en": "Destination",
    "de": "Zielort",
    "fr": "Destination"
  },
  "vehicle": {
    "tr": "Araç",
    "en": "Vehicle",
    "de": "Fahrzeug",
    "fr": "Véhicule"
  },
  "vehicleCategory": {
    "tr": "Araç Kategorisi",
    "en": "Vehicle Category",
    "de": "Fahrzeugkategorie",
    "fr": "Catégorie du véhicule"
  },
  "vehicleCount": {
    "tr": "Araç Adedi",
    "en": "Vehicle Count",
    "de": "Fahrzeuganzahl",
    "fr": "Nombre de véhicules"
  },
  "vehicleDay": {
    "tr": "Gün",
    "en": "Day",
    "de": "Tag",
    "fr": "Jour"
  },
  "pickupReturnInfo": {
    "tr": "Alış / Bırakış Bilgileri",
    "en": "Pickup / Return Information",
    "de": "Abhol- / Rückgabeinformationen",
    "fr": "Informations de prise / retour"
  },
  "extraServices": {
    "tr": "Ek Hizmetler",
    "en": "Extra Services",
    "de": "Zusatzleistungen",
    "fr": "Services supplémentaires"
  },
  "tourType": {
    "tr": "Tur Tipi",
    "en": "Tour Type",
    "de": "Tourtyp",
    "fr": "Type de circuit"
  },
  "meetingDate": {
    "tr": "Buluşma Tarihi",
    "en": "Meeting Date",
    "de": "Treffdatum",
    "fr": "Date de rendez-vous"
  },
  "tourKind": {
    "tr": "Tur Türü",
    "en": "Tour Kind",
    "de": "Tourart",
    "fr": "Genre de circuit"
  },
  "meetingTime": {
    "tr": "Buluşma Saati",
    "en": "Meeting Time",
    "de": "Treffzeit",
    "fr": "Heure de rendez-vous"
  },
  "tourDuration": {
    "tr": "Tur Süresi",
    "en": "Tour Duration",
    "de": "Tourdauer",
    "fr": "Durée du circuit"
  },
  "meetingPlace": {
    "tr": "Buluşma Yeri",
    "en": "Meeting Place",
    "de": "Treffpunkt",
    "fr": "Lieu de rendez-vous"
  },
  "tourGuide": {
    "tr": "Tur Rehberi",
    "en": "Tour Guide",
    "de": "Reiseleiter",
    "fr": "Guide touristique"
  },
  "shipName": {
    "tr": "Gemi Adı",
    "en": "Ship Name",
    "de": "Schiffsname",
    "fr": "Nom du navire"
  },
  "entrancesIncluded": {
    "tr": "Girişler Dahil",
    "en": "Entrances Included",
    "de": "Eintritte inklusive",
    "fr": "Entrées incluses"
  },
  "returnInfo": {
    "tr": "Dönüş Bilgileri",
    "en": "Return Information",
    "de": "Rückkehrinformationen",
    "fr": "Informations de retour"
  },
  "mealsIncluded": {
    "tr": "Yemekler Dahil",
    "en": "Meals Included",
    "de": "Mahlzeiten inklusive",
    "fr": "Repas inclus"
  },
  "note": {
    "tr": "Not / İptal Prosedürü",
    "en": "Note / Cancellation Procedure",
    "de": "Notiz / Stornierungsverfahren",
    "fr": "Note / Procédure d’annulation"
  },
  "terms": {
    "tr": "Şartlar ve Koşullar",
    "en": "Terms and Conditions",
    "de": "Allgemeine Geschäftsbedingungen",
    "fr": "Conditions générales"
  },
  "companyInfo": {
    "tr": "Alt Şirket Bilgileri",
    "en": "Footer Company Information",
    "de": "Firmeninformationen in der Fußzeile",
    "fr": "Informations société en pied de page"
  },
  "bookedByInfo": {
    "tr": "Rezervasyon Yapan Bilgileri",
    "en": "Booked By Information",
    "de": "Informationen zum Buchenden",
    "fr": "Informations du réservataire"
  },
  "printDate": {
    "tr": "Basım Tarihi / Saati",
    "en": "Print Date / Time",
    "de": "Druckdatum / -zeit",
    "fr": "Date / heure d’impression"
  },
  "serviceIcon": {
    "tr": "Hizmet İkonu", "en": "Service Icon", "de": "Leistungssymbol", "fr": "Icône du service"
  },
  "routeSummary": {
    "tr": "Rota Özeti", "en": "Route Summary", "de": "Routenübersicht", "fr": "Résumé de l’itinéraire"
  },
  "transferType": {
    "tr": "Transfer Tipi", "en": "Transfer Type", "de": "Transfertyp", "fr": "Type de transfert"
  },
  "tourOperator": {
    "tr": "Tur Operatörü", "en": "Tour Operator", "de": "Reiseveranstalter", "fr": "Tour-opérateur"
  },
  "driverName": {
    "tr": "Sürücü Adı", "en": "Driver Name", "de": "Fahrername", "fr": "Nom du chauffeur"
  },
  "driverPhone": {
    "tr": "Sürücü Telefonu", "en": "Driver Phone", "de": "Fahrertelefon", "fr": "Téléphone du chauffeur"
  },
  "plateNumber": {
    "tr": "Plaka", "en": "Plate Number", "de": "Kennzeichen", "fr": "Plaque d’immatriculation"
  },
  "priceSummary": {
    "tr": "Fiyat Özeti", "en": "Price Summary", "de": "Preisübersicht", "fr": "Résumé du prix"
  },
  "footer": {
    "tr": "Alt Bilgi", "en": "Footer", "de": "Fußzeile", "fr": "Pied de page"
  },
  "vehicleSummary": {
    "tr": "Araç Özeti", "en": "Vehicle Summary", "de": "Fahrzeugübersicht", "fr": "Résumé du véhicule"
  },
  "pickupLocation": {
    "tr": "Alış Yeri", "en": "Pickup Location", "de": "Abholort", "fr": "Lieu de prise en charge"
  },
  "pickupDate": {
    "tr": "Alış Tarihi", "en": "Pickup Date", "de": "Abholdatum", "fr": "Date de prise en charge"
  },
  "pickupTime": {
    "tr": "Alış Saati", "en": "Pickup Time", "de": "Abholzeit", "fr": "Heure de prise en charge"
  },
  "dropoffLocation": {
    "tr": "Bırakış Yeri", "en": "Drop-off Location", "de": "Rückgabeort", "fr": "Lieu de restitution"
  },
  "dropoffDate": {
    "tr": "Bırakış Tarihi", "en": "Drop-off Date", "de": "Rückgabedatum", "fr": "Date de restitution"
  },
  "dropoffTime": {
    "tr": "Bırakış Saati", "en": "Drop-off Time", "de": "Rückgabezeit", "fr": "Heure de restitution"
  },
  "dailyTourSummary": {
    "tr": "Günlük Tur Özeti", "en": "Daily Tour Summary", "de": "Tagestour-Übersicht", "fr": "Résumé de l’excursion"
  },
  "tourCode": {
    "tr": "Tur Kodu", "en": "Tour Code", "de": "Tourcode", "fr": "Code du circuit"
  },
  "tourDate": {
    "tr": "Tur Tarihi", "en": "Tour Date", "de": "Tourdatum", "fr": "Date du circuit"
  },
  "tourTime": {
    "tr": "Tur Saati", "en": "Tour Time", "de": "Tourzeit", "fr": "Heure du circuit"
  },
  "program": {
    "tr": "Program", "en": "Program", "de": "Programm", "fr": "Programme"
  },
  "flightRouteSummary": {
    "tr": "Uçuş Rota Özeti", "en": "Flight Route Summary", "de": "Flugroutenübersicht", "fr": "Résumé de l’itinéraire de vol"
  },
  "airlineCode": {
    "tr": "Havayolu Kodu", "en": "Airline Code", "de": "Airline-Code", "fr": "Code compagnie aérienne"
  },
  "flightType": {
    "tr": "Uçuş Tipi", "en": "Flight Type", "de": "Flugtyp", "fr": "Type de vol"
  },
  "classType": {
    "tr": "Sınıf Tipi", "en": "Class Type", "de": "Klassenart", "fr": "Type de classe"
  },
  "cruiseSummary": {
    "tr": "Gemi Özeti", "en": "Cruise Summary", "de": "Kreuzfahrtübersicht", "fr": "Résumé de la croisière"
  },
  "cruiseName": {
    "tr": "Gemi / Cruise Adı", "en": "Cruise Name", "de": "Kreuzfahrtname", "fr": "Nom de la croisière"
  },
  "cruiseLocation": {
    "tr": "Gemi Konumu", "en": "Cruise Location", "de": "Kreuzfahrtort", "fr": "Lieu de la croisière"
  },
  "cabinType": {
    "tr": "Kabin Tipi", "en": "Cabin Type", "de": "Kabinentyp", "fr": "Type de cabine"
  },
  "country": {
    "tr": "Ülke", "en": "Country", "de": "Land", "fr": "Pays"
  },
  "otherSummary": {
    "tr": "Hizmet Özeti", "en": "Service Summary", "de": "Leistungsübersicht", "fr": "Résumé du service"
  },
  "serviceName": {
    "tr": "Hizmet Adı", "en": "Service Name", "de": "Leistungsname", "fr": "Nom du service"
  },
  "serviceCode": {
    "tr": "Hizmet Kodu", "en": "Service Code", "de": "Leistungscode", "fr": "Code du service"
  },
  "serviceDate": {
    "tr": "Hizmet Başlangıç Tarihi", "en": "Service Start Date", "de": "Leistungsbeginn", "fr": "Date de début du service"
  },
  "serviceEndDate": {
    "tr": "Hizmet Bitiş Tarihi", "en": "Service End Date", "de": "Leistungsende", "fr": "Date de fin du service"
  },
  "description": {
    "tr": "Açıklama", "en": "Description", "de": "Beschreibung", "fr": "Description"
  },
  "recordDate": {
    "tr": "Kayıt Tarihi", "en": "Record Date", "de": "Erfassungsdatum", "fr": "Date d’enregistrement"
  },
  "passengerPhone": {
    "tr": "Yolcu Telefonu", "en": "Passenger Phone", "de": "Passagiertelefon", "fr": "Téléphone du passager"
  },
  "identityNumber": {
    "tr": "Kimlik Numarası", "en": "Identity Number", "de": "Identitätsnummer", "fr": "Numéro d’identité"
  },
  "agencyInfo": {
    "tr": "Acente Bilgisi", "en": "Agency Information", "de": "Agenturinformationen", "fr": "Informations agence"
  },
  "customerInfo": {
    "tr": "Cari Bilgisi", "en": "Customer Information", "de": "Kundeninformationen", "fr": "Informations client"
  },
  "services": {
    "tr": "Hizmetler", "en": "Services", "de": "Leistungen", "fr": "Services"
  },
  "lowerLogo": {
    "tr": "Alt Logo",
    "en": "Lower Logo",
    "de": "Unteres Logo",
    "fr": "Logo inférieur"
  }
},
      voucherUiTexts: {
  "fieldSelect": {
    "tr": "Voucher’da Gösterilecek Alanlar",
    "en": "Fields to Show on Voucher",
    "de": "Auf dem Voucher anzuzeigende Felder",
    "fr": "Champs à afficher sur le voucher"
  },
  "selectAll": {
    "tr": "Tümü",
    "en": "All",
    "de": "Alle",
    "fr": "Tous"
  },
  "clear": {
    "tr": "Temizle",
    "en": "Clear",
    "de": "Leeren",
    "fr": "Effacer"
  },
  "companyNameOverride": {
    "tr": "Görünecek Firma İsmi",
    "en": "Company Name to Show",
    "de": "Anzuzeigender Firmenname",
    "fr": "Nom de la société à afficher"
  }
},
      selectedSalerType:0
    };
  },

  watch: {
    selectedVoucherItems(newVal) {
      this.voucherCustomCompanyName =
        (newVal && newVal.SirketBilgileri && newVal.SirketBilgileri.SirketIsmi) || "";
    },
  },

  created() {},
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.prevRoute = from.path;
    });
  },
  mounted() {
    this.sayfayetki = helpers.pageScreenAuth(this.$route.name);
    
    if (this.sayfayetki.Status == true) {
      this.loadingStatus = true;
      this.pnr = this.$route.query.PNR_No;
      this.otelvoucherYazdir(this.$route.query.PNR_No, 0,this.$route.query.Tip);
    } else {
      this.$refs.yetkidialog
        .open(this.sayfayetki.Message, this.sayfayetki.islem)
        .then((sonuc) => {
          if (sonuc == true) {
            if (this.prevRoute != null) {
              var url = "#" + this.prevRoute;

              window.open(url, "_self");
            } else {
              var url = "#/";
              window.open(url, "_self");
            }
          } else {
          }
        });
    }
  },
  beforeDestroy() {
    this.releaseVoucherPdfPreviewUrl();
  },
  methods: {
    isVoucherFieldSelectionSupported(saticiTipi) {
      var type = parseInt(saticiTipi || 0);
      return [1, 2, 3, 4, 5, 8, 9, 10].indexOf(type) >= 0;
    },
    getVoucherLocaleKey() {
      if (["tr", "en", "de", "fr"].indexOf(this.locale) >= 0) {
        return this.locale;
      }
      return "tr";
    },
    getVoucherFieldLabel(fieldKey) {
      var localeKey = this.getVoucherLocaleKey();
      var fieldLabel = this.voucherFieldLabels[fieldKey];
      if (!fieldLabel) {
        return fieldKey;
      }
      return fieldLabel[localeKey] || fieldLabel.tr || fieldKey;
    },
    getVoucherUiText(textKey) {
      var localeKey = this.getVoucherLocaleKey();
      var textItem = this.voucherUiTexts[textKey];
      if (!textItem) {
        return textKey;
      }
      return textItem[localeKey] || textItem.tr || textKey;
    },
    getVoucherFieldStorageKey(saticiTipi) {
      var credentials = {};
      try {
        var rawCredentials = window.localStorage.getItem("credentials");
        credentials = rawCredentials ? JSON.parse(rawCredentials) : {};
      } catch (error) {
        credentials = {};
      }

      var companyCode = credentials.SirketKodu || credentials.CoperSirketNo || "0";
      var userCode =
        credentials.UserID ||
        credentials.UserId ||
        credentials.KullaniciKodu ||
        credentials.UserName ||
        credentials.Kod ||
        "default";

      return (
        "voucher-visible-fields-" +
        companyCode +
        "-" +
        userCode +
        "-" +
        saticiTipi
      );
    },
    getDefaultVoucherFields(saticiTipi) {
      if (!this.isVoucherFieldSelectionSupported(saticiTipi)) {
        return [];
      }

      var fields = this.voucherFieldDefinitions[saticiTipi] || [];
      return fields.slice();
    },
    loadVoucherFieldSelection(saticiTipi) {
      if (!this.isVoucherFieldSelectionSupported(saticiTipi)) {
        this.selectedVoucherFields = [];
        return;
      }

      var availableFields = this.getDefaultVoucherFields(saticiTipi);
      var storageKey = this.getVoucherFieldStorageKey(saticiTipi);
      var savedFields = null;

      try {
        var savedValue = window.localStorage.getItem(storageKey);
        savedFields = savedValue ? JSON.parse(savedValue) : null;
      } catch (error) {
        savedFields = null;
      }

      if (Array.isArray(savedFields)) {
        this.selectedVoucherFields = savedFields.filter((fieldKey) => {
          return availableFields.indexOf(fieldKey) >= 0;
        });
      } else {
        this.selectedVoucherFields = availableFields;
      }
    },
    saveVoucherFieldSelection() {
      if (!this.isVoucherFieldSelectionSupported(this.selectedSalerType)) {
        return;
      }

      var availableFields = this.getDefaultVoucherFields(this.selectedSalerType);
      var validSelectedFields = (this.selectedVoucherFields || []).filter(
        (fieldKey) => availableFields.indexOf(fieldKey) >= 0
      );

      this.selectedVoucherFields = validSelectedFields;
      window.localStorage.setItem(
        this.getVoucherFieldStorageKey(this.selectedSalerType),
        JSON.stringify(validSelectedFields)
      );

      this.$nextTick(() => {
        this.refreshVoucherImages();
      });
    },
    selectAllVoucherFields() {
      if (!this.isVoucherFieldSelectionSupported(this.selectedSalerType)) {
        return;
      }
      this.selectedVoucherFields = this.getDefaultVoucherFields(
        this.selectedSalerType
      );
      this.saveVoucherFieldSelection();
    },
    clearVoucherFields() {
      if (!this.isVoucherFieldSelectionSupported(this.selectedSalerType)) {
        return;
      }
      this.selectedVoucherFields = [];
      this.saveVoucherFieldSelection();
    },
    showVoucherField(fieldKey) {
      return (this.selectedVoucherFields || []).indexOf(fieldKey) >= 0;
    },
    showAnyVoucherField(fieldKeys) {
      return fieldKeys.some((fieldKey) => this.showVoucherField(fieldKey));
    },
    refreshVoucherImages() {
      this.$nextTick(() => {
        if (this.showVoucherField("upperLogo")) {
          this.addUpImage(this.voucherInfo.UstLogoUrl);
        }
        if (this.showVoucherField("lowerLogo")) {
          this.addDownImage(this.voucherInfo.AltLogoUrl);
        }
      });
    },
  EmailGonderPdf() {
    // Formu temizle (cc alanın yoksa kalsın, varsa kullanılır)
    this.form = {
      pnrNo: '',
      to: '',
      cc: '',
      agencyName: '',
      agentFullName: '',
      docType: null,
    };
    this.emailValid = false;

    // Var ise validasyon mesajlarını temizle
    this.$nextTick(() => {
      if (this.$refs.emailForm && this.$refs.emailForm.resetValidation) {
        this.$refs.emailForm.resetValidation();
      }
    });

    // Popup'ı aç
    this.emailDialog = true;
  },

  // Dialog içindeki "Gönder" butonu / form submit
  async submitEmail(force = true) {
  console.log('[submitEmail] click');
  this.submitting = true;

  try {
    if (!force && this.$refs.emailForm && this.$refs.emailForm.validate) {
      const result = await this.$refs.emailForm.validate();
      const isValid = typeof result === 'object' ? !!result.valid : !!result;
      if (!isValid) {
        console.warn('[submitEmail] form invalid -> gönderim iptal');
        return;
      }
    }

    // payload (body)
    const params = {
      pnrNo: this.form.pnrNo,
      to: this.form.to,
      cc: this.form.cc || null,
      agencyName: this.form.agencyName,
      agentFullName: this.form.agentFullName,
      docType: this.form.docType,
    };

    // credentials & headers (undefined/null güvenli)
    var rawCreds = window.localStorage.getItem('credentials');
    var credentials = rawCreds ? JSON.parse(rawCreds) : {};

    var headers = {
      // Authorization gerekiyorsa ekle
      // "Bearer " + auth.getAuthHeader() senin projende token döndürüyorsa:
      Authorization: 'Bearer ' + (auth && typeof auth.getAuthHeader === 'function' ? auth.getAuthHeader() : ''),
      'CariSirketNo': (credentials && credentials.SirketKodu != null) ? credentials.SirketKodu.toString() : '',
      'CoperSirketNo': (credentials && credentials.CoperSirketNo != null) ? credentials.CoperSirketNo.toString() : '',
      'MuhasebeSirketNo': (credentials && credentials.MuhasebeSirketNo != null) ? credentials.MuhasebeSirketNo.toString() : '',
    };

    // NOT: tool.http_post'un 4. argümanı options/headers ise:
    const res = await tool.http_post(this, 'EmailGonderPdf', params, { headers });

    console.log('[submitEmail] OK', res);
    this.$toast && this.$toast.success && this.$toast.success('E-posta gönderildi');
    this.emailDialog = false;
  } catch (err) {
    console.error('[submitEmail] ERROR', err);
    this.$toast && this.$toast.error && this.$toast.error('Gönderim sırasında hata oluştu');
  } finally {
    this.submitting = false;
  }
},

getVoucherPdfTypeInfo() {
    const type = parseInt(this.selectedSalerType || 0);
    const infos = {
      1: { tr: 'Otel Voucher', en: 'Hotel Voucher', de: 'Hotel Voucher', fr: 'Voucher Hôtel', file: 'HotelVoucher' },
      2: { tr: 'Transfer Voucher', en: 'Transfer Voucher', de: 'Transfer Voucher', fr: 'Voucher Transfert', file: 'TransferVoucher' },
      3: { tr: 'Restaurant Voucher', en: 'Restaurant Voucher', de: 'Restaurant Voucher', fr: 'Voucher Restaurant', file: 'RestaurantVoucher' },
      4: { tr: 'Günlük Tur Voucher', en: 'Daily Tour Voucher', de: 'Tagestour Voucher', fr: 'Voucher Excursion', file: 'DailyTourVoucher' },
      5: { tr: 'Rent A Car Voucher', en: 'Rent A Car Voucher', de: 'Mietwagen Voucher', fr: 'Voucher Location de Voiture', file: 'RentACarVoucher' },
      8: { tr: 'Uçuş Voucher', en: 'Flight Voucher', de: 'Flug Voucher', fr: 'Voucher Vol', file: 'FlightVoucher' },
      9: { tr: 'Gemi Voucher', en: 'Cruise Voucher', de: 'Kreuzfahrt Voucher', fr: 'Voucher Croisière', file: 'CruiseVoucher' },
      10: { tr: 'Diğer Voucher', en: 'Other Voucher', de: 'Sonstiger Voucher', fr: 'Autre Voucher', file: 'OtherVoucher' },
      11: { tr: 'Genel Voucher', en: 'General Voucher', de: 'Allgemeiner Voucher', fr: 'Voucher Général', file: 'GeneralVoucher' },
    };

    return infos[type] || {
      tr: 'Voucher',
      en: 'Voucher',
      de: 'Voucher',
      fr: 'Voucher',
      file: 'Voucher',
    };
  },

  getVoucherPdfLocalizedName() {
    const info = this.getVoucherPdfTypeInfo();
    return info[this.locale] || info.tr || 'Voucher';
  },

  getVoucherPdfDialogTitle() {
    return this.getVoucherPdfLocalizedName() + ' PDF';
  },

  getVoucherPdfPreviewTitle() {
    const suffix = {
      tr: ' Önizleme',
      en: ' Preview',
      de: ' Vorschau',
      fr: ' Aperçu',
    };

    return this.getVoucherPdfLocalizedName() + ' PDF' + (suffix[this.locale] || suffix.tr);
  },

  getVoucherPdfInformationText() {
    const texts = {
      tr: 'PDF, yukarıda seçili olan alanlara göre oluşturulacaktır.',
      en: 'The PDF will be created with the fields currently selected above.',
      de: 'Das PDF wird mit den oben ausgewählten Feldern erstellt.',
      fr: 'Le PDF sera créé avec les champs sélectionnés ci-dessus.',
    };

    return texts[this.locale] || texts.tr;
  },

  openVoucherPdfDialog() {
    var voucherType = parseInt(this.selectedSalerType || 0);

    if (!voucherType) {
      this.mesaj = this.locale === 'en'
        ? 'Please select a voucher first.'
        : 'Lütfen önce bir voucher seçiniz.';
      this.snackbar = true;
      return;
    }

    if (voucherType === 11) {
      this.downloadGeneralVoucherPdfOldFlow();
      return;
    }

    this.voucherPdf.pnrNo = this.pnr || this.$route.query.PNR_No || '';
    this.voucherPdf.lang = ['tr', 'en', 'de', 'fr'].indexOf(this.locale) >= 0
      ? this.locale
      : 'tr';
    this.voucherPdfDialog = true;

    this.$nextTick(() => {
      this.$refs.voucherPdfForm && this.$refs.voucherPdfForm.resetValidation();
    });
  },

  downloadGeneralVoucherPdfOldFlow() {
    const pnrNo = Number(this.pnr || this.$route.query.PNR_No || 0);
    const lang = ['tr', 'en', 'de'].indexOf(this.locale) >= 0
      ? this.locale
      : 'tr';

    if (!pnrNo) {
      this.mesaj = this.locale === 'en'
        ? 'A valid PNR number is required.'
        : 'Geçerli bir PNR numarası gereklidir.';
      this.snackbar = true;
      return;
    }

    const credentials = JSON.parse(
      window.localStorage.getItem('credentials') || '{}'
    );

    this.loadingStatus = true;

    this.$http.post(
      auth.API_URL + 'api/Coper/GenelVoucherPdfDownload',
      {
        PnrNo: pnrNo,
        Lang: lang,
      },
      {
        headers: {
          Authorization: 'Bearer ' + auth.getAuthHeader(),
          CariSirketNo: credentials.SirketKodu != null
            ? credentials.SirketKodu.toString()
            : '',
          CoperSirketNo: credentials.CoperSirketNo != null
            ? credentials.CoperSirketNo.toString()
            : '',
          MuhasebeSirketNo: credentials.MuhasebeSirketNo != null
            ? credentials.MuhasebeSirketNo.toString()
            : '',
        },
        responseType: 'arraybuffer',
      }
    ).then((response) => {
      const responseData = response.data || response.body;
      const blob = new Blob([responseData], {
        type: 'application/pdf',
      });
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');

      link.href = url;
      link.download = `GenelVoucher_${pnrNo}.pdf`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    }).catch((error) => {
      console.error('Genel Voucher PDF oluşturulamadı', error);
      this.mesaj = this.locale === 'en'
        ? 'General Voucher PDF could not be created.'
        : 'Genel Voucher PDF oluşturulamadı.';
      this.snackbar = true;
    }).finally(() => {
      this.loadingStatus = false;
    });
  },

  async submitVoucherPdfDownload() {
    const ok = this.$refs.voucherPdfForm && this.$refs.voucherPdfForm.validate();
    if (!ok) return;

    try {
      this.submittingVoucherPdf = true;
      await this.createVoucherPdfPreview(
        this.voucherPdf.pnrNo,
        this.voucherPdf.lang
      );
      this.voucherPdfDialog = false;
    } finally {
      this.submittingVoucherPdf = false;
    }
  },

  createHotelVoucherPdfPreview(pnrNo, lang) {
    return this.createVoucherPdfPreview(pnrNo, lang);
  },

  createVoucherPdfPreview(pnrNo, lang) {
    if (parseInt(this.selectedSalerType || 0) === 11) {
      this.downloadGeneralVoucherPdfOldFlow();
      return Promise.resolve();
    }

    const credentials = JSON.parse(
      window.localStorage.getItem('credentials') || '{}'
    );

    const params = {
      PnrNo: Number(pnrNo),
      Lang: lang || 'tr',
      SellerCode: this.secilenSaticiKod == null
        ? ''
        : String(this.secilenSaticiKod),
      VoucherType: parseInt(this.selectedSalerType || 0),
      KalemDetay: !!this.KalemDetay,
      IsimleriAyir: !!this.IsimleriAyir,
      Fields: (this.selectedVoucherFields || []).slice(),
    };

    return this.$http.post(
      auth.API_URL + 'api/Coper/VoucherPdfPreview',
      params,
      {
        headers: {
          Authorization: 'Bearer ' + auth.getAuthHeader(),
          CariSirketNo: credentials.SirketKodu != null
            ? credentials.SirketKodu.toString()
            : '',
          CoperSirketNo: credentials.CoperSirketNo != null
            ? credentials.CoperSirketNo.toString()
            : '',
          MuhasebeSirketNo: credentials.MuhasebeSirketNo != null
            ? credentials.MuhasebeSirketNo.toString()
            : '',
        },
        responseType: 'arraybuffer',
      }
    ).then((response) => {
      this.releaseVoucherPdfPreviewUrl();

      this.voucherPdfPreviewBlob = new Blob([response.data], {
        type: 'application/pdf',
      });
      this.voucherPdfPreviewUrl = URL.createObjectURL(
        this.voucherPdfPreviewBlob
      );

      const filePrefix = this.getVoucherPdfTypeInfo().file || 'Voucher';
      this.voucherPdfPreviewFileName = `${filePrefix}_${pnrNo}_${lang}.pdf`;
      this.voucherPdfPreviewDialog = true;
    }).catch((error) => {
      console.error('Voucher PDF oluşturulamadı', error);
      this.mesaj = this.locale === 'en'
        ? 'Voucher PDF could not be created.'
        : 'Voucher PDF oluşturulamadı.';
      this.snackbar = true;
      throw error;
    });
  },

  downloadVoucherPdfPreview() {
    if (!this.voucherPdfPreviewBlob) {
      return;
    }

    const url = URL.createObjectURL(this.voucherPdfPreviewBlob);
    const link = document.createElement('a');
    link.href = url;
    link.download = this.voucherPdfPreviewFileName || 'HotelVoucher.pdf';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  },

  closeVoucherPdfPreview() {
    this.voucherPdfPreviewDialog = false;
    this.releaseVoucherPdfPreviewUrl();
    this.voucherPdfPreviewBlob = null;
    this.voucherPdfPreviewFileName = '';
  },

  releaseVoucherPdfPreviewUrl() {
    if (this.voucherPdfPreviewUrl) {
      URL.revokeObjectURL(this.voucherPdfPreviewUrl);
      this.voucherPdfPreviewUrl = null;
    }
  },






    getVoucher(){
      this.tmpSayfalar=[];
      this.loadingStatus = true;
      this.voucheritems = [];
      this.itemsVoucherSaticilar = [];
      this.selectedVoucherItems = [];
      this.otelvoucherYazdir(this.$route.query.PNR_No, 0,this.$route.query.Tip);
    },
    formatDate(value){
      var date = value.split('-');
      return date[2] + "." + date[1] + "." + date[0]
    },
    checkTrueFalse(val){
      var _checkValue = this.checkValue.find(x => x.value == val);

      switch (this.locale) {
        case "tr":
          return _checkValue.textTR;
        case "en":
          return _checkValue.textEN;
        case "de":
          return _checkValue.textDE;
        case "fr":
          return _checkValue.textFR;
        default:
          break;
      }
    },
    checkItemsList(val){
      var _checkItems = this.checkItems.find(x => x.value == val);
      switch (this.locale) {
        case "tr":
          return _checkItems.textTR;
        case "en":
          return _checkItems.textEN;
        case "de":
          return _checkItems.textDE;
        case "fr":
          return _checkItems.textFR;
        default:
          break;
      }
    },
    getTurTuru(val){
     var _turTuru = this.TurTuru.find(x => x.value == val);
      switch (this.locale) {
        case "tr":
          return _turTuru.text;
        case "en":
          return _turTuru.text;
        case "de":
          return _turTuru.text;
        case "fr":
          return _turTuru.text;
        default:
          break;
      }
    },
    getTurTipi(val){
       var _turTipi = this.pantipitems.find(x => x.value == val);
      switch (this.locale) {
        case "tr":
          return _turTipi.textTR;
        case "en":
          return _turTipi.textEN;
        case "de":
          return _turTipi.textDE;
        case "fr":
          return _turTipi.textFR;
        default:
          break;
      }
    },
  getIconName: function (t) {
      let _resultIcon = null;
      this.SaticiIconList.forEach((element) => {
        if (element.Kod == t) {
          _resultIcon = element.IconName;
        }
      });
      return _resultIcon;
    },
    KisiTipToStr(tip) {
      if (tip == null) {
        tip = 0;
      }
      switch (this.locale) {
        case "tr":
          return this.KisiTip[tip].AciklamaTR;
        case "en":
          return this.KisiTip[tip].AciklamaEN;
        case "de":
          return this.KisiTip[tip].AciklamaDE;
        case "fr":
          return this.KisiTip[tip].AciklamaFR;
        default:
          break;
      }
    },
    voucherLoad2()
    {
      if (!this.secilenVoucherObje || !this.secilenVoucherObje.saticiTipi) {
        this.secilenSaticiKod = null;
        this.selectedSalerType = 0;
        this.selectedVoucherFields = [];
        this.selectedVoucherItems = [];
        this.vouchergoster = false;
        return;
      }

      // var voucherDetails = this.secilenVoucher.split('-');
      // if(voucherDetails.length == 4){
      //     this.secilenSaticiKod = voucherDetails[0] + "-" + voucherDetails[1];
      // }else{
      //     this.secilenSaticiKod = voucherDetails[0];
      // }
      this.secilenSaticiKod = this.secilenVoucherObje.value;
      switch (this.secilenVoucherObje.saticiTipi) {
          case 1://otel
          this.voucherSet(1);
          break;
          case 2: //arac
          this.voucherSet(2);
          break;
          case 3: //restaurant
          this.voucherSet(3);
          break;
          case 4: //acente
          this.voucherSet(4);
          break;
          case 5://rentacar 
          this.voucherSet(5);
          break;
        default:
          this.selectedSalerType = parseInt(this.secilenVoucherObje.saticiTipi || 0);
          this.loadVoucherFieldSelection(this.selectedSalerType);
          break;
      }

    },
    voucherLoad() {
      if (!this.secilenVoucherObje || !this.secilenVoucherObje.saticiTipi) {
        this.secilenSaticiKod = null;
        this.selectedSalerType = 0;
        this.selectedVoucherFields = [];
        this.selectedVoucherItems = [];
        this.vouchergoster = false;
        return;
      }
  
      var voucherDetails = this.secilenVoucherObje;
      
      // if(voucherDetails.length == 4){
      //     this.secilenSaticiKod = voucherDetails[0] + "-" + voucherDetails[1];
      // }else{
      //     this.secilenSaticiKod = voucherDetails[0];
      // }
      this.secilenSaticiKod = this.secilenVoucherObje.value;
      switch (this.secilenVoucherObje.saticiTipi) {
          case 1://otel
          this.voucherSet(1);
          break;
          case 2: //arac
          this.voucherSet(2);
          break;
          case 3: //restaurant
          this.voucherSet(3);
          break;
          case 4: //acente
          this.voucherSet(4);
          break;
          case 5://rentacar 
          this.voucherSet(5);
          break;
        default:
          this.selectedSalerType = parseInt(this.secilenVoucherObje.saticiTipi || 0);
          this.loadVoucherFieldSelection(this.selectedSalerType);
          break;
      }

    },
    voucherSet(Tip){
      this.selectedSalerType = parseInt(Tip);
      this.loadVoucherFieldSelection(this.selectedSalerType);
    switch (parseInt(Tip)) {

          case 1://otel
         
         
         if (this.IsimleriAyir==true)
         {
          if (this.tmpSayfalar.length==0)
          {
           
            for (let i = 0; i <  this.voucheritems.OtelVoucher.Sayfalar.length; i++) {
           
              this.tmpSayfalar.push(this.voucheritems.OtelVoucher.Sayfalar[i]);
         }
          }
          else
          {
            this.voucheritems.OtelVoucher.Sayfalar=[];
            for (let i = 0; i <  this.tmpSayfalar.length; i++) {
           
              
              this.voucheritems.OtelVoucher.Sayfalar.push(this.tmpSayfalar[i]);
      }
           
          }
         
         
var seciliRapors=this.secilenVoucherObje.raporNo;
var seciliRapor=seciliRapors;


          this.selectedVoucherItems = this.voucheritems.OtelVoucher;
          this.voucherInfo.Aciklamalar = this.voucheritems.OtelVoucher.Aciklamalar;
          this.YedekAciklamalar = this.voucheritems.OtelVoucher.Aciklamalar;
          this.voucherInfo.SirketBilgileri = this.voucheritems.OtelVoucher.SirketBilgileri;
           this.voucherInfo.Sayfalar = this.voucheritems.OtelVoucher.Sayfalar;
          
for (let g = 0; g < this.voucheritems.OtelVoucher.Sayfalar.length; g++) {
  for (let i = 0; i < this.voucherInfo.Sayfalar.length; i++) {
          
           if (this.voucherInfo.Sayfalar[i].RaporNo!=seciliRapor)
           {
             this.voucherInfo.Sayfalar.splice(i,1);
             break;
           }
         }
          
         }
         if (this.voucherInfo.Sayfalar.length>1)
         {
          if (this.voucherInfo.Sayfalar[0].RaporNo!=seciliRapor)
          {
            this.voucherInfo.Sayfalar.splice(0,1);
          }
          else
          {
            this.voucherInfo.Sayfalar.splice(this.voucherInfo.Sayfalar.length-1,1);
          }
         }
        

          var _odaText = this.voucherInfo.Sayfalar[0].OdaToplamlari.map(
          function (item) {
            return item.Adet + " " + item.OdaKodu + " ";
          }
          );
          this.toplamOdaText = _odaText.toString();
          this.isAcente = false;
          this.isRentACar = false;
          this.isTransfer = false;
          this.isRestaurant = false;
          this.isOtel = true;
          this.vouchergoster = true;
         }
         else
         {
          this.selectedVoucherItems = this.voucheritems.OtelVoucher;
          this.voucherInfo.Aciklamalar = this.voucheritems.OtelVoucher.Aciklamalar;
          this.YedekAciklamalar = this.voucheritems.OtelVoucher.Aciklamalar;
          this.voucherInfo.SirketBilgileri = this.voucheritems.OtelVoucher.SirketBilgileri;
          this.voucherInfo.Sayfalar = this.voucheritems.OtelVoucher.Sayfalar;
          var _odaText = this.voucherInfo.Sayfalar[0].OdaToplamlari.map(
          function (item) {
            return item.Adet + " " + item.OdaKodu + " ";
          }
          );
          this.toplamOdaText = _odaText.toString();
          this.isAcente = false;
          this.isRentACar = false;
          this.isTransfer = false;
          this.isRestaurant = false;
          this.isOtel = true;
          this.vouchergoster = true;
         }

          
         
          break;
          case 2: //arac
if (this.IsimleriAyir==true)
{
  if (this.tmpSayfalar.length==0)
          {
           
            for (let i = 0; i <  this.voucheritems.AracVoucher.Sayfalar.length; i++) {
           
              this.tmpSayfalar.push(this.voucheritems.AracVoucher.Sayfalar[i]);
         }
          }
          else
          {
            this.voucheritems.AracVoucher.Sayfalar=[];
            for (let i = 0; i <  this.tmpSayfalar.length; i++) {
           
              
              this.voucheritems.AracVoucher.Sayfalar.push(this.tmpSayfalar[i]);
      }
           
          }
         
         
var seciliRapors=this.secilenVoucherObje.raporNo;
var seciliRapor=seciliRapors;


          this.selectedVoucherItems = this.voucheritems.AracVoucher;
          this.voucherInfo.Aciklamalar = this.voucheritems.AracVoucher.Aciklamalar;
          this.YedekAciklamalar = this.voucheritems.AracVoucher.Aciklamalar;
          this.voucherInfo.SirketBilgileri = this.voucheritems.AracVoucher.SirketBilgileri;
           this.voucherInfo.Sayfalar = this.voucheritems.AracVoucher.Sayfalar;
          
for (let g = 0; g < this.voucheritems.AracVoucher.Sayfalar.length; g++) {
  for (let i = 0; i < this.voucherInfo.Sayfalar.length; i++) {
          
           if (this.voucherInfo.Sayfalar[i].RaporNo!=seciliRapor)
           {
             this.voucherInfo.Sayfalar.splice(i,1);
             break;
           }
         }
          
         }
         if (this.voucherInfo.Sayfalar.length>1)
         {
          if (this.voucherInfo.Sayfalar[0].RaporNo!=seciliRapor)
          {
            this.voucherInfo.Sayfalar.splice(0,1);
          }
          else
          {
            this.voucherInfo.Sayfalar.splice(this.voucherInfo.Sayfalar.length-1,1);
          }
         }
        

        
          this.isAcente = false;
          this.isRentACar = false;
          this.isOtel = false;
          this.isRestaurant = false;
          this.isTransfer = true;
          this.vouchergoster = true;
}
else
{
          this.selectedVoucherItems = this.voucheritems.AracVoucher;
          this.voucherInfo.Aciklamalar = this.voucheritems.AracVoucher.Aciklamalar;
          this.YedekAciklamalar = this.voucheritems.AracVoucher.Aciklamalar;
          this.voucherInfo.SirketBilgileri = this.voucheritems.AracVoucher.SirketBilgileri;
          this.voucherInfo.Sayfalar = this.voucheritems.AracVoucher.Sayfalar;
          this.isAcente = false;
          this.isRentACar = false;
          this.isOtel = false;
          this.isRestaurant = false;
          this.isTransfer = true;
          this.vouchergoster = true;
}

         
          break;
          case 3: //restaurant
if (this.IsimleriAyir==true)
{
  if (this.tmpSayfalar.length==0)
          {
           
            for (let i = 0; i <  this.voucheritems.RestaurantVoucher.Sayfalar.length; i++) {
           
              this.tmpSayfalar.push(this.voucheritems.RestaurantVoucher.Sayfalar[i]);
         }
          }
          else
          {
            this.voucheritems.RestaurantVoucher.Sayfalar=[];
            for (let i = 0; i <  this.tmpSayfalar.length; i++) {
           
              
              this.voucheritems.RestaurantVoucher.Sayfalar.push(this.tmpSayfalar[i]);
      }
           
          }
         
         
var seciliRapors=this.secilenVoucherObje.raporNo;
var seciliRapor=seciliRapors;


          this.selectedVoucherItems = this.voucheritems.RestaurantVoucher;
          this.voucherInfo.Aciklamalar = this.voucheritems.RestaurantVoucher.Aciklamalar;
          this.YedekAciklamalar = this.voucheritems.RestaurantVoucher.Aciklamalar;
          this.voucherInfo.SirketBilgileri = this.voucheritems.RestaurantVoucher.SirketBilgileri;
           this.voucherInfo.Sayfalar = this.voucheritems.RestaurantVoucher.Sayfalar;
          
for (let g = 0; g < this.voucheritems.RestaurantVoucher.Sayfalar.length; g++) {
  for (let i = 0; i < this.voucherInfo.Sayfalar.length; i++) {
          
           if (this.voucherInfo.Sayfalar[i].RaporNo!=seciliRapor)
           {
             this.voucherInfo.Sayfalar.splice(i,1);
             break;
           }
         }
          
         }
         if (this.voucherInfo.Sayfalar.length>1)
         {
          if (this.voucherInfo.Sayfalar[0].RaporNo!=seciliRapor)
          {
            this.voucherInfo.Sayfalar.splice(0,1);
          }
          else
          {
            this.voucherInfo.Sayfalar.splice(this.voucherInfo.Sayfalar.length-1,1);
          }
         }
        

        
          this.isOtel = false;
          this.isTransfer = false;
          this.isRentACar = false;
          this.isAcente = false;
          this.isRestaurant = true;
          this.vouchergoster = true;
}
else
{
  this.selectedVoucherItems = this.voucheritems.RestaurantVoucher;
          this.voucherInfo.Aciklamalar = this.voucheritems.RestaurantVoucher.Aciklamalar;
          this.YedekAciklamalar = this.voucheritems.RestaurantVoucher.Aciklamalar;
          this.voucherInfo.SirketBilgileri = this.voucheritems.RestaurantVoucher.SirketBilgileri;
          this.voucherInfo.Sayfalar = this.voucheritems.RestaurantVoucher.Sayfalar;
          this.isOtel = false;
          this.isTransfer = false;
          this.isRentACar = false;
          this.isAcente = false;
          this.isRestaurant = true;
          this.vouchergoster = true;
}

        
          break;
          case 4: //acente
          if (this.IsimleriAyir==true)
          {
            if (this.tmpSayfalar.length==0)
          {
           
            for (let i = 0; i <  this.voucheritems.AcenteVoucher.Sayfalar.length; i++) {
           
              this.tmpSayfalar.push(this.voucheritems.AcenteVoucher.Sayfalar[i]);
         }
          }
          else
          {
            this.voucheritems.AcenteVoucher.Sayfalar=[];
            for (let i = 0; i <  this.tmpSayfalar.length; i++) {
           
              
              this.voucheritems.AcenteVoucher.Sayfalar.push(this.tmpSayfalar[i]);
      }
           
          }
         
         
var seciliRapors=this.secilenVoucherObje.raporNo;
var seciliRapor=seciliRapors;


          this.selectedVoucherItems = this.voucheritems.AcenteVoucher;
          this.voucherInfo.Aciklamalar = this.voucheritems.AcenteVoucher.Aciklamalar;
          this.YedekAciklamalar = this.voucheritems.AcenteVoucher.Aciklamalar;
          this.voucherInfo.SirketBilgileri = this.voucheritems.AcenteVoucher.SirketBilgileri;
           this.voucherInfo.Sayfalar = this.voucheritems.AcenteVoucher.Sayfalar;
          
for (let g = 0; g < this.voucheritems.AcenteVoucher.Sayfalar.length; g++) {
  for (let i = 0; i < this.voucherInfo.Sayfalar.length; i++) {
          
           if (this.voucherInfo.Sayfalar[i].RaporNo!=seciliRapor)
           {
             this.voucherInfo.Sayfalar.splice(i,1);
             break;
           }
         }
          
         }
         if (this.voucherInfo.Sayfalar.length>1)
         {
          if (this.voucherInfo.Sayfalar[0].RaporNo!=seciliRapor)
          {
            this.voucherInfo.Sayfalar.splice(0,1);
          }
          else
          {
            this.voucherInfo.Sayfalar.splice(this.voucherInfo.Sayfalar.length-1,1);
          }
         }
        

        
         this.isRestaurant = false;
          this.isOtel = false;
          this.isTransfer = false;
          this.isRentACar = false;
          this.isAcente = true;
          this.vouchergoster = true;
          }
          else
          {
            this.selectedVoucherItems = this.voucheritems.AcenteVoucher;
          this.voucherInfo.Aciklamalar = this.voucheritems.AcenteVoucher.Aciklamalar;
          this.YedekAciklamalar = this.voucheritems.AcenteVoucher.Aciklamalar;
          this.voucherInfo.SirketBilgileri = this.voucheritems.AcenteVoucher.SirketBilgileri;
          this.voucherInfo.Sayfalar = this.voucheritems.AcenteVoucher.Sayfalar;
          this.isRestaurant = false;
          this.isOtel = false;
          this.isTransfer = false;
          this.isRentACar = false;
          this.isAcente = true;
          this.vouchergoster = true;
          }
        
          break;
          case 5://rentacar 
          if (this.IsimleriAyir==true)
          {
            if (this.tmpSayfalar.length==0)
          {
           
            for (let i = 0; i <  this.voucheritems.RentACarVoucher.Sayfalar.length; i++) {
           
              this.tmpSayfalar.push(this.voucheritems.RentACarVoucher.Sayfalar[i]);
         }
          }
          else
          {
            this.voucheritems.RentACarVoucher.Sayfalar=[];
            for (let i = 0; i <  this.tmpSayfalar.length; i++) {
           
              
              this.voucheritems.RentACarVoucher.Sayfalar.push(this.tmpSayfalar[i]);
      }
           
          }
         
         
var seciliRapors=this.secilenVoucherObje.raporNo;
var seciliRapor=seciliRapors;


          this.selectedVoucherItems = this.voucheritems.RentACarVoucher;
          this.voucherInfo.Aciklamalar = this.voucheritems.RentACarVoucher.Aciklamalar;
          this.YedekAciklamalar = this.voucheritems.RentACarVoucher.Aciklamalar;
          this.voucherInfo.SirketBilgileri = this.voucheritems.RentACarVoucher.SirketBilgileri;
           this.voucherInfo.Sayfalar = this.voucheritems.RentACarVoucher.Sayfalar;
          
for (let g = 0; g < this.voucheritems.RentACarVoucher.Sayfalar.length; g++) {
  for (let i = 0; i < this.voucherInfo.Sayfalar.length; i++) {
          
           if (this.voucherInfo.Sayfalar[i].RaporNo!=seciliRapor)
           {
             this.voucherInfo.Sayfalar.splice(i,1);
             break;
           }
         }
          
         }
         if (this.voucherInfo.Sayfalar.length>1)
         {
          if (this.voucherInfo.Sayfalar[0].RaporNo!=seciliRapor)
          {
            this.voucherInfo.Sayfalar.splice(0,1);
          }
          else
          {
            this.voucherInfo.Sayfalar.splice(this.voucherInfo.Sayfalar.length-1,1);
          }
         }
        

        
         this.isRestaurant = false;
          this.isOtel = false;
          this.isTransfer = false;
          this.isAcente = false;
          this.isRentACar = true;
          this.vouchergoster = true;
          }
          else
          {
            this.selectedVoucherItems = this.voucheritems.RentACarVoucher;
          this.voucherInfo.Aciklamalar = this.voucheritems.RentACarVoucher.Aciklamalar;
          this.YedekAciklamalar = this.voucheritems.RentACarVoucher.Aciklamalar;
          this.voucherInfo.SirketBilgileri = this.voucheritems.RentACarVoucher.SirketBilgileri;
          this.voucherInfo.Sayfalar = this.voucheritems.RentACarVoucher.Sayfalar;
          this.isRestaurant = false;
          this.isOtel = false;
          this.isTransfer = false;
          this.isAcente = false;
          this.isRentACar = true;
          this.vouchergoster = true;
          }
         
          break;
        default:
          break;
      }    

        this.sleep(1000).then(() => {
           this.addUpImage(this.voucherInfo.UstLogoUrl);
           this.addDownImage(this.voucherInfo.AltLogoUrl);
        });

    },
    acikalamaDuzenle() {
      switch (this.dialogEditTitle) {
        case "Not":
          this.voucherInfo.Aciklamalar.Not = this.dialogEditText;
          this.dialogDuzenle = false;
          break;
        case "Açıklama 1":
          this.voucherInfo.Aciklamalar.Aciklama1 = this.dialogEditText;
          this.dialogDuzenle = false;
          break;
        case "Açıklama 2":
          this.voucherInfo.Aciklamalar.Aciklama2 = this.dialogEditText;
          this.dialogDuzenle = false;
          break;
        default:
          break;
      }
    },
    aciklamaDialogOpen(tip) {
      switch (tip) {
        case "NOT":
          this.dialogDuzenle = true;
          this.dialogEditText = this.voucherInfo.Aciklamalar.Not;
          this.dialogEditTitle = "Not";
          break;
        case "ACIKLAMA1":
          this.dialogDuzenle = true;
          this.dialogEditText = this.voucherInfo.Aciklamalar.Aciklama1;
          this.dialogEditTitle = "Açıklama 1";
          break;
        case "ACIKLAMA2":
          this.dialogDuzenle = true;
          this.dialogEditText = this.voucherInfo.Aciklamalar.Aciklama2;
          this.dialogEditTitle = "Açıklama 2";
          break;
        default:
          break;
      }
    },
    addUpImage(imageUrl) {
      if (this.voucherInfo.UstLogoUrl != null) {

        var w=window.innerWidth;
        var newImageUst = document.createElement("img");
    
        if (w<=480){
        newImageUst.style = "width:400;height:200px;display: block;margin: 0 auto;";
        }else if(w <= 768){
        newImageUst.style = "width:700px;height:200px;display: block;margin: 0 auto;";
        }else if(w <= 1024){
        newImageUst.style = "width:700px;height:200px;display: block;margin: 0 auto;";
        }
        else{
        newImageUst.style = "width:1000px;height:200px;";
        }

        newImageUst.src = imageUrl;
        var upperLogoContainer = document.getElementById("imgUst");
        if (upperLogoContainer && this.showVoucherField("upperLogo")) {
          upperLogoContainer.innerHTML = "";
          upperLogoContainer.appendChild(newImageUst);
        }
      }
    },
    addDownImage(imageUrl) {
      if (this.voucherInfo.AltLogoUrl != null) {
        var newImageAlt = document.createElement("img");
        var w=window.innerWidth;

        newImageAlt.src = imageUrl;
        if (w<=480){
        newImageAlt.style = "width:400;height:200px;display: block;margin: 0 auto;";
        }else if(w <= 768){
        newImageAlt.style = "width:700px;height:200px;display: block;margin: 0 auto;";
        }else if(w <= 1024){
        newImageAlt.style = "width:700px;height:200px;display: block;margin: 0 auto;";
        }
        else{
        newImageAlt.style = "width:1000px;height:200px;";
        }
        var lowerLogoContainer = document.getElementById("imgAlt");
        if (lowerLogoContainer && this.showVoucherField("lowerLogo")) {
          lowerLogoContainer.innerHTML = "";
          lowerLogoContainer.appendChild(newImageAlt);
        }
      }
    },
    getImages() {
      var params = {
        FileCode: "UstLogo",
      };

      tool.http_post(this, "BinaryFileLoadBase64", params).then((response) => {
        if (response.body.Status == true) {
          if (response.body.data.DosyaUzantisi == ".jpeg") {
            this.voucherInfo.UstLogoUrl =
              "data:image/jpeg;base64, " + response.body.data.imageBase64;
            this.addUpImage(this.voucherInfo.UstLogoUrl);
          } else if (response.body.data.DosyaUzantisi == ".jpg") {
            this.voucherInfo.UstLogoUrl =
              "data:image/jpg;base64, " + response.body.data.imageBase64;
            this.addUpImage(this.voucherInfo.UstLogoUrl);
          } else if (response.body.data.DosyaUzantisi == ".png") {
            this.voucherInfo.UstLogoUrl =
              "data:image/png;base64, " + response.body.data.imageBase64;
            this.addUpImage(this.voucherInfo.UstLogoUrl);
          }
        }
      });

      var params1 = {
        FileCode: "AltLogo",
      };

      tool.http_post(this, "BinaryFileLoadBase64", params1).then((response) => {
        if (response.body.Status == true) {
          if (response.body.data.DosyaUzantisi == ".jpeg") {
            this.voucherInfo.AltLogoUrl =
              "data:image/jpeg;base64," + response.body.data.imageBase64;
            this.addDownImage(this.voucherInfo.AltLogoUrl);
          } else if (response.body.data.DosyaUzantisi == ".jpg") {
            this.voucherInfo.AltLogoUrl =
              "data:image/jpg;base64," + response.body.data.imageBase64;
            this.addDownImage(this.voucherInfo.AltLogoUrl);
          } else if (response.body.data.DosyaUzantisi == ".png") {
            this.voucherInfo.AltLogoUrl =
              "data:image/png;base64," + response.body.data.imageBase64;
            this.addDownImage(this.voucherInfo.AltLogoUrl);
          }
        }
      });
    },
    onIzlemeOlustur() {
      this.loadingStatus = true;
      setTimeout(
        function () {
          this.loadingStatus = false;
        }.bind(this),
        2500
      );
      this.sleep(3000).then(() => {
        this.voucheryazdir();
      });
    },
    sleep(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    },
    LogoKaydet(Title, FileCode) {
      this.$refs.imagefiledialog.open(Title, FileCode).then((confirm) => {
        if (confirm !== "") {
          this.voucherLoad();
        }
      });
    },
    getDateNow() {
      return helpers.getDateNow();
    },
    PansiyonTipToStr(tip) {
      if (tip == null) {
      tip = 0
    }

    var varmi = this.PansiyonWithNull.filter(function (el) {
      return el.kod == tip
    });
    
    if (varmi.length != 0) {
      return varmi[0].aciklama
    } else {
      return null
    }
    },
    SaticiTipToStr(tip) {
      return rez.SaticiTipToStr(tip);
    },
    getdatetimenow() {
      var timenow = helpers.getTimeNow();

      return String(timenow);
    },

    gunhesapla(val) {
      const oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
      const firstDate = new Date(val.donem1);
      const secondDate = new Date(val.donem2);

      const diffDays = Math.round(Math.abs((firstDate - secondDate) / oneDay));

      return diffDays;
    },

    denemeyazdir(divName) {
      this.voucheritems.Aciklamalar.Not = this.voucherInfo.Aciklamalar.Not;
      this.voucheritems.Aciklamalar.Aciklama1 =
        this.voucherInfo.Aciklamalar.Aciklama1;
      this.voucheritems.Aciklamalar.Aciklama2 =
        this.voucherInfo.Aciklamalar.Aciklama2;

      var mywindow = window.open("", "PRINT", "height=500,width=700");

      mywindow.document.write("<html><head></head><body>");
      mywindow.document.write(document.getElementById(divName).innerHTML);
      mywindow.document.write("</body></html>");

      mywindow.document.close(); // necessary for IE >= 10
      mywindow.focus(); // necessary for IE >= 10*/
      this.sleep(500).then(() => {
        //necessary for image load
        mywindow.print();
        mywindow.close();
      });

      return true;
    },
    voucheryazdir() {
      printJS({
        printable: "printJS-form",
        type: "html",
        ignoreElements: ["skip", "skip2", "skip3"],
      });
    },
    checkKalemDetay(element,voucherSaticilar){
      let controlName = element.Satici.Kod + " - " + element.Satici.Isim;
      return  voucherSaticilar.find((x) => x.name == controlName);
                
    },
    otelvoucherYazdir(val, saticiKod,saticiTip) {
     
      var _tip = saticiTip.split('-');
      var _control = 0;
      var params = {
        PNR_No: val,
        KalemDetay : this.KalemDetay,
        IsimleriAyir:this.IsimleriAyir
      };
      tool.http_post(this, "Voucher", params).then(
        (response) => {
          if (response.body.Status == true) {
            this.voucheritems = response.body.data;

            if(this.voucheritems.AcenteVoucher){
              
            this.voucheritems.AcenteVoucher.Sayfalar.forEach((element) => {
            if(this.KalemDetay){
                let checkValue = this.checkKalemDetay(element,this.itemsVoucherSaticilar)
                if(typeof checkValue == "undefined" ){
                  this.itemsVoucherSaticilar.push({
                    name: " " + element.Satici.Kod + " - " + element.Satici.Isim,
                    value: element.Satici.Kod ,
                    raporNo:element.RaporNo,
                    saticiTipi: element.Satici.SaticiTipi,
                    icon: this.getIconName(element.Satici.SaticiTipi)
                  });
                }
              }else{
                
                this.itemsVoucherSaticilar.push({
                name: + element.RaporNo + " " + element.Satici.Kod + " - " + element.Satici.Isim,
                value: element.Satici.Kod ,
                raporNo:element.RaporNo,
                saticiTipi: element.Satici.SaticiTipi,
                icon: this.getIconName(element.Satici.SaticiTipi)
              });
             
              }
            });
            }

            if(this.voucheritems.AracVoucher){
            this.voucheritems.AracVoucher.Sayfalar.forEach((element) => {
              if(this.KalemDetay){
                let checkValue = this.checkKalemDetay(element,this.itemsVoucherSaticilar)
                if(typeof checkValue == "undefined" ){
                  this.itemsVoucherSaticilar.push({
                    name: element.Satici.Kod + " - " + element.Satici.Isim,
                    value: element.Satici.Kod ,
                raporNo:element.RaporNo,
                saticiTipi: element.Satici.SaticiTipi,
                    icon: this.getIconName(element.Satici.SaticiTipi)
                  });
                }
              }else{
              this.itemsVoucherSaticilar.push({
                name: element.Satici.Kod + " - " + element.Satici.Isim,
                value: element.Satici.Kod ,
                raporNo:element.RaporNo,
                saticiTipi: element.Satici.SaticiTipi,
                icon: this.getIconName(element.Satici.SaticiTipi)
              });
              }
            });
            }

            if(this.voucheritems.OtelVoucher){
            this.voucheritems.OtelVoucher.Sayfalar.forEach((element) => {
              if(this.KalemDetay){
                let checkValue = this.checkKalemDetay(element,this.itemsVoucherSaticilar)
                if(typeof checkValue == "undefined" ){
                  
                  this.itemsVoucherSaticilar.push({
                    
                    name: element.Satici.Kod + " - " + element.Satici.Isim,
                    value: element.Satici.Kod ,
                raporNo:element.RaporNo,
                saticiTipi: element.Satici.SaticiTipi,
                    icon: this.getIconName(element.Satici.SaticiTipi)
                  });
                }
              }else{
              
               this.itemsVoucherSaticilar.push({
                name:  element.RaporNo + " - " + element.Satici.Kod + " - " + element.Satici.Isim,
                value: element.Satici.Kod,
                raporNo:element.RaporNo,
                saticiTipi: element.Satici.SaticiTipi,
                icon: this.getIconName(element.Satici.SaticiTipi)
              });
              } 
      
            });
            }

          if(this.voucheritems.RentACarVoucher){
            this.voucheritems.RentACarVoucher.Sayfalar.forEach((element) => {
            if(this.KalemDetay){
                let checkValue = this.checkKalemDetay(element,this.itemsVoucherSaticilar)
                if(typeof checkValue == "undefined" ){
                  this.itemsVoucherSaticilar.push({
                    name: element.Satici.Kod + " - " + element.Satici.Isim,
                    value: element.Satici.Kod ,
                raporNo:element.RaporNo,
                saticiTipi: element.Satici.SaticiTipi,
                    icon: this.getIconName(element.Satici.SaticiTipi)
                  });
                }
              }else{
              this.itemsVoucherSaticilar.push({
                name: element.Satici.Kod + " - " + element.Satici.Isim,
                value: element.Satici.Kod ,
                raporNo:element.RaporNo,
                saticiTipi: element.Satici.SaticiTipi,
                icon: this.getIconName(element.Satici.SaticiTipi)
              });
              }
            });
            }

            if(this.voucheritems.RestaurantVoucher){
            this.voucheritems.RestaurantVoucher.Sayfalar.forEach((element) => {
            if(this.KalemDetay){
                let checkValue = this.checkKalemDetay(element,this.itemsVoucherSaticilar)
                if(typeof checkValue == "undefined" ){
                  this.itemsVoucherSaticilar.push({
                    name: element.Satici.Kod + " - " + element.Satici.Isim,
                    value: element.Satici.Kod ,
                    raporNo:element.RaporNo,
                    saticiTipi: element.Satici.SaticiTipi,
                    icon: this.getIconName(element.Satici.SaticiTipi)
                  });
                }
              }else{
              this.itemsVoucherSaticilar.push({
                name: element.Satici.Kod + " - " + element.Satici.Isim,
                value: element.Satici.Kod ,
                raporNo:element.RaporNo,
                saticiTipi: element.Satici.SaticiTipi,
                icon: this.getIconName(element.Satici.SaticiTipi)
              });
              }
            });
            }

            this.secilenSaticiKod=null;
            console.log(this.itemsVoucherSaticilar);
            this.itemsVoucherSaticilar.forEach(element => {
              
              if(element.saticiTipi == parseInt(_tip) && _control == 0){
                if (this.IsimleriAyir==false)
                {
                    this.secilenVoucherObje.value=element.value;
                    this.secilenVoucherObje.raporNo=element.raporNo;
                    this.secilenVoucherObje.saticiTipi=element.saticiTipi;
                    this.secilenVoucherObje.name=element.name;
                    this.secilenVoucherObje.icon=element.icon;
                _control == 1;
                this.voucherLoad();
                }
              
              }
            });

          

            this.sleep(2000).then(() => {
               this.getImages();
               this.loadingStatus = false;
            });
         

            this.loadingStatus = false;
          }else {
            this.mesaj = response.body.ErrorList[0];
            this.snackbar = true;
            this.vouchergoster = false;
          }
        },
        (response) => {
          this.mesaj = "Hata Oluştu, tekrar deneyiniz";
          this.snackbar = true;
          this.vouchergoster = false;
        }
      );
    },
    aciklamaKaydet() {
      var params = {
        Aciklama: this.voucherInfo.Aciklamalar,
        SaticiTipi: this.selectedSalerType,
        RaporTipi: 1,
      };

      tool.http_post(this, "RaporAciklamaKaydet", params).then(
        (response) => {
          if (response.body.Status == true) {
            this.mesaj = "Açıklamalar kaydedildi.";
            this.snackbar = true;
            this.dialogTaslak = false;
          } else {
            this.mesaj = response.body.ErrorList[0];
            this.snackbar = true;
            this.dialogTaslak = false;
          }
        },
        (response) => {
          this.mesaj = "Hata oluştu, tekrar deneyiniz";
          this.snackbar = true;
          this.dialogTaslak = false;
        }
      );
    },
  },

  filters: {
    dateformat: function (t) {
      return helpers.dateformat(t);
    },
    moneyformat: function (m) {
      return helpers.moneyformat(m);
    },

    bakiyekontrol: function (m) {
      return helpers.bakiyekontrol(m);
    },
    timeformat: function (t) {
      return  helpers.getTime(t)
    }
  },

  moneyformat: function (m) {
    return helpers.moneyformat(m);
  },

  bakiyekontrol: function (m) {
    return helpers.bakiyekontrol(m);
  },
};
</script>
<style scoped>
img[src=""] {
  display: none;
}

/* Tablo yatay kaydırma - mobilde taşmayı önler */
.voucher-print-container {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

/* Tablo minimum genişlik - mobilde okunabilirlik */
.voucher-print-container table {
  min-width: 600px;
}

/* Mobil: butonlar tam genişlik ve daha büyük */
@media (max-width: 600px) {
  .voucher-print-container table {
    font-size: 11px;
  }

  .voucher-print-container .subheading {
    font-size: 11px !important;
  }

  .voucher-print-container .title {
    font-size: 14px !important;
  }

  /* Filtre alanındaki checkbox ve select'ler alt alta */
  .project .layout {
    flex-direction: column;
  }
}
</style>
